export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

/** adminsettingspinneddatapointtype */
export type AdminSettingsPinnedDataPointType = {
  __typename?: 'AdminSettingsPinnedDataPointType';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  dataPointType: DataPointType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AiGuidanceSuggestionDto = {
  __typename?: 'AiGuidanceSuggestionDto';
  aiSuggestionHtml: Scalars['String']['output'];
  sourceGuidanceKeys: Array<LibraryGuidanceDocumentEnum>;
};

export type AiGuidanceSuggestionInput = {
  aiQuery: Scalars['String']['input'];
  guidanceKeys: Array<LibraryGuidanceDocumentEnum>;
};

export type AnswerDataPointRequestInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dataPointRequestId?: Scalars['String']['input'];
  fileId?: Scalars['String']['input'];
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
  valueSource?: InputMaybe<Array<DataPointValueSourceInput>>;
  valueUnit?: InputMaybe<DataPointTypeValueUnitEnum>;
};

export type ApproveDataPointRequestInput = {
  dataPointRequestId: Scalars['String']['input'];
};

export type ApproveDataPointRequestsInput = {
  dataPointRequestIds?: Array<Scalars['String']['input']>;
};

export type ChartsInput = {
  chartDateRange: Scalars['JSON']['input'];
  charts: Scalars['JSON']['input'];
};

/** Comment */
export type Comment = {
  __typename?: 'Comment';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  link?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

/** Enum for comparison operators */
export enum ComparisonOperatorEnum {
  EQ = 'EQ',
  GT = 'GT',
  LT = 'LT'
}

/** A type of measurement value such as percent or number */
export enum ComparisonValueTypeEnum {
  NUMBER = 'NUMBER',
  PERCENT = 'PERCENT',
  YES_NO = 'YES_NO'
}

export type CreateCategoryInput = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subcategoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateCustomQuestionnaireInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  entityLocationId?: InputMaybe<Scalars['String']['input']>;
  questionnaireName: Scalars['String']['input'];
};

export type CreateDataPointRequestChatCommentInput = {
  dprId: Scalars['String']['input'];
  link: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type CreateEntityKpiCommentInput = {
  entityKPI: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type CreateEntityKpiInput = {
  comparisonOperator?: InputMaybe<ComparisonOperatorEnum>;
  comparisonValue?: Scalars['Float']['input'];
  comparisonValueType?: ComparisonValueTypeEnum;
  dataPointType?: Scalars['String']['input'];
  description?: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
  startingDate: Scalars['DateTime']['input'];
  startingValue?: InputMaybe<Scalars['Float']['input']>;
  targets?: Array<Scalars['String']['input']>;
  user?: Scalars['String']['input'];
};

export type CreateEntityLocationInput = {
  name?: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInsightInput = {
  dataPointTypeAId?: Scalars['String']['input'];
  dataPointTypeBId?: Scalars['String']['input'];
  refreshInterval?: DataPointTypeRefreshIntervalEnum;
  targetAction?: DataPointTypeTargetActionEnum;
  title?: Scalars['String']['input'];
  type?: Scalars['String']['input'];
};

export type CreateTaxonomyProjectInput = {
  assignees: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateUserInput = {
  assignments?: InputMaybe<UserAssignmentInput>;
  email?: Scalars['String']['input'];
  entities: Array<Scalars['String']['input']>;
  entity: Scalars['String']['input'];
  firstName?: Scalars['String']['input'];
  jobDepartment?: Scalars['String']['input'];
  jobTitle?: Scalars['String']['input'];
  language?: InputMaybe<UserLanguageEnum>;
  lastName?: Scalars['String']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
};

/** customQuestionnaire */
export type CustomQuestionnaire = {
  __typename?: 'CustomQuestionnaire';
  _id: Scalars['ID']['output'];
  category?: Maybe<DataPointCategory>;
  entity: Entity;
  initiallyCreatedForEntityLocation: EntityLocation;
  name: Scalars['String']['output'];
  questions: Array<CustomQuestionnaireQuestion>;
  status: CustomQuestionnaireStatus;
  subcategory?: Maybe<DataPointSubcategory>;
};

/** CustomQuestionnaireQuestion */
export type CustomQuestionnaireQuestion = {
  __typename?: 'CustomQuestionnaireQuestion';
  _id: Scalars['ID']['output'];
  allowUploadProof: Scalars['Boolean']['output'];
  extraOptions?: Maybe<CustomQuestionnaireQuestionExtraOptions>;
  frameworkGroup?: Maybe<Scalars['String']['output']>;
  frameworks: Array<ReportingFrameworkEnum>;
  question: Scalars['String']['output'];
  questionHelp: Scalars['String']['output'];
  refreshInterval: DataPointTypeRefreshIntervalEnum;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ValueDataTypeEnum;
};

/** Extra options for choice custom questionnaire questions type */
export type CustomQuestionnaireQuestionChoiceOptions = {
  __typename?: 'CustomQuestionnaireQuestionChoiceOptions';
  options: Array<Scalars['String']['output']>;
};

export type CustomQuestionnaireQuestionExtraOptions = CustomQuestionnaireQuestionChoiceOptions | CustomQuestionnaireQuestionNumericOptions | CustomQuestionnaireQuestionNumericSplitOptions;

/** Extra options for numeric custom questionnaire questions type */
export type CustomQuestionnaireQuestionNumericOptions = {
  __typename?: 'CustomQuestionnaireQuestionNumericOptions';
  valueUnit: DataPointTypeValueUnitEnum;
};

/** Extra options for numeric_split custom questionnaire questions type */
export type CustomQuestionnaireQuestionNumericSplitOptions = {
  __typename?: 'CustomQuestionnaireQuestionNumericSplitOptions';
  unitGroup: DataPointTypeValueUnitEnum;
};

/** Enum for custom questionnaire status */
export enum CustomQuestionnaireStatus {
  AI_FAILED = 'AI_FAILED',
  AI_PROCESSING = 'AI_PROCESSING',
  CHECK_MAPPING = 'CHECK_MAPPING',
  DONE = 'DONE',
  EDIT_QUESTIONS = 'EDIT_QUESTIONS',
  SHARE = 'SHARE',
  UPLOAD = 'UPLOAD'
}

/** datapoint */
export type DataPoint = {
  __typename?: 'DataPoint';
  _id: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataPointRequest?: Maybe<DataPointRequest>;
  dataPointType: DataPointType;
  dataPointTypeFlat: DataPointType;
  displayValue?: Maybe<Scalars['JSON']['output']>;
  displayValueUnit?: Maybe<DataPointTypeValueUnitEnum>;
  entities?: Maybe<Array<Entity>>;
  entity?: Maybe<Entity>;
  from?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<EntityLocation>;
  locations?: Maybe<Array<EntityLocation>>;
  organization?: Maybe<Organization>;
  reference?: Maybe<Array<DataPointReference>>;
  to?: Maybe<Scalars['DateTime']['output']>;
  type: DataPoint_Type;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
  valueSource?: Maybe<Array<DataPointValueSource>>;
  valueUnit?: Maybe<DataPointTypeValueUnitEnum>;
  valueUnitDivisor?: Maybe<DataPointTypeValueUnitEnum>;
};

/** DataPointCategory */
export type DataPointCategory = {
  __typename?: 'DataPointCategory';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  doubleMaterialityTopic?: Maybe<DoubleMaterialityTopic>;
  entity?: Maybe<Entity>;
  framework: ReportingFrameworkEnum;
  isConnectedToDoubleMateriality: Scalars['Boolean']['output'];
  location?: Maybe<EntityLocation>;
  name: Scalars['String']['output'];
  orderPosition: Scalars['Float']['output'];
  organization?: Maybe<Organization>;
  slug: Scalars['String']['output'];
  subcategories: Array<DataPointSubcategory>;
  subheading: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** DataPointReference */
export type DataPointReference = {
  __typename?: 'DataPointReference';
  type: DataPointReferenceEnum;
  value: Scalars['String']['output'];
};

/** Enum for DataPoint DataPointReferenceEnum */
export enum DataPointReferenceEnum {
  PROOF_TEXT = 'PROOF_TEXT'
}

/** datapointrequest */
export type DataPointRequest = {
  __typename?: 'DataPointRequest';
  _id: Scalars['ID']['output'];
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<User>;
  assignee?: Maybe<User>;
  chatComments?: Maybe<Array<Comment>>;
  childs: Array<DataPointRequest>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataPoint?: Maybe<DataPoint>;
  dataPointType: DataPointType;
  dataPointTypeFlat: DataPointTypeFlat;
  delegations?: Maybe<Array<DataPointRequestDelegation>>;
  displayStatus: DataPointRequestStatusEnum;
  displayValue?: Maybe<Scalars['JSON']['output']>;
  displayValueUnit?: Maybe<DataPointTypeValueUnitEnum>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  entity: Entity;
  file?: Maybe<RepositoryFile>;
  followers: Array<User>;
  from?: Maybe<Scalars['DateTime']['output']>;
  isHistoric?: Maybe<Scalars['Boolean']['output']>;
  isReopenRequestPending?: Maybe<Scalars['Boolean']['output']>;
  location: EntityLocation;
  originalValue?: Maybe<Scalars['JSON']['output']>;
  originalValueUnit?: Maybe<DataPointTypeValueUnitEnum>;
  override?: Maybe<EntityLocationOverride>;
  parent?: Maybe<DataPointRequest>;
  rejectReason: Scalars['String']['output'];
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedBy?: Maybe<User>;
  status: DataPointRequestStatusEnum;
  suggestionFormularResult?: Maybe<DataPointRequestSuggestionFormularDto>;
  to?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
  valueSource?: Maybe<Array<DataPointValueSource>>;
};

export type DataPointRequestAnalyticsDto = {
  __typename?: 'DataPointRequestAnalyticsDto';
  _id: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  numberOfNonOpenDataPointsRequests: Scalars['Float']['output'];
};

/** datapointrequestdelegation */
export type DataPointRequestDelegation = {
  __typename?: 'DataPointRequestDelegation';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  reminder?: Maybe<Reminder>;
  shareToken: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type DataPointRequestFilterByInput = {
  criteria: Array<Scalars['String']['input']>;
  field: DataPointRequestFilterableFieldEnum;
};

/** Enum for filterable fields of data point requests */
export enum DataPointRequestFilterableFieldEnum {
  ASSIGNEE = 'ASSIGNEE',
  CATEGORY = 'CATEGORY',
  DATA_POINT_TYPE = 'DATA_POINT_TYPE',
  LOCATION = 'LOCATION',
  PERIOD = 'PERIOD',
  SUBCATEGORY = 'SUBCATEGORY'
}

export type DataPointRequestFiltersDto = {
  __typename?: 'DataPointRequestFiltersDto';
  assignees: Array<User>;
  categories: Array<Scalars['String']['output']>;
  dataPointTypes: Array<DataPointType>;
  locations: Array<EntityLocation>;
  periods: Array<DataPointRequestPeriodFiltersDto>;
  subcategories: Array<DataPointRequestSubcategoriesFilterDto>;
};

export type DataPointRequestPaginatedDto = {
  __typename?: 'DataPointRequestPaginatedDto';
  items: Array<DataPointRequest>;
  totalCount: Scalars['Float']['output'];
};

export type DataPointRequestPeriodFiltersDto = {
  __typename?: 'DataPointRequestPeriodFiltersDto';
  from?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type DataPointRequestReportingProgressDto = {
  __typename?: 'DataPointRequestReportingProgressDto';
  accepted: Scalars['Float']['output'];
  closed: Scalars['Float']['output'];
  draft: Scalars['Float']['output'];
  entity: Entity;
  location: EntityLocation;
  open: Scalars['Float']['output'];
  overDue: Scalars['Float']['output'];
  pending: Scalars['Float']['output'];
  rejected: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

/** Enum for DataPointRequest status */
export enum DataPointRequestStatusEnum {
  ACCEPTED = 'ACCEPTED',
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  OPEN = 'OPEN',
  OVERDUE = 'OVERDUE',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type DataPointRequestSubcategoriesFilterDto = {
  __typename?: 'DataPointRequestSubcategoriesFilterDto';
  category: Scalars['String']['output'];
  subcategory: Scalars['String']['output'];
};

export type DataPointRequestSuggestionFormularDto = {
  __typename?: 'DataPointRequestSuggestionFormularDto';
  dependencies: Array<DataPointType>;
  result: Scalars['Float']['output'];
};

/** DataPointSubcategory */
export type DataPointSubcategory = {
  __typename?: 'DataPointSubcategory';
  _id: Scalars['ID']['output'];
  doubleMaterialityMandatoryReason?: Maybe<DoubleMaterialityMandatoryReason>;
  isConnectedToDoubleMateriality: Scalars['Boolean']['output'];
  isDisabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orderPosition: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
  subheading: Scalars['String']['output'];
  topic: Scalars['String']['output'];
};

/** datapointtype */
export type DataPointType = {
  __typename?: 'DataPointType';
  _id: Scalars['ID']['output'];
  activeReportingFramework: DataPointTypeReportingFramework;
  allowUploadProof: Scalars['Boolean']['output'];
  assignee: User;
  calculatedDataPointTypes: Array<DataPointType>;
  codioDataPointType?: Maybe<DataPointType>;
  codioDataPointTypeSuggestions: Array<DataPointType>;
  createdAt: Scalars['DateTime']['output'];
  datapoints: Array<DataPoint>;
  defaultChartType: Scalars['String']['output'];
  emissionCategory?: Maybe<Scalars['String']['output']>;
  emissionFactors: Array<DataPointTypeEmissionFactor>;
  emissionSubcategory?: Maybe<Scalars['String']['output']>;
  emissionType?: Maybe<DataPointTypeEmissionTypeEnum>;
  entity?: Maybe<Entity>;
  formular: Scalars['String']['output'];
  formularDependencies: Array<DataPointType>;
  friendlyName: Scalars['String']['output'];
  insightDenominator: Scalars['Boolean']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  language: UserLanguageEnum;
  location?: Maybe<EntityLocation>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  organization?: Maybe<Organization>;
  question: Scalars['String']['output'];
  questionHelp: Scalars['String']['output'];
  refreshInterval: DataPointTypeRefreshIntervalEnum;
  reportingFrameworks: Array<DataPointTypeReportingFramework>;
  suggestedTargets: Array<Target>;
  suggestionFormular: Scalars['String']['output'];
  summarizingMethod?: Maybe<SummarizingMethodEnum>;
  targetAction?: Maybe<DataPointTypeTargetActionEnum>;
  type: DataPointType_Type;
  updatedAt: Scalars['DateTime']['output'];
  valueDataType: ValueDataTypeEnum;
  valueDataTypeOptions?: Maybe<Scalars['JSON']['output']>;
  valueUnit?: Maybe<DataPointTypeValueUnitEnum>;
  valueUnitDivisor?: Maybe<DataPointTypeValueUnitEnum>;
};

/** DataPointTypeEmissionFactor */
export type DataPointTypeEmissionFactor = {
  __typename?: 'DataPointTypeEmissionFactor';
  _id: Scalars['ID']['output'];
  factor: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export type DataPointTypeEmissionFactorInput = {
  _id?: Scalars['String']['input'];
  factor: Scalars['Float']['input'];
  year: Scalars['Float']['input'];
};

/** Enum for DataPointTypeEmissionFactors type */
export enum DataPointTypeEmissionTypeEnum {
  OUTSIDE = 'OUTSIDE',
  SCOPE_1 = 'SCOPE_1',
  SCOPE_2 = 'SCOPE_2',
  SCOPE_2_LOCATION_BASED = 'SCOPE_2_LOCATION_BASED',
  SCOPE_2_MARKET_BASED = 'SCOPE_2_MARKET_BASED',
  SCOPE_3 = 'SCOPE_3'
}

/** DataPointTypeFlat */
export type DataPointTypeFlat = {
  __typename?: 'DataPointTypeFlat';
  category: Scalars['String']['output'];
  conditionDatapoint: Scalars['String']['output'];
  conditionValue: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  subcategory: Scalars['String']['output'];
};

export type DataPointTypeOverrideInput = {
  customConversionFactor?: InputMaybe<Scalars['Float']['input']>;
  dataPointTypeId?: Scalars['String']['input'];
  emissionFactorValue?: InputMaybe<Scalars['Float']['input']>;
  emissionFactorYear?: InputMaybe<Scalars['Float']['input']>;
  guidanceCommentText?: InputMaybe<Scalars['String']['input']>;
  isCustomUnitValueGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  isDelegated?: InputMaybe<Scalars['Boolean']['input']>;
  isEmissionFactorGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  isSplit?: InputMaybe<Scalars['Boolean']['input']>;
  refreshInterval?: InputMaybe<DataPointTypeRefreshIntervalEnum>;
  tags?: InputMaybe<Array<TagInput>>;
  valueUnit?: InputMaybe<DataPointTypeValueUnitEnum>;
};

/** Enum for DataPointType refreshIntervals */
export enum DataPointTypeRefreshIntervalEnum {
  DAILY = 'DAILY',
  HALF_YEARLY = 'HALF_YEARLY',
  MONTHLY = 'MONTHLY',
  NONE = 'NONE',
  ONCE = 'ONCE',
  QUARTERLY = 'QUARTERLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

/** DataPointTypeReportingFramework */
export type DataPointTypeReportingFramework = {
  __typename?: 'DataPointTypeReportingFramework';
  _id: Scalars['ID']['output'];
  boundary: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  conditionDatapoint: Scalars['String']['output'];
  conditionValue: Scalars['String']['output'];
  framework: ReportingFrameworkEnum;
  groups: Array<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  phasein: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
};

export type DataPointTypeSubcategoryDto = {
  __typename?: 'DataPointTypeSubcategoryDto';
  _id: Scalars['JSON']['output'];
  assignees?: Maybe<Array<User>>;
  category: Scalars['String']['output'];
  framework: ReportingFrameworkEnum;
  progress?: Maybe<Scalars['Float']['output']>;
  subcategory: Scalars['String']['output'];
};

/** Enum for DataPointType targetAction */
export enum DataPointTypeTargetActionEnum {
  DECREASE = 'DECREASE',
  INCREASE = 'INCREASE'
}

/** Enum for DataPointType valueUnit */
export enum DataPointTypeValueUnitEnum {
  CHF = 'CHF',
  CUBIC_METER = 'CUBIC_METER',
  DAYS = 'DAYS',
  EUR = 'EUR',
  GBP = 'GBP',
  HOURS = 'HOURS',
  KGCO2EQ = 'KGCO2EQ',
  KILOGRAM = 'KILOGRAM',
  KILOMETER = 'KILOMETER',
  KILOWATT = 'KILOWATT',
  KILOWATTHOURS = 'KILOWATTHOURS',
  LITER = 'LITER',
  MEGAWATTHOURS = 'MEGAWATTHOURS',
  MEGA_LITER = 'MEGA_LITER',
  METER = 'METER',
  METRIC_TONS = 'METRIC_TONS',
  NUMBER = 'NUMBER',
  PERCENT = 'PERCENT',
  PRODUCTION_UNIT = 'PRODUCTION_UNIT',
  SQUARE_METER = 'SQUARE_METER',
  TCO2EQ = 'TCO2EQ',
  TONS = 'TONS',
  USD = 'USD'
}

/** Enum for DataPointType.Type */
export enum DataPointType_Type {
  CALCULATION = 'CALCULATION',
  INSIGHT = 'INSIGHT',
  REGULAR = 'REGULAR'
}

/** DataPointValueSource */
export type DataPointValueSource = {
  __typename?: 'DataPointValueSource';
  delegationEmail?: Maybe<Scalars['String']['output']>;
  emissionFactor?: Maybe<Scalars['Float']['output']>;
  emissionFactorCountry?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalValue?: Maybe<Scalars['JSON']['output']>;
  originalValueUnit?: Maybe<DataPointTypeValueUnitEnum>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type DataPointValueSourceInput = {
  emissionFactor?: InputMaybe<Scalars['Float']['input']>;
  emissionFactorCountry?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  unit?: InputMaybe<DataPointTypeValueUnitEnum>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** Enum for DataPoint.Type */
export enum DataPoint_Type {
  CALCULATION = 'CALCULATION',
  DATAPOINT = 'DATAPOINT',
  INSIGHT = 'INSIGHT',
  SUMMARY = 'SUMMARY'
}

export type DatapointsCreatedAnalyticsDto = {
  __typename?: 'DatapointsCreatedAnalyticsDto';
  _id: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  numberOfCreatedDatapoints: Scalars['Float']['output'];
};

export type DelegateDataPointRequestsInput = {
  dataPointRequestIds?: Array<Scalars['String']['input']>;
};

export type DelegateTaxonomyAssessmentBusinessActivityInput = {
  objective?: InputMaybe<TaxonomyAssessmentBusinessActivityObjectiveEnum>;
  type: TaxonomyBusinessActivityDelegationTypeEnum;
};

export type DeleteDataPointRequestsInput = {
  dataPointRequestIds?: Array<Scalars['String']['input']>;
};

export type DeleteEntityKpiInput = {
  _id?: Scalars['String']['input'];
};

export type DeleteEntityLocationInput = {
  _id?: Scalars['String']['input'];
};

export type DeleteInsightInput = {
  _id?: Scalars['String']['input'];
};

export type DisableUserInput = {
  _id?: Scalars['String']['input'];
};

/** DoesNotHarm */
export type DoesNotHarm = {
  __typename?: 'DoesNotHarm';
  _id: Scalars['ID']['output'];
  adaptation?: Maybe<Scalars['Boolean']['output']>;
  adaptationComment?: Maybe<Scalars['String']['output']>;
  adaptationDelegation?: Maybe<TaxonomyBusinessActivityDelegation>;
  adaptationDocument?: Maybe<TaxonomyDocument>;
  biodiversity?: Maybe<Scalars['Boolean']['output']>;
  biodiversityComment?: Maybe<Scalars['String']['output']>;
  biodiversityDelegation?: Maybe<TaxonomyBusinessActivityDelegation>;
  biodiversityDocument?: Maybe<TaxonomyDocument>;
  circular?: Maybe<Scalars['Boolean']['output']>;
  circularComment?: Maybe<Scalars['String']['output']>;
  circularDelegation?: Maybe<TaxonomyBusinessActivityDelegation>;
  circularDocument?: Maybe<TaxonomyDocument>;
  mitigation?: Maybe<Scalars['Boolean']['output']>;
  mitigationComment?: Maybe<Scalars['String']['output']>;
  mitigationDelegation?: Maybe<TaxonomyBusinessActivityDelegation>;
  mitigationDocument?: Maybe<TaxonomyDocument>;
  pollution?: Maybe<Scalars['Boolean']['output']>;
  pollutionComment?: Maybe<Scalars['String']['output']>;
  pollutionDelegation?: Maybe<TaxonomyBusinessActivityDelegation>;
  pollutionDocument?: Maybe<TaxonomyDocument>;
  water?: Maybe<Scalars['Boolean']['output']>;
  waterComment?: Maybe<Scalars['String']['output']>;
  waterDelegation?: Maybe<TaxonomyBusinessActivityDelegation>;
  waterDocument?: Maybe<TaxonomyDocument>;
};

/** DoubleMateriality */
export type DoubleMateriality = {
  __typename?: 'DoubleMateriality';
  _id: Scalars['ID']['output'];
  iroImpacts: Array<DoubleMaterialityIroImpact>;
  iroRiskAndOpportunities: Array<DoubleMaterialityIroRiskAndOpportunity>;
  organization: Organization;
  potentialMagnitude: DoubleMaterialityPotentialMagnitude;
  stakeholderOptions: Array<Scalars['String']['output']>;
  stakeholders: Array<DoubleMaterialityStakeholder>;
  surveys: Array<DoubleMaterialitySurvey>;
  timeHorizons: DoubleMaterialityTimeHorizons;
  topics: Array<DoubleMaterialityTopicSelection>;
  topicsOptions: Scalars['JSON']['output'];
};

export type DoubleMaterialityDownloadDocumentDto = {
  __typename?: 'DoubleMaterialityDownloadDocumentDto';
  file: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Enum for double materiality downloadable document */
export enum DoubleMaterialityDownloadDocumentEnum {
  DMA_DEFINITIONS = 'DMA_DEFINITIONS',
  DMA_PROCESS_FOR_USERS = 'DMA_PROCESS_FOR_USERS',
  GENERAL_OVERVIEW = 'GENERAL_OVERVIEW',
  IMPACTS_SCORING = 'IMPACTS_SCORING',
  LONG_LIST = 'LONG_LIST',
  RISKS_AND_OPPORTUNITIES_SCORING = 'RISKS_AND_OPPORTUNITIES_SCORING',
  STAKEHOLDER_ENGAGEMENT = 'STAKEHOLDER_ENGAGEMENT'
}

export type DoubleMaterialityExternallyDto = {
  __typename?: 'DoubleMaterialityExternallyDto';
  doubleMaterialityId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  surveyId: Scalars['String']['output'];
  userLanguage: UserLanguageEnum;
};

/** DoubleMaterialityIroImpact */
export type DoubleMaterialityIroImpact = {
  __typename?: 'DoubleMaterialityIroImpact';
  _id: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  document?: Maybe<RepositoryFile>;
  impact: Scalars['String']['output'];
  irremediability?: Maybe<Scalars['Float']['output']>;
  likelihood?: Maybe<Scalars['Float']['output']>;
  scale?: Maybe<Scalars['Float']['output']>;
  scope?: Maybe<Scalars['Float']['output']>;
  scoreComment: Scalars['String']['output'];
  scoreDocument?: Maybe<RepositoryFile>;
  topicId: Scalars['String']['output'];
  type?: Maybe<DoubleMaterialityIroImpactType>;
};

/** Enum for Double Materiality IRO Impact type */
export enum DoubleMaterialityIroImpactType {
  ACTUAL_NEGATIVE = 'ACTUAL_NEGATIVE',
  ACTUAL_POSITIVE = 'ACTUAL_POSITIVE',
  POTENTIAL_NEGATIVE = 'POTENTIAL_NEGATIVE',
  POTENTIAL_POSITIVE = 'POTENTIAL_POSITIVE'
}

/** DoubleMaterialityIroRiskAndOpportunity */
export type DoubleMaterialityIroRiskAndOpportunity = {
  __typename?: 'DoubleMaterialityIroRiskAndOpportunity';
  _id: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  document?: Maybe<RepositoryFile>;
  likelihood?: Maybe<Scalars['Float']['output']>;
  potentialMagnitude?: Maybe<Scalars['Float']['output']>;
  riskAndOpportunity: Scalars['String']['output'];
  scoreComment: Scalars['String']['output'];
  scoreDocument?: Maybe<RepositoryFile>;
  topicId: Scalars['String']['output'];
  type?: Maybe<DoubleMaterialityIroRiskAndOpportunityType>;
};

/** Enum for Double Materiality IRO Risk and Opportunity type */
export enum DoubleMaterialityIroRiskAndOpportunityType {
  OPPORTUNITY = 'OPPORTUNITY',
  RISK = 'RISK'
}

/** Enum for DoubleMaterialityMandatoryReason type */
export enum DoubleMaterialityMandatoryReason {
  DueToFinancialMateriality = 'DueToFinancialMateriality',
  DueToSustainabilityMatter = 'DueToSustainabilityMatter',
  Regardless = 'Regardless',
  TopicIsMaterial = 'TopicIsMaterial'
}

/** DoubleMaterialityPotentialMagnitude */
export type DoubleMaterialityPotentialMagnitude = {
  __typename?: 'DoubleMaterialityPotentialMagnitude';
  _id: Scalars['ID']['output'];
  almostNoFinancialEffectComment: Scalars['String']['output'];
  almostNoFinancialEffectDocument?: Maybe<RepositoryFile>;
  almostNoFinancialEffectValue?: Maybe<Scalars['Float']['output']>;
  criticallyRelevantFinancialEffectComment: Scalars['String']['output'];
  criticallyRelevantFinancialEffectDocument?: Maybe<RepositoryFile>;
  criticallyRelevantFinancialEffectValue?: Maybe<Scalars['Float']['output']>;
  lowFinancialEffectComment: Scalars['String']['output'];
  lowFinancialEffectDocument?: Maybe<RepositoryFile>;
  lowFinancialEffectValue?: Maybe<Scalars['Float']['output']>;
  minorFinancialEffectComment: Scalars['String']['output'];
  minorFinancialEffectDocument?: Maybe<RepositoryFile>;
  minorFinancialEffectValue?: Maybe<Scalars['Float']['output']>;
  significantFinancialEffectComment: Scalars['String']['output'];
  significantFinancialEffectDocument?: Maybe<RepositoryFile>;
  significantFinancialEffectValue?: Maybe<Scalars['Float']['output']>;
};

/** DoubleMaterialityStakeholder */
export type DoubleMaterialityStakeholder = {
  __typename?: 'DoubleMaterialityStakeholder';
  _id: Scalars['String']['output'];
  description: Scalars['String']['output'];
  engage?: Maybe<Scalars['String']['output']>;
  reasons: Scalars['String']['output'];
  stakeholder?: Maybe<Scalars['String']['output']>;
};

/** DoubleMaterialitySurvey */
export type DoubleMaterialitySurvey = {
  __typename?: 'DoubleMaterialitySurvey';
  _id: Scalars['String']['output'];
  answers: Scalars['JSON']['output'];
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  stakeholderId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DoubleMaterialitySurveyStatus>;
  type?: Maybe<DoubleMaterialitySurveyType>;
};

/** Enum for Double Materiality Survey Status */
export enum DoubleMaterialitySurveyStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_SENT = 'NOT_SENT'
}

/** Enum for Double Materiality Survey type */
export enum DoubleMaterialitySurveyType {
  IMPACT = 'IMPACT',
  RISKS_OPPORTUNITIES = 'RISKS_OPPORTUNITIES'
}

/** DoubleMaterialityTimeHorizons */
export type DoubleMaterialityTimeHorizons = {
  __typename?: 'DoubleMaterialityTimeHorizons';
  _id: Scalars['ID']['output'];
  longTermComment: Scalars['String']['output'];
  longTermDocument?: Maybe<RepositoryFile>;
  longTermValue?: Maybe<Scalars['Float']['output']>;
  mediumTermComment: Scalars['String']['output'];
  mediumTermDocument?: Maybe<RepositoryFile>;
  mediumTermValue?: Maybe<Scalars['Float']['output']>;
  shortTermComment: Scalars['String']['output'];
  shortTermDocument?: Maybe<RepositoryFile>;
  shortTermValue?: Maybe<Scalars['Float']['output']>;
};

/** DoubleMaterialityTopic */
export type DoubleMaterialityTopic = {
  __typename?: 'DoubleMaterialityTopic';
  _id: Scalars['ID']['output'];
  esrs: Scalars['String']['output'];
  subTopics: Array<DoubleMaterialityTopicSubTopic>;
  topic: Scalars['String']['output'];
};

/** DoubleMaterialityTopicSelection */
export type DoubleMaterialityTopicSelection = {
  __typename?: 'DoubleMaterialityTopicSelection';
  _id: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  document?: Maybe<RepositoryFile>;
  esrs: Scalars['String']['output'];
  subSubTopic: Scalars['String']['output'];
  subTopic: Scalars['String']['output'];
  timeHorizon: Scalars['String']['output'];
  topic: Scalars['String']['output'];
  valueChain: Array<Scalars['String']['output']>;
};

/** DoubleMaterialityTopicSubTopic */
export type DoubleMaterialityTopicSubTopic = {
  __typename?: 'DoubleMaterialityTopicSubTopic';
  subSubTopics: Array<Scalars['String']['output']>;
  subTopic: Scalars['String']['output'];
};

/** EmissionFactorSuggestion */
export type EmissionFactorSuggestion = {
  __typename?: 'EmissionFactorSuggestion';
  _id: Scalars['ID']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emissionCategory?: Maybe<Scalars['String']['output']>;
  emissionFactors: Array<DataPointTypeEmissionFactor>;
  emissionSubcategory?: Maybe<Scalars['String']['output']>;
  emissionType?: Maybe<DataPointTypeEmissionTypeEnum>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  valueUnit: DataPointTypeValueUnitEnum;
};

export type EmissionsDto = {
  __typename?: 'EmissionsDto';
  _id: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  scope: DataPointTypeEmissionTypeEnum;
  value: Scalars['Float']['output'];
};

/** entity */
export type Entity = {
  __typename?: 'Entity';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  entitySettings: EntitySettings;
  isDeactivated: Scalars['Boolean']['output'];
  kpis: Array<EntityKpi>;
  locations: Array<EntityLocation>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  reportingFrameworks: Array<ReportingFrameworkEnum>;
  updatedAt: Scalars['DateTime']['output'];
};

/** EntityAssignment */
export type EntityAssignment = {
  __typename?: 'EntityAssignment';
  _id: Scalars['ID']['output'];
  categories: Array<EntityCategoryAssignment>;
};

export type EntityAssignmentDto = {
  __typename?: 'EntityAssignmentDto';
  assignee: User;
  category: Scalars['String']['output'];
  dataPointTypes?: Maybe<DataPointType>;
  location: EntityLocation;
  statuses?: Maybe<Array<DataPointRequestStatusEnum>>;
  subcategory: Scalars['String']['output'];
};

export type EntityAssignmentTotalsDto = {
  __typename?: 'EntityAssignmentTotalsDto';
  assigmentsTotal: Scalars['Float']['output'];
  assignedTopicsTotal: Scalars['Float']['output'];
};

/** EntityCategoryAssignment */
export type EntityCategoryAssignment = {
  __typename?: 'EntityCategoryAssignment';
  _id: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  subcategories: Array<EntitySubcategoryAssignment>;
};

export type EntityInput = {
  _id?: Scalars['String']['input'];
  name?: Scalars['String']['input'];
};

/** EntityKPI */
export type EntityKpi = {
  __typename?: 'EntityKPI';
  _id: Scalars['ID']['output'];
  comments: Array<Comment>;
  comparisonOperator: ComparisonOperatorEnum;
  comparisonValue: Scalars['Float']['output'];
  comparisonValueType: ComparisonValueTypeEnum;
  completionPercent: Scalars['Float']['output'];
  dataPointType: DataPointType;
  description: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  entity: Entity;
  startingDate: Scalars['DateTime']['output'];
  startingValue?: Maybe<Scalars['Float']['output']>;
  status: EntityKpiStatusEnum;
  targets: Array<Target>;
  user: User;
};

/** Enum for entity kpi status */
export enum EntityKpiStatusEnum {
  ACHIEVED = 'ACHIEVED',
  MISSED = 'MISSED',
  ONGOING = 'ONGOING',
  OPEN = 'OPEN'
}

/** EntityLocation */
export type EntityLocation = {
  __typename?: 'EntityLocation';
  _id: Scalars['ID']['output'];
  areCategoriesAppliedOnAllProjects?: Maybe<Scalars['Boolean']['output']>;
  areCustomCategoriesAppliedOnAllProjects?: Maybe<Scalars['Boolean']['output']>;
  assignments: EntityAssignment;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entity: Entity;
  hasOwnDataPointRequests: Scalars['Boolean']['output'];
  hasParentInfo: Scalars['Boolean']['output'];
  isHeadquarters: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  overrides: Array<EntityLocationOverride>;
  parent?: Maybe<EntityLocation>;
  suspensions: EntityLocationSuspensions;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EntityLocationAnalyticsDto = {
  __typename?: 'EntityLocationAnalyticsDto';
  _id: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  numberOfCreatedProjects: Scalars['Float']['output'];
};

export type EntityLocationInput = {
  _id?: Scalars['String']['input'];
};

/** EntityLocationOverride */
export type EntityLocationOverride = {
  __typename?: 'EntityLocationOverride';
  _id: Scalars['ID']['output'];
  customConversionFactor?: Maybe<Scalars['Float']['output']>;
  datapointtype: DataPointType;
  emissionFactors: Array<DataPointTypeEmissionFactor>;
  guidanceComments: Array<Comment>;
  isSplit: Scalars['Boolean']['output'];
  refreshInterval?: Maybe<DataPointTypeRefreshIntervalEnum>;
  tags?: Maybe<Array<Tag>>;
  valueUnit?: Maybe<DataPointTypeValueUnitEnum>;
};

export type EntityLocationSubcategorySummaryDto = {
  __typename?: 'EntityLocationSubcategorySummaryDto';
  assignees: Array<User>;
  category: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  overrides: Array<EntityLocationOverride>;
  progress: Scalars['Float']['output'];
  subcategory: Scalars['String']['output'];
};

export type EntityLocationSummaryDto = {
  __typename?: 'EntityLocationSummaryDto';
  _id: Scalars['String']['output'];
  assignees: Array<User>;
  assignments: EntityAssignment;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  depth: Scalars['Float']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  hasChildren: Scalars['Boolean']['output'];
  hasParentInfo: Scalars['Boolean']['output'];
  isHeadquarters: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  overrides: Array<EntityLocationOverride>;
  parent?: Maybe<Scalars['String']['output']>;
  progress: Scalars['Float']['output'];
  suspensions: EntityLocationSuspensions;
};

/** EntityLocationSuspensions */
export type EntityLocationSuspensions = {
  __typename?: 'EntityLocationSuspensions';
  datapointtypes: Array<DataPointType>;
  subcategories: Array<Scalars['String']['output']>;
};

/** Entity Notification Settings */
export type EntityNotificationSettings = {
  __typename?: 'EntityNotificationSettings';
  _id: Scalars['ID']['output'];
  approvedDatapoints: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  goals: Scalars['Boolean']['output'];
  newProject: Scalars['Boolean']['output'];
  openApprovals: Scalars['Boolean']['output'];
  openDatapoints: Scalars['Boolean']['output'];
  recommendationsVisibility: Scalars['Boolean']['output'];
  rejectedDatapoints: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  voluntaryVisibility: Scalars['Boolean']['output'];
};

/** Entity Reporting Period Version 2 */
export type EntityReportingPeriod = {
  __typename?: 'EntityReportingPeriod';
  _id: Scalars['ID']['output'];
  deadline: Scalars['DateTime']['output'];
  from: Scalars['DateTime']['output'];
  status: EntityReportingPeriodStatusEnum;
  to: Scalars['DateTime']['output'];
};

/** Enum for entity reporting period status */
export enum EntityReportingPeriodStatusEnum {
  COMPLETED = 'COMPLETED',
  ONGOING = 'ONGOING'
}

/** Entity Settings */
export type EntitySettings = {
  __typename?: 'EntitySettings';
  _id: Scalars['ID']['output'];
  activeReportingPeriod: EntityReportingPeriod;
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dashboardPinnedDataPointTypes: Array<AdminSettingsPinnedDataPointType>;
  industry: Scalars['String']['output'];
  locationOfHeadquarter: Scalars['String']['output'];
  nameOfHeadquarter: Scalars['String']['output'];
  notificationSettings: EntityNotificationSettings;
  numberOfEmployees: Scalars['String']['output'];
  overviewPinnedDataPointTypes: Array<AdminSettingsPinnedDataPointType>;
  picture?: Maybe<RepositoryFile>;
  reportingPeriods: Array<EntityReportingPeriod>;
  requiredProofCategories: Array<Scalars['String']['output']>;
  sharePassword: Scalars['String']['output'];
  shareToken: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EntitySettingsReportingPeriodInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  deadline: Scalars['DateTime']['input'];
  from: Scalars['DateTime']['input'];
  isCompleted: Scalars['Boolean']['input'];
  to: Scalars['DateTime']['input'];
  toBeDeleted: Scalars['Boolean']['input'];
};

/** EntitySubcategoryAssignment */
export type EntitySubcategoryAssignment = {
  __typename?: 'EntitySubcategoryAssignment';
  _id: Scalars['ID']['output'];
  datapointtypes: Array<DataPointType>;
  subcategory: Scalars['String']['output'];
};

export type GetLoginWorkspacesDto = {
  __typename?: 'GetLoginWorkspacesDto';
  isNewUser: Scalars['Boolean']['output'];
  workspaces: Array<Scalars['String']['output']>;
};

/** Enum for User#GetStartedStatusEnum */
export enum GetStartedStatusEnum {
  GOALS = 'GOALS',
  LOCATIONS = 'LOCATIONS',
  MATERIALITY = 'MATERIALITY',
  PROFILE = 'PROFILE',
  TEAM = 'TEAM',
  TOPICS = 'TOPICS'
}

/** Goal */
export type Goal = {
  __typename?: 'Goal';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  entity: Entity;
  name: Scalars['String']['output'];
  number: Scalars['Float']['output'];
  reportingFramework: ReportingFrameworkEnum;
  targets: Array<Target>;
  updatedAt: Scalars['DateTime']['output'];
};

/** grouped datapoint */
export type GroupedDataPoint = {
  __typename?: 'GroupedDataPoint';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataPointRequest?: Maybe<DataPointRequest>;
  dataPointType: DataPointType;
  dataPointTypeFlat: DataPointType;
  displayValue?: Maybe<Scalars['JSON']['output']>;
  displayValueUnit?: Maybe<DataPointTypeValueUnitEnum>;
  entities?: Maybe<Array<Entity>>;
  entity?: Maybe<Entity>;
  from?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<EntityLocation>;
  locations?: Maybe<Array<EntityLocation>>;
  organization?: Maybe<Organization>;
  reference?: Maybe<Array<DataPointReference>>;
  to?: Maybe<Scalars['DateTime']['output']>;
  type: DataPoint_Type;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
  valueSource?: Maybe<Array<DataPointValueSource>>;
  valueUnit?: Maybe<DataPointTypeValueUnitEnum>;
  valueUnitDivisor?: Maybe<DataPointTypeValueUnitEnum>;
};

/** Enum for help type */
export enum HelpTypeEnum {
  EXPERT = 'EXPERT',
  TECHNICAL = 'TECHNICAL'
}

/** Enum for library guidance downloadable document */
export enum LibraryGuidanceDocumentEnum {
  CARBON_ACCOUNTING_MODULE = 'CARBON_ACCOUNTING_MODULE',
  DOUBLE_MATERIALITY_ANALYSIS = 'DOUBLE_MATERIALITY_ANALYSIS',
  ESRS_CSRD_DEFINITIONS = 'ESRS_CSRD_DEFINITIONS',
  ESRS_CSRD_MODULE = 'ESRS_CSRD_MODULE',
  EU_TAXONOMY = 'EU_TAXONOMY',
  HOW_TO_CUSTOMIZE_THE_PLATFORM = 'HOW_TO_CUSTOMIZE_THE_PLATFORM',
  PRODUCT_AND_CONTENT_UPDATES = 'PRODUCT_AND_CONTENT_UPDATES'
}

export type Mutation = {
  __typename?: 'Mutation';
  addDataPointTypeOverride: EntityLocation;
  addDataPointTypeOverrideByEntity: Array<EntityLocation>;
  addEntityToUsers: Array<User>;
  addFileMetadata: RepositoryFile;
  addRatingToRecommendation: Recommendation;
  addUserToRecommendation: Recommendation;
  answerDataPointRequest: DataPointRequest;
  answerDelegatedDataPointRequest: DataPointRequest;
  approveDataPointRequest: DataPointRequest;
  approveDataPointRequests: Array<DataPointRequest>;
  assignUserToDoubleMateriality: Array<User>;
  completeCustomQuestionnaire: CustomQuestionnaire;
  createCustomQuestionnaire: CustomQuestionnaire;
  createDataPointCustomCategory: DataPointCategory;
  createDataPointCustomSubcategories: DataPointCategory;
  createDataPointRequestChatComment: DataPointRequest;
  createEntity: Entity;
  createEntityKPI: Array<EntityKpi>;
  createEntityKPIComment: Comment;
  createEntityLocation: Array<EntityLocation>;
  createInsight: DataPointType;
  createTaxonomyAssessment: TaxonomyAssessment;
  createTaxonomyProject: TaxonomyProject;
  createUser: User;
  delegateBusinessActivity: TaxonomyBusinessActivity;
  delegateDataPointRequests: Array<DataPointRequest>;
  delegateTaxonomyAssessments: Array<TaxonomyAssessment>;
  deleteCustomQuestionnaireQuestion: Scalars['Float']['output'];
  deleteDataPointCustomCategories: Array<Scalars['String']['output']>;
  deleteDataPointCustomSubcategories: DataPointCategory;
  deleteDataPointRequest: Scalars['Float']['output'];
  deleteDataPointRequestDelegation: DataPointRequest;
  deleteDataPointRequests: Scalars['Float']['output'];
  deleteDataPointType: Scalars['Float']['output'];
  deleteEntity: Entity;
  deleteEntityKPI: EntityKpi;
  deleteEntityLocation: Scalars['Float']['output'];
  deleteInsight: Scalars['Float']['output'];
  deleteRepositoryFile: RepositoryFile;
  deleteTaxonomyDocument: Scalars['Float']['output'];
  deleteTaxonomyProject: Scalars['Float']['output'];
  disableUser: User;
  followDataPointRequest: DataPointRequest;
  generateDataPointRequestsForPastDates: Array<DataPointRequest>;
  generateFileDownloadToken: Scalars['String']['output'];
  generateFileUploadToken: RepositoryFile;
  generateFileUploadTokenExternal: RepositoryFile;
  generateQuestionnaireFileUploadToken: RepositoryFile;
  reassignSuperadmin: User;
  rejectDataPointRequest: DataPointRequest;
  rejectDataPointRequests: Array<DataPointRequest>;
  remindUsersAdmin: Scalars['Float']['output'];
  requestCO2Report: User;
  requestCustomReport: User;
  requestEsgReport: User;
  requestHelp: Scalars['Boolean']['output'];
  requestHelpForExternalTaxonomy: Scalars['Boolean']['output'];
  requestReopenDataPointRequest: DataPointRequest;
  requestSupport: User;
  resetDataPointRequest: DataPointRequest;
  sendSurveys: Scalars['Float']['output'];
  setQuestionnaireName: CustomQuestionnaire;
  signup: User;
  startFileProcessing: CustomQuestionnaireStatus;
  suspendDataPointTypeByEntity: Array<EntityLocation>;
  suspendDataPointTypeByLocation: EntityLocation;
  toggleCategories: EntityLocation;
  unapproveDataPointRequest: DataPointRequest;
  unapproveDataPointRequests: Array<DataPointRequest>;
  unfollowDataPointRequest: DataPointRequest;
  unsuspendDataPointTypeByEntity: Array<EntityLocation>;
  unsuspendDataPointTypeByLocation: EntityLocation;
  updateDataPointCustomCategoryName: DataPointCategory;
  updateDataPointCustomSubcategories: DataPointCategory;
  updateEntity: Entity;
  updateEntityAssignment: EntityLocation;
  updateEntityKPI: EntityKpi;
  updateEntityLocation: EntityLocation;
  updateEntityReportingFrameworks: Entity;
  updateEntitySettings: EntitySettings;
  updateExternallyTaxonomyAssessmentBusinessActivity: Scalars['Boolean']['output'];
  updateInsight: DataPointType;
  updateOrganization: Organization;
  updateRestriction: Restriction;
  updateSubcategoryAssignments: Scalars['Int']['output'];
  updateTaxonomyAssessment: TaxonomyAssessment;
  updateTaxonomyAssessmentActivities: TaxonomyAssessment;
  updateTaxonomyAssessmentBusinessActivity: TaxonomyBusinessActivity;
  updateTaxonomyAssessmentSectors: TaxonomyAssessment;
  updateTaxonomyCoreData: TaxonomyCoreData;
  updateTaxonomyProject: TaxonomyProject;
  updateUser: User;
  uploadCsvForHistoricImport: Array<DataPoint>;
  uploadQuestionsJSON: CustomQuestionnaire;
  uploadedFileForReview: Scalars['String']['output'];
  upsertCustomQuestionnaireQuestion: CustomQuestionnaireQuestion;
  upsertDataPoint: DataPoint;
  upsertDataPointType: DataPointType;
  validateBusinessActivityShareToken: Scalars['Boolean']['output'];
  validateDoubleMaterialitySurveyParticipantShareToken: Scalars['Boolean']['output'];
};


export type MutationAddDataPointTypeOverrideArgs = {
  dataPointTypeOverride: DataPointTypeOverrideInput;
  entityLocation: EntityLocationInput;
};


export type MutationAddDataPointTypeOverrideByEntityArgs = {
  dataPointTypeOverride: DataPointTypeOverrideInput;
};


export type MutationAddEntityToUsersArgs = {
  entityId: Scalars['String']['input'];
  usersIds: Array<Scalars['String']['input']>;
};


export type MutationAddFileMetadataArgs = {
  repositoryFile: UpdateRepositoryFileInput;
};


export type MutationAddRatingToRecommendationArgs = {
  rating: Scalars['Float']['input'];
  recommendationId: Scalars['String']['input'];
};


export type MutationAddUserToRecommendationArgs = {
  recommendationId: Scalars['String']['input'];
};


export type MutationAnswerDataPointRequestArgs = {
  AnswerDataPointRequestInput: AnswerDataPointRequestInput;
};


export type MutationAnswerDelegatedDataPointRequestArgs = {
  AnswerDataPointRequestInput: AnswerDataPointRequestInput;
  delegationEmailAddress: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
};


export type MutationApproveDataPointRequestArgs = {
  ApproveDataPointRequestInput: ApproveDataPointRequestInput;
};


export type MutationApproveDataPointRequestsArgs = {
  approveDataPointRequestsInput: ApproveDataPointRequestsInput;
};


export type MutationAssignUserToDoubleMaterialityArgs = {
  userIds: Array<Scalars['String']['input']>;
};


export type MutationCompleteCustomQuestionnaireArgs = {
  customQuestionnaireId: Scalars['String']['input'];
};


export type MutationCreateCustomQuestionnaireArgs = {
  customQuestionnaireData: CreateCustomQuestionnaireInput;
};


export type MutationCreateDataPointCustomCategoryArgs = {
  createCategory: CreateCategoryInput;
};


export type MutationCreateDataPointCustomSubcategoriesArgs = {
  categoryId: Scalars['String']['input'];
  subcategoryNames: Array<Scalars['String']['input']>;
};


export type MutationCreateDataPointRequestChatCommentArgs = {
  createDataPointRequestChatCommentInput: CreateDataPointRequestChatCommentInput;
};


export type MutationCreateEntityArgs = {
  entityInput: EntityInput;
};


export type MutationCreateEntityKpiArgs = {
  entityKPIs?: Array<CreateEntityKpiInput>;
};


export type MutationCreateEntityKpiCommentArgs = {
  comment: CreateEntityKpiCommentInput;
};


export type MutationCreateEntityLocationArgs = {
  entityLocation: CreateEntityLocationInput;
};


export type MutationCreateInsightArgs = {
  createInsightInput: CreateInsightInput;
};


export type MutationCreateTaxonomyAssessmentArgs = {
  projectId: Scalars['String']['input'];
};


export type MutationCreateTaxonomyProjectArgs = {
  createTaxonomyProjectInput: CreateTaxonomyProjectInput;
};


export type MutationCreateUserArgs = {
  user: CreateUserInput;
};


export type MutationDelegateBusinessActivityArgs = {
  assessmentId: Scalars['String']['input'];
  businessActivityId: Scalars['String']['input'];
  data: DelegateTaxonomyAssessmentBusinessActivityInput;
  email: Scalars['String']['input'];
};


export type MutationDelegateDataPointRequestsArgs = {
  delegateDataPointRequestsInput: DelegateDataPointRequestsInput;
  emailAddresses: Array<Scalars['String']['input']>;
};


export type MutationDelegateTaxonomyAssessmentsArgs = {
  assessmentIds: Array<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
};


export type MutationDeleteCustomQuestionnaireQuestionArgs = {
  customQuestionnaireId: Scalars['String']['input'];
  customQuestionnaireQuestionId: Scalars['String']['input'];
};


export type MutationDeleteDataPointCustomCategoriesArgs = {
  categoryIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteDataPointCustomSubcategoriesArgs = {
  categoryId: Scalars['String']['input'];
  subcategoryIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteDataPointRequestArgs = {
  dataPointRequestId: Scalars['String']['input'];
};


export type MutationDeleteDataPointRequestDelegationArgs = {
  dataPointRequestId: Scalars['String']['input'];
};


export type MutationDeleteDataPointRequestsArgs = {
  deleteDataPointRequestsInput: DeleteDataPointRequestsInput;
};


export type MutationDeleteDataPointTypeArgs = {
  dataPointTypeId: Scalars['String']['input'];
};


export type MutationDeleteEntityArgs = {
  entityInput: EntityInput;
};


export type MutationDeleteEntityKpiArgs = {
  entityKPI: DeleteEntityKpiInput;
};


export type MutationDeleteEntityLocationArgs = {
  entityLocation: DeleteEntityLocationInput;
};


export type MutationDeleteInsightArgs = {
  deleteInsightInput: DeleteInsightInput;
};


export type MutationDeleteRepositoryFileArgs = {
  repositoryFileId: Scalars['String']['input'];
};


export type MutationDeleteTaxonomyDocumentArgs = {
  taxonomyDocumentId: Scalars['String']['input'];
};


export type MutationDeleteTaxonomyProjectArgs = {
  _id: Scalars['String']['input'];
};


export type MutationDisableUserArgs = {
  user: DisableUserInput;
};


export type MutationFollowDataPointRequestArgs = {
  dataPointRequestId: Scalars['String']['input'];
};


export type MutationGenerateDataPointRequestsForPastDatesArgs = {
  dataPointTypeId: Scalars['String']['input'];
  pastDatesInput: PastDatesInput;
  projectId: Scalars['String']['input'];
};


export type MutationGenerateFileDownloadTokenArgs = {
  repositoryFileId: Scalars['String']['input'];
  repositoryFileType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateFileUploadTokenExternalArgs = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateQuestionnaireFileUploadTokenArgs = {
  customQuestionnaireId: Scalars['String']['input'];
};


export type MutationReassignSuperadminArgs = {
  user: UpdateUserInput;
};


export type MutationRejectDataPointRequestArgs = {
  RejectDataPointRequestInput: RejectDataPointRequestInput;
};


export type MutationRejectDataPointRequestsArgs = {
  RejectDataPointRequestsInput: RejectDataPointRequestsInput;
};


export type MutationRemindUsersAdminArgs = {
  _id: Scalars['String']['input'];
  type: RemindUsersAdminType;
};


export type MutationRequestCo2ReportArgs = {
  entityIds: Array<Scalars['String']['input']>;
};


export type MutationRequestCustomReportArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  format: Scalars['String']['input'];
  locationIds: Array<Scalars['String']['input']>;
};


export type MutationRequestEsgReportArgs = {
  entityIds: Array<Scalars['String']['input']>;
};


export type MutationRequestHelpArgs = {
  message: Scalars['String']['input'];
  phoneOrEmail: Scalars['String']['input'];
  type: HelpTypeEnum;
};


export type MutationRequestHelpForExternalTaxonomyArgs = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
};


export type MutationRequestReopenDataPointRequestArgs = {
  reopenRequestedDataPointRequestInput: ReopenRequestedDataPointRequestInput;
};


export type MutationRequestSupportArgs = {
  input: RequestSupportInput;
};


export type MutationResetDataPointRequestArgs = {
  dataPointRequestId: Scalars['String']['input'];
};


export type MutationSendSurveysArgs = {
  doubleMaterialityId: Scalars['String']['input'];
  sendSurveys: Array<SendSurveyInput>;
};


export type MutationSetQuestionnaireNameArgs = {
  customQuestionnaireId: Scalars['String']['input'];
  inputData: SetQuestionnaireNameInput;
};


export type MutationSignupArgs = {
  user: SignupInput;
};


export type MutationStartFileProcessingArgs = {
  customQuestionnaireId: Scalars['String']['input'];
};


export type MutationSuspendDataPointTypeByEntityArgs = {
  dataPointTypeId: Scalars['String']['input'];
};


export type MutationSuspendDataPointTypeByLocationArgs = {
  dataPointTypeId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};


export type MutationToggleCategoriesArgs = {
  disable: Array<Scalars['String']['input']>;
  enable: Array<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
};


export type MutationUnapproveDataPointRequestArgs = {
  UnapproveDataPointRequestInput: UnapproveDataPointRequestInput;
};


export type MutationUnapproveDataPointRequestsArgs = {
  UnapproveDataPointRequestsInput: UnapproveDataPointRequestsInput;
};


export type MutationUnfollowDataPointRequestArgs = {
  dataPointRequestId: Scalars['String']['input'];
};


export type MutationUnsuspendDataPointTypeByEntityArgs = {
  dataPointTypeId: Scalars['String']['input'];
};


export type MutationUnsuspendDataPointTypeByLocationArgs = {
  dataPointTypeId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};


export type MutationUpdateDataPointCustomCategoryNameArgs = {
  updateCategoryNameInput: UpdateCategoryNameInput;
};


export type MutationUpdateDataPointCustomSubcategoriesArgs = {
  categoryId: Scalars['String']['input'];
  subcategories: Array<UpdateSubcategoryInput>;
};


export type MutationUpdateEntityArgs = {
  entityInput: EntityInput;
};


export type MutationUpdateEntityAssignmentArgs = {
  locationId: Scalars['String']['input'];
  updateEntityAssignmentInput: Array<UpdateEntityAssignmentInput>;
};


export type MutationUpdateEntityKpiArgs = {
  entityKPI: UpdateEntityKpiInput;
};


export type MutationUpdateEntityLocationArgs = {
  entityLocation: UpdateEntityLocationInput;
};


export type MutationUpdateEntityReportingFrameworksArgs = {
  updateEntityReportingFrameworksInput: UpdateEntityReportingFrameworksInput;
};


export type MutationUpdateEntitySettingsArgs = {
  updateEntitySettingsInput: UpdateEntitySettingsInput;
};


export type MutationUpdateExternallyTaxonomyAssessmentBusinessActivityArgs = {
  email: Scalars['String']['input'];
  input: UpdateExternallyTaxonomyAssessmentBusinessActivityInput;
  shareToken: Scalars['String']['input'];
};


export type MutationUpdateInsightArgs = {
  updateInsightInput: UpdateInsightInput;
};


export type MutationUpdateOrganizationArgs = {
  organizationInput: OrganizationInput;
};


export type MutationUpdateRestrictionArgs = {
  restrictionInput: RestrictionInput;
};


export type MutationUpdateSubcategoryAssignmentsArgs = {
  subcategoryAssignments: UserUpdateSubcategoryAssignmentsInput;
};


export type MutationUpdateTaxonomyAssessmentArgs = {
  assessmentId: Scalars['String']['input'];
  input: UpdateTaxonomyAssessmentInput;
};


export type MutationUpdateTaxonomyAssessmentActivitiesArgs = {
  activityIds: Array<Scalars['String']['input']>;
  assessmentId: Scalars['String']['input'];
};


export type MutationUpdateTaxonomyAssessmentBusinessActivityArgs = {
  assessmentId: Scalars['String']['input'];
  businessActivityId: Scalars['String']['input'];
  input: UpdateTaxonomyAssessmentBusinessActivityInput;
};


export type MutationUpdateTaxonomyAssessmentSectorsArgs = {
  assessmentId: Scalars['String']['input'];
  sectorIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateTaxonomyCoreDataArgs = {
  coreData: TaxonomyCoreDataInput;
};


export type MutationUpdateTaxonomyProjectArgs = {
  updateTaxonomyProjectInput: UpdateTaxonomyProjectInput;
};


export type MutationUpdateUserArgs = {
  user: UpdateUserInput;
};


export type MutationUploadCsvForHistoricImportArgs = {
  csvContent: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};


export type MutationUploadQuestionsJsonArgs = {
  customQuestionnaireId: Scalars['String']['input'];
  questions: Scalars['String']['input'];
};


export type MutationUploadedFileForReviewArgs = {
  fileId: Scalars['String']['input'];
  projectIds: Array<Scalars['String']['input']>;
  topics: Array<Scalars['String']['input']>;
};


export type MutationUpsertCustomQuestionnaireQuestionArgs = {
  customQuestionnaireId: Scalars['String']['input'];
  questionData: UpsertCustomQuestionnaireQuestionInput;
};


export type MutationUpsertDataPointArgs = {
  upsertDataPointInput: UpsertDataPointInput;
};


export type MutationUpsertDataPointTypeArgs = {
  dataPointTypeInput: UpsertDataPointTypeInput;
};


export type MutationValidateBusinessActivityShareTokenArgs = {
  email: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
};


export type MutationValidateDoubleMaterialitySurveyParticipantShareTokenArgs = {
  email: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
};

/** Enum for User#OnboardingStatusEnum */
export enum OnboardingStatusEnum {
  COMPLETED = 'COMPLETED',
  INCOMPLETE = 'INCOMPLETE'
}

/** Organization */
export type Organization = {
  __typename?: 'Organization';
  _id: Scalars['ID']['output'];
  isDemo: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  restrictions: Restriction;
  taxonomyCoreData?: Maybe<TaxonomyCoreData>;
};

export type OrganizationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Enum for pagination limit possible values */
export enum PaginationLimitEnum {
  FIFTY = 'FIFTY',
  HUNDRED = 'HUNDRED',
  TWENTY_FIVE = 'TWENTY_FIVE',
  TWO_HUNDRED = 'TWO_HUNDRED'
}

/** Enum for Pagination sorting type */
export enum PaginationSortingEnum {
  ASC = 'ASC',
  DESC = 'DESC',
  NONE = 'NONE'
}

export type PastDatesInput = {
  pastDates?: Array<Scalars['Float']['input']>;
};

/** Enum for PDF Reports types */
export enum PdfReportTypeEnum {
  ALL = 'ALL',
  CARBON_FOOTPRINT = 'CARBON_FOOTPRINT',
  QUALITATIVE = 'QUALITATIVE',
  STANDARD = 'STANDARD'
}

/** pinneddatapointtype */
export type PinnedDataPointType = {
  __typename?: 'PinnedDataPointType';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  dataPointType: DataPointType;
  entity: Entity;
  updatedAt: Scalars['DateTime']['output'];
};

export type PinnedDataPointTypeInput = {
  dataPointType?: Scalars['String']['input'];
  entity?: Scalars['String']['input'];
};

export type PreviewInsightInput = {
  dataPointTypeAId?: Scalars['String']['input'];
  dataPointTypeBId?: Scalars['String']['input'];
  targetAction?: DataPointTypeTargetActionEnum;
  type?: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  downloadDMAResultExcel: Scalars['String']['output'];
  downloadDoubleMaterialityDocument: DoubleMaterialityDownloadDocumentDto;
  downloadPDFReport: Scalars['String']['output'];
  downloadRepositoryGuidanceDocument: RepositoryDownloadDocumentDto;
  downloadRepositorySourceDocument: RepositoryDownloadDocumentDto;
  entityLocationSubcategorySummaries: Array<EntityLocationSubcategorySummaryDto>;
  entityLocationSummaries: Array<EntityLocationSummaryDto>;
  entityLocationSummary: EntityLocationSummaryDto;
  entitySummaries: Array<EntityLocationSummaryDto>;
  generateDataPointSummary: Scalars['String']['output'];
  generateGuidanceAiSuggestion: AiGuidanceSuggestionDto;
  getAdminDataPointsByType: Array<DataPoint>;
  getAllCategoriesForEntity: Array<DataPointCategory>;
  getAllSubcategories: Array<DataPointTypeSubcategoryDto>;
  getAllTeamsUsers: Array<User>;
  getApprovalDataPointRequestsFilters: DataPointRequestFiltersDto;
  getAuthenticatedUser: User;
  getAvailableDataPointsGroupedByType: Array<DataPoint>;
  getAvailableSubcategories: Array<DataPointTypeSubcategoryDto>;
  getCarbonFootprintDataPointsByProjectAndDateRange: Array<DataPoint>;
  getCarbonFootprintDataPointsByProjectAndDateRangeAdmin: Array<GroupedDataPoint>;
  getCategories: Array<DataPointCategory>;
  getCategoriesWithSubcategories: Array<DataPointCategory>;
  getCategoriesWithSubcategoriesForUser: Array<DataPointCategory>;
  getCurrentEntity: Entity;
  getCurrentEntitySettings: EntitySettings;
  getCurrentExternalUserId: Scalars['String']['output'];
  getCurrentUserEntities: Array<Entity>;
  getCustomCategoriesWithSubcategories: Array<DataPointCategory>;
  getCustomCategoriesWithSubcategoriesForEntity: Array<DataPointCategory>;
  getCustomQuestionnaire: CustomQuestionnaire;
  getDataPointCategoriesForDoubleMateriality: Array<DataPointCategory>;
  getDataPointRequest?: Maybe<DataPointRequest>;
  getDataPointRequestAnalytics: Array<DataPointRequestAnalyticsDto>;
  getDataPointRequestsEncodedReport: Scalars['String']['output'];
  getDataPointType: DataPointType;
  getDataPointsByType: Array<DataPoint>;
  getDataPointsByTypeAndLocation: Array<DataPoint>;
  getDataPointsEncodedAdminPDFReport: Scalars['String']['output'];
  getDataPointsEncodedPDFReport: Scalars['String']['output'];
  getDataPointsEncodedReport: Scalars['String']['output'];
  getDatapointsAsXlsxAdmin: Scalars['String']['output'];
  getDatapointsCreatedAnalytics: Array<DatapointsCreatedAnalyticsDto>;
  getDelegatedDataPointRequests: Array<DataPointRequest>;
  getDelegatedSubcategories: Array<UserSubcategoryAssignment>;
  getDenominatorNumericDataPointTypes: Array<DataPointType>;
  getDoesNotHarm: DoesNotHarm;
  getDoubleMaterialityTopics: Array<DoubleMaterialityTopic>;
  getEmissionFactorSuggestions: Array<EmissionFactorSuggestion>;
  getEmissionFactorsCsv: Scalars['String']['output'];
  getEmissions: Array<EmissionsDto>;
  getEmissionsDataPointTypes: Array<DataPointType>;
  getEmissionsExternal: Array<EmissionsDto>;
  getEntityAssignments: Array<EntityAssignmentDto>;
  getEntityCustomQuestionnaires: Array<CustomQuestionnaire>;
  getEntityKPI: EntityKpi;
  getEntityKPIs: Array<EntityKpi>;
  getEntityLocationAnalytics: Array<EntityLocationAnalyticsDto>;
  getEntityReportingProgress: Array<DataPointRequestReportingProgressDto>;
  getEntityRepositoryFiles: Array<RepositoryFile>;
  getEntityRepositoryFilesAdmin: Array<RepositoryFile>;
  getEntityTags: Array<Tag>;
  getEsgDataPointTypes: Array<DataPointType>;
  getEsgDataPointsLength: Scalars['Float']['output'];
  getExternallyDoubleMateriality: DoubleMaterialityExternallyDto;
  getGoal: Goal;
  getGoals: Array<Goal>;
  getGraphsPDF: Scalars['String']['output'];
  getHistoryAsXSLX: Scalars['String']['output'];
  getInsightDataPointTypes: Array<DataPointType>;
  getInsightDataPointTypesAdmin: Array<DataPointType>;
  getInsightDataPoints: Array<DataPoint>;
  getInsightDataPointsAdmin: Array<GroupedDataPoint>;
  getKPIDataPoints: Array<GroupedDataPoint>;
  getLocationsForCustomCategory: Array<EntityLocation>;
  getLoginWorkspaces: GetLoginWorkspacesDto;
  getMyDataPointRequests: Array<DataPointRequest>;
  getNumberOfEntities: Scalars['Float']['output'];
  getNumberOfEntitiesExternal: Scalars['Float']['output'];
  getNumberOfEntityKpis: Scalars['Float']['output'];
  getNumberOfEntityKpisExternal: Scalars['Float']['output'];
  getNumberOfLocations: Scalars['Float']['output'];
  getNumberOfLocationsExternal: Scalars['Float']['output'];
  getNumberOfUsers: Scalars['Float']['output'];
  getNumberOfUsersExternal: Scalars['Float']['output'];
  getNumericDataPointTypes: Array<DataPointType>;
  getObjectives: TaxonomyAssessmentBusinessActivityObjectiveEnum;
  getOrCreateDoubleMateriality: DoubleMateriality;
  getOrganizationQuestionnaires: Array<CustomQuestionnaire>;
  getOrganizationQuestionnairesCount: Scalars['Float']['output'];
  getOwnUser: User;
  getPaginatedApprovalDataPointRequests: DataPointRequestPaginatedDto;
  getPinnedDataPoints: Array<DataPoint>;
  getPinnedDataPointsAdmin: Array<GroupedDataPoint>;
  getProjectsAdmin: Array<EntityLocation>;
  getQualitativeDataPointsByProjectAndDateRangeAdmin: Array<GroupedDataPoint>;
  getRecommendations: Array<Recommendation>;
  getReportingProgress: Array<DataPointRequestReportingProgressDto>;
  getReportingProgressExternal: Array<DataPointRequestReportingProgressDto>;
  getRepositorySourceFiles: Array<RepositoryFile>;
  getSingleProjectExport: Scalars['String']['output'];
  getStandardDataPointsByProjectAndDateRange: Array<DataPoint>;
  getStandardDataPointsByProjectAndDateRangeAdmin: Array<GroupedDataPoint>;
  getSummaryDataPointsByProjectAndDateRangeAdmin: Array<GroupedDataPoint>;
  getTarget: Target;
  getTargets: Array<Target>;
  getTaxonomyAssessment: TaxonomyAssessment;
  getTaxonomyAssessments: Array<TaxonomyAssessment>;
  getTaxonomyBusinessActivityDelegation: TaxonomyBusinessActivityDelegationDto;
  getTaxonomyCoreData: TaxonomyCoreData;
  getTaxonomyDocuments: TaxonomyDocumentPaginatedDto;
  getTaxonomyDocumentsFilters: TaxonomyDocumentsFiltersDto;
  getTaxonomyProject: TaxonomyProject;
  getTaxonomyProjectSpreadsheets: Scalars['String']['output'];
  getTaxonomyProjects: Array<TaxonomyProject>;
  getTaxonomySectors: Array<TaxonomySector>;
  getTeamUserDataPointRequests: Array<DataPointRequest>;
  getTeamUsers: Array<User>;
  getTotalsForAssigments: EntityAssignmentTotalsDto;
  getUserAssignedDataPointRequestsSubcategories: Array<UserAssignedDataPointRequestSubcategoryDto>;
  getUserCreatedAnalytics: Array<UserCreatedAnalyticsDto>;
  getUserRepositoryFiles: Array<RepositoryFile>;
  isAnyDataPointApprovedAndNumeric: Scalars['Boolean']['output'];
  previewInsight: Array<DataPoint>;
  restrictions: Restriction;
  validateDelegation: Scalars['Boolean']['output'];
};


export type QueryDownloadDmaResultExcelArgs = {
  data: Scalars['String']['input'];
};


export type QueryDownloadDoubleMaterialityDocumentArgs = {
  file: DoubleMaterialityDownloadDocumentEnum;
};


export type QueryDownloadPdfReportArgs = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  reportTypes?: InputMaybe<Array<PdfReportTypeEnum>>;
  workspaceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDownloadRepositoryGuidanceDocumentArgs = {
  file: LibraryGuidanceDocumentEnum;
  fileType: RepositoryFileTypeEnum;
};


export type QueryDownloadRepositorySourceDocumentArgs = {
  fileName: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
};


export type QueryEntityLocationSubcategorySummariesArgs = {
  locationId: Scalars['String']['input'];
};


export type QueryEntityLocationSummaryArgs = {
  entityLocationId: Scalars['String']['input'];
};


export type QueryGenerateDataPointSummaryArgs = {
  dataPointType: Scalars['String']['input'];
  from: Scalars['String']['input'];
  locations: Array<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};


export type QueryGenerateGuidanceAiSuggestionArgs = {
  aiGuidanceSuggestionInput: AiGuidanceSuggestionInput;
};


export type QueryGetAdminDataPointsByTypeArgs = {
  allEntities?: InputMaybe<Scalars['Boolean']['input']>;
  dataPointTypeNames: Array<Scalars['String']['input']>;
};


export type QueryGetAllCategoriesForEntityArgs = {
  entityId: Scalars['String']['input'];
};


export type QueryGetAllTeamsUsersArgs = {
  includeInactive?: Scalars['Boolean']['input'];
};


export type QueryGetApprovalDataPointRequestsFiltersArgs = {
  status?: DataPointRequestStatusEnum;
};


export type QueryGetCarbonFootprintDataPointsByProjectAndDateRangeArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCarbonFootprintDataPointsByProjectAndDateRangeAdminArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  workspaceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetCategoriesArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCategoriesWithSubcategoriesArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCategoriesWithSubcategoriesForUserArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCurrentExternalUserIdArgs = {
  emailAddress: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
};


export type QueryGetCustomCategoriesWithSubcategoriesArgs = {
  entityLocationId: Scalars['String']['input'];
};


export type QueryGetCustomQuestionnaireArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetDataPointRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetDataPointRequestsEncodedReportArgs = {
  dataPointRequestIds: Array<Scalars['String']['input']>;
};


export type QueryGetDataPointTypeArgs = {
  dataPointTypeId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDataPointsByTypeArgs = {
  dataPointTypeNames: Array<Scalars['String']['input']>;
};


export type QueryGetDataPointsByTypeAndLocationArgs = {
  dataPointTypeIds: Array<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
};


export type QueryGetDataPointsEncodedAdminPdfReportArgs = {
  dataPointTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  reportType?: PdfReportTypeEnum;
  reportingFrameworks?: InputMaybe<Array<ReportingFrameworkEnum>>;
  scope2EmissionTypeExcluded?: InputMaybe<DataPointTypeEmissionTypeEnum>;
  workspaceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetDataPointsEncodedPdfReportArgs = {
  dataPointTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  reportType?: PdfReportTypeEnum;
  scope2EmissionTypeExcluded?: InputMaybe<DataPointTypeEmissionTypeEnum>;
};


export type QueryGetDataPointsEncodedReportArgs = {
  dataPointTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dataPointTypeNames?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  entityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  reportingFrameworks?: InputMaybe<Array<ReportingFrameworkEnum>>;
};


export type QueryGetDatapointsAsXlsxAdminArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  entityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  onlyCo2?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetDelegatedDataPointRequestsArgs = {
  emailAddress: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
  statusFilter?: InputMaybe<DataPointRequestStatusEnum>;
};


export type QueryGetDenominatorNumericDataPointTypesArgs = {
  withExistingDataPoints?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetEmissionFactorSuggestionsArgs = {
  emissionSubcategory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEmissionsArgs = {
  adminMode?: InputMaybe<Scalars['Boolean']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEmissionsExternalArgs = {
  adminMode?: InputMaybe<Scalars['Boolean']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  sharePassword?: InputMaybe<Scalars['String']['input']>;
  shareToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEntityKpiArgs = {
  _id: Scalars['String']['input'];
};


export type QueryGetEntityReportingProgressArgs = {
  adminMode?: InputMaybe<Scalars['Boolean']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEntityRepositoryFilesArgs = {
  type?: Scalars['String']['input'];
};


export type QueryGetEntityRepositoryFilesAdminArgs = {
  type?: Scalars['String']['input'];
};


export type QueryGetExternallyDoubleMaterialityArgs = {
  email: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
};


export type QueryGetGoalArgs = {
  _id: Scalars['String']['input'];
};


export type QueryGetGraphsPdfArgs = {
  charts: ChartsInput;
};


export type QueryGetHistoryAsXslxArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  entityIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetInsightDataPointsArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLocationsForCustomCategoryArgs = {
  dataPointCategoryId: Scalars['String']['input'];
};


export type QueryGetLoginWorkspacesArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetMyDataPointRequestsArgs = {
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  categoryFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  includeChilds?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  sortedByUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  statusFilter?: InputMaybe<DataPointRequestStatusEnum>;
  subcategoryFilter?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetNumberOfEntitiesExternalArgs = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  sharePassword?: InputMaybe<Scalars['String']['input']>;
  shareToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetNumberOfEntityKpisExternalArgs = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  sharePassword?: InputMaybe<Scalars['String']['input']>;
  shareToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetNumberOfLocationsExternalArgs = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  sharePassword?: InputMaybe<Scalars['String']['input']>;
  shareToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetNumberOfUsersArgs = {
  adminMode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetNumberOfUsersExternalArgs = {
  adminMode?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  sharePassword?: InputMaybe<Scalars['String']['input']>;
  shareToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetNumericDataPointTypesArgs = {
  withActiveReportingFramework?: InputMaybe<Scalars['Boolean']['input']>;
  withExistingDataPoints?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetPaginatedApprovalDataPointRequestsArgs = {
  filterBy?: Array<DataPointRequestFilterByInput>;
  limit?: PaginationLimitEnum;
  offset?: Scalars['Int']['input'];
  searchBy?: Scalars['String']['input'];
  sortBy?: Scalars['String']['input'];
  sortOrder?: PaginationSortingEnum;
  status?: InputMaybe<DataPointRequestStatusEnum>;
};


export type QueryGetPinnedDataPointsAdminArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetQualitativeDataPointsByProjectAndDateRangeAdminArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  workspaceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetRecommendationsArgs = {
  dataPointTypeId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
};


export type QueryGetReportingProgressArgs = {
  adminMode?: InputMaybe<Scalars['Boolean']['input']>;
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetReportingProgressExternalArgs = {
  adminMode?: InputMaybe<Scalars['Boolean']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  sharePassword?: InputMaybe<Scalars['String']['input']>;
  shareToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSingleProjectExportArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStandardDataPointsByProjectAndDateRangeArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStandardDataPointsByProjectAndDateRangeAdminArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  workspaceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetSummaryDataPointsByProjectAndDateRangeAdminArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  workspaceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetTargetArgs = {
  _id: Scalars['String']['input'];
};


export type QueryGetTaxonomyAssessmentArgs = {
  _id: Scalars['String']['input'];
};


export type QueryGetTaxonomyAssessmentsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetTaxonomyBusinessActivityDelegationArgs = {
  email: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
};


export type QueryGetTaxonomyDocumentsArgs = {
  filterBy?: Array<TaxonomyDocumentsFilterByInput>;
  limit?: PaginationLimitEnum;
  offset?: Scalars['Int']['input'];
  sortBy?: Scalars['String']['input'];
  sortOrder?: PaginationSortingEnum;
};


export type QueryGetTaxonomyProjectArgs = {
  _id: Scalars['String']['input'];
};


export type QueryGetTaxonomyProjectSpreadsheetsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetTeamUserDataPointRequestsArgs = {
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  categoryFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  includeChilds?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  sortedByUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  statusFilter?: InputMaybe<DataPointRequestStatusEnum>;
  subcategoryFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  teamUserId: Scalars['String']['input'];
};


export type QueryGetTeamUsersArgs = {
  includeInactive?: Scalars['Boolean']['input'];
};


export type QueryGetUserAssignedDataPointRequestsSubcategoriesArgs = {
  locationId: Scalars['String']['input'];
};


export type QueryPreviewInsightArgs = {
  previewInsightInput: PreviewInsightInput;
};


export type QueryValidateDelegationArgs = {
  emailAddress: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
};

/** Recommendation */
export type Recommendation = {
  __typename?: 'Recommendation';
  _id: Scalars['ID']['output'];
  averageRating: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  dataPointType: DataPointType;
  entities: Array<Entity>;
  language?: Maybe<UserLanguageEnum>;
  ratings: Array<RecommendationRating>;
  tags: Array<RecommendationTagEnum>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  users: Array<User>;
  utilizationCount: Scalars['Float']['output'];
};

/** recommendationRating */
export type RecommendationRating = {
  __typename?: 'RecommendationRating';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  rating: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

/** Enum for Recommendation tag */
export enum RecommendationTagEnum {
  COMPANY_SPECIFIC = 'COMPANY_SPECIFIC',
  INDUSTRY_ANSWER = 'INDUSTRY_ANSWER',
  TEAM_ANSWER = 'TEAM_ANSWER'
}

export type RejectDataPointRequestInput = {
  dataPointRequestId?: Scalars['String']['input'];
  reason?: Scalars['String']['input'];
};

export type RejectDataPointRequestsInput = {
  dataPointRequestIds?: Array<Scalars['String']['input']>;
};

/** Should remind users for workspace or project */
export enum RemindUsersAdminType {
  PROJECT = 'PROJECT',
  WORKSPACE = 'WORKSPACE'
}

/** reminder */
export type Reminder = {
  __typename?: 'Reminder';
  _id: Scalars['ID']['output'];
  commentLink: Scalars['String']['output'];
  sendAt: Scalars['DateTime']['output'];
  shareToken: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ReopenRequestedDataPointRequestInput = {
  dataPointRequestId: Scalars['String']['input'];
};

/** Enum for ESG reporting frameworks */
export enum ReportingFrameworkEnum {
  CDP = 'CDP',
  CUSTOM = 'CUSTOM',
  CUSTOMER_REQUIREMENT = 'CUSTOMER_REQUIREMENT',
  DERIVED = 'DERIVED',
  DNK = 'DNK',
  ECOVADIS = 'ECOVADIS',
  EMAS = 'EMAS',
  ESRS = 'ESRS',
  GHG = 'GHG',
  GRI = 'GRI',
  INTERNAL_REQUIREMENT = 'INTERNAL_REQUIREMENT',
  LkSG = 'LkSG',
  ONBOARDING = 'ONBOARDING',
  OTHER = 'OTHER',
  SDG = 'SDG',
  SYSTEM = 'SYSTEM',
  TCFD = 'TCFD',
  VSME = 'VSME'
}

export type RepositoryDownloadDocumentDto = {
  __typename?: 'RepositoryDownloadDocumentDto';
  file: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** repositoryfile */
export type RepositoryFile = {
  __typename?: 'RepositoryFile';
  _id: Scalars['ID']['output'];
  category?: Maybe<Scalars['String']['output']>;
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  dataPointRequests: Array<DataPointRequest>;
  date?: Maybe<Scalars['DateTime']['output']>;
  downloadUrl: Scalars['String']['output'];
  entity?: Maybe<Entity>;
  filename: Scalars['String']['output'];
  filepath?: Maybe<Scalars['String']['output']>;
  filesize: Scalars['Float']['output'];
  language?: Maybe<UserLanguageEnum>;
  module?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  preSignedUrl: Scalars['String']['output'];
  relatedProjects?: Maybe<Array<EntityLocation>>;
  relatedTopicSlugs?: Maybe<Array<Scalars['String']['output']>>;
  secretUpdateToken: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Enum for repository file type */
export enum RepositoryFileTypeEnum {
  HTML = 'HTML',
  PDF = 'PDF'
}

export type RequestSupportInput = {
  phone: Scalars['String']['input'];
};

/** Restriction */
export type Restriction = {
  __typename?: 'Restriction';
  _id: Scalars['ID']['output'];
  numberOfAdmins: Scalars['Float']['output'];
  numberOfExportsPerYearPerType: Scalars['Float']['output'];
  numberOfManagers: Scalars['Float']['output'];
  numberOfProjects: Scalars['Float']['output'];
  numberOfQuestionnaires: Scalars['Float']['output'];
  numberOfTopics: Scalars['Float']['output'];
  numberOfUsers: Scalars['Float']['output'];
  numberOfWorkspaces: Scalars['Float']['output'];
  restrictedFeatures: Array<RestrictionsFeaturesEnum>;
  supportedStandards: Array<ReportingFrameworkEnum>;
  supportedTopics: Array<Scalars['String']['output']>;
};

export type RestrictionInput = {
  numberOfQuestionnaires?: InputMaybe<Scalars['Float']['input']>;
  restrictedFeatures?: InputMaybe<Array<RestrictionsFeaturesEnum>>;
};

/** Enum for restrictions */
export enum RestrictionsFeaturesEnum {
  CALCULATORS = 'CALCULATORS',
  CARBON_ACCOUNTING = 'CARBON_ACCOUNTING',
  DOUBLE_MATERIALITY = 'DOUBLE_MATERIALITY',
  ESRS = 'ESRS',
  GOALS = 'GOALS',
  TAXONOMY = 'TAXONOMY'
}

export type SendSurveyInput = {
  body: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
};

export type SetQuestionnaireNameInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  name?: Scalars['String']['input'];
};

export type SignupInput = {
  sub?: Scalars['String']['input'];
  token?: Scalars['String']['input'];
  tosAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Enum for DataPointType summarizingMethod */
export enum SummarizingMethodEnum {
  AVERAGE = 'AVERAGE',
  SUM = 'SUM'
}

/** tag */
export type Tag = {
  __typename?: 'Tag';
  _id: Scalars['ID']['output'];
  color: TagColorEnum;
  entity: Entity;
  name: Scalars['String']['output'];
};

/** Enum for tag color */
export enum TagColorEnum {
  AMBER = 'AMBER',
  BLUE = 'BLUE',
  EMERALD = 'EMERALD',
  INDIGO = 'INDIGO',
  ORANGE = 'ORANGE',
  ROSE = 'ROSE',
  STONE = 'STONE',
  TEAL = 'TEAL',
  VIOLET = 'VIOLET',
  YELLOW = 'YELLOW'
}

export type TagInput = {
  color?: TagColorEnum;
  name?: Scalars['String']['input'];
};

/** Target */
export type Target = {
  __typename?: 'Target';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  entity: Entity;
  goal: Goal;
  isRecommended: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  suggestedDataPointTypes: Array<DataPointType>;
  updatedAt: Scalars['DateTime']['output'];
};

/** TaxonomyAssessment */
export type TaxonomyAssessment = {
  __typename?: 'TaxonomyAssessment';
  _id: Scalars['ID']['output'];
  alignedCapex: Scalars['Float']['output'];
  alignedOpex: Scalars['Float']['output'];
  alignedTurnover: Scalars['Float']['output'];
  businessActivities: Array<TaxonomyBusinessActivity>;
  capex: Scalars['Float']['output'];
  capexCompleteLater: Scalars['Boolean']['output'];
  delegation?: Maybe<TaxonomyAssessmentDelegation>;
  documents: Array<TaxonomyDocument>;
  eligibleCapex: Scalars['Float']['output'];
  eligibleOpex: Scalars['Float']['output'];
  eligibleTurnover: Scalars['Float']['output'];
  nonEligibleCapex: Scalars['Float']['output'];
  nonEligibleOpex: Scalars['Float']['output'];
  nonEligibleTurnover: Scalars['Float']['output'];
  opex: Scalars['Float']['output'];
  opexCompleteLater: Scalars['Boolean']['output'];
  project: TaxonomyProject;
  sectors: Array<TaxonomySector>;
  status: Scalars['String']['output'];
  turnover: Scalars['Float']['output'];
  turnoverCompleteLater: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Enum for TaxonomyAssessmentBusinessActivityObjectiveEnum */
export enum TaxonomyAssessmentBusinessActivityObjectiveEnum {
  adaptation = 'adaptation',
  biodiversity = 'biodiversity',
  circular = 'circular',
  mitigation = 'mitigation',
  pollution = 'pollution',
  water = 'water'
}

/** taxonomyassessmentdelegation */
export type TaxonomyAssessmentDelegation = {
  __typename?: 'TaxonomyAssessmentDelegation';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Enum for Taxonomy assessment status #TaxonomyAssessmentStatusEnum */
export enum TaxonomyAssessmentStatusEnum {
  TAXONOMY_ASSESSMENT_BUSINESS_ACTIVITIES = 'TAXONOMY_ASSESSMENT_BUSINESS_ACTIVITIES',
  TAXONOMY_ASSESSMENT_BUSINESS_ACTIVITIES_CAPEX = 'TAXONOMY_ASSESSMENT_BUSINESS_ACTIVITIES_CAPEX',
  TAXONOMY_ASSESSMENT_BUSINESS_ACTIVITIES_OPEX = 'TAXONOMY_ASSESSMENT_BUSINESS_ACTIVITIES_OPEX',
  TAXONOMY_ASSESSMENT_BUSINESS_ACTIVITIES_TURNOVER = 'TAXONOMY_ASSESSMENT_BUSINESS_ACTIVITIES_TURNOVER',
  TAXONOMY_ASSESSMENT_COMPLETED = 'TAXONOMY_ASSESSMENT_COMPLETED',
  TAXONOMY_ASSESSMENT_COMPLETED_FINAL = 'TAXONOMY_ASSESSMENT_COMPLETED_FINAL',
  TAXONOMY_ASSESSMENT_DOCUMENTS = 'TAXONOMY_ASSESSMENT_DOCUMENTS',
  TAXONOMY_ASSESSMENT_DO_NO_SIGNIFICANT_HARM = 'TAXONOMY_ASSESSMENT_DO_NO_SIGNIFICANT_HARM',
  TAXONOMY_ASSESSMENT_MINIMUM_SAFEGUARDS = 'TAXONOMY_ASSESSMENT_MINIMUM_SAFEGUARDS',
  TAXONOMY_ASSESSMENT_NOT_STARTED = 'TAXONOMY_ASSESSMENT_NOT_STARTED',
  TAXONOMY_ASSESSMENT_SUBSTANTIAL_CONTRIBUTION = 'TAXONOMY_ASSESSMENT_SUBSTANTIAL_CONTRIBUTION'
}

/** TaxonomyBusinessActivities */
export type TaxonomyBusinessActivity = {
  __typename?: 'TaxonomyBusinessActivity';
  _id: Scalars['ID']['output'];
  activity: TaxonomySectorActivity;
  activityCapex: Scalars['Float']['output'];
  activityFit: Scalars['Float']['output'];
  activityOpex: Scalars['Float']['output'];
  activityTurnover: Scalars['Float']['output'];
  alignedCapex: Scalars['Float']['output'];
  alignedOpex: Scalars['Float']['output'];
  alignedTurnover: Scalars['Float']['output'];
  doesNotHarm: DoesNotHarm;
  eligibleCapex: Scalars['Float']['output'];
  eligibleOpex: Scalars['Float']['output'];
  eligibleTurnover: Scalars['Float']['output'];
  isElibible: Scalars['Boolean']['output'];
  isObjectiveAnswered: Scalars['Boolean']['output'];
  minimumStandardsDelegation?: Maybe<TaxonomyBusinessActivityDelegation>;
  minimumStandardsRespected?: Maybe<Scalars['Boolean']['output']>;
  minimumStandardsRespectedComment?: Maybe<Scalars['String']['output']>;
  minimumStandardsRespectedDocument?: Maybe<TaxonomyDocument>;
  objective?: Maybe<TaxonomyAssessmentBusinessActivityObjectiveEnum>;
  objectiveComment?: Maybe<Scalars['String']['output']>;
  objectiveDocument?: Maybe<TaxonomyDocument>;
  substantialContributionDelegation?: Maybe<TaxonomyBusinessActivityDelegation>;
  taxonomyFit: TaxonomyFitEnum;
};

/** TaxonomyBusinessActivityDelegation */
export type TaxonomyBusinessActivityDelegation = {
  __typename?: 'TaxonomyBusinessActivityDelegation';
  _id: Scalars['ID']['output'];
  objective?: Maybe<TaxonomyAssessmentBusinessActivityObjectiveEnum>;
  shareToken: Scalars['String']['output'];
  user: User;
};

export type TaxonomyBusinessActivityDelegationDto = {
  __typename?: 'TaxonomyBusinessActivityDelegationDto';
  activityName: Scalars['String']['output'];
  objective: TaxonomyAssessmentBusinessActivityObjectiveEnum;
  objectiveDescription?: Maybe<Scalars['String']['output']>;
  projectName: Scalars['String']['output'];
  type: TaxonomyBusinessActivityDelegationTypeEnum;
  userId: Scalars['String']['output'];
};

/** Enum for TaxonomyBusinessActivityDelegationTypeEnum */
export enum TaxonomyBusinessActivityDelegationTypeEnum {
  DoesNotHarmAdaptation = 'DoesNotHarmAdaptation',
  DoesNotHarmBiodiversity = 'DoesNotHarmBiodiversity',
  DoesNotHarmCircular = 'DoesNotHarmCircular',
  DoesNotHarmMitigation = 'DoesNotHarmMitigation',
  DoesNotHarmPollution = 'DoesNotHarmPollution',
  DoesNotHarmWater = 'DoesNotHarmWater',
  MinimumStandards = 'MinimumStandards',
  SubstantialContribution = 'SubstantialContribution'
}

/** Taxonomy Core Data */
export type TaxonomyCoreData = {
  __typename?: 'TaxonomyCoreData';
  _id: Scalars['ID']['output'];
  capEx?: Maybe<Scalars['Float']['output']>;
  capExCompleteLater: Scalars['Boolean']['output'];
  capExFile?: Maybe<TaxonomyDocument>;
  minimumSafeguards?: Maybe<Scalars['Boolean']['output']>;
  opEx?: Maybe<Scalars['Float']['output']>;
  opExCompleteLater: Scalars['Boolean']['output'];
  opExFile?: Maybe<TaxonomyDocument>;
  turnover?: Maybe<Scalars['Float']['output']>;
  turnoverCompleteLater: Scalars['Boolean']['output'];
  turnoverFile?: Maybe<TaxonomyDocument>;
};

export type TaxonomyCoreDataInput = {
  capEx?: InputMaybe<Scalars['Float']['input']>;
  capExCompleteLater?: Scalars['Boolean']['input'];
  capExFileId?: InputMaybe<Scalars['String']['input']>;
  capExShouldApply?: Scalars['Boolean']['input'];
  minimumSafeguards?: InputMaybe<Scalars['Boolean']['input']>;
  opEx?: InputMaybe<Scalars['Float']['input']>;
  opExCompleteLater?: Scalars['Boolean']['input'];
  opExFileId?: InputMaybe<Scalars['String']['input']>;
  opExShouldApply?: Scalars['Boolean']['input'];
  turnover?: InputMaybe<Scalars['Float']['input']>;
  turnoverCompleteLater?: Scalars['Boolean']['input'];
  turnoverFileId?: InputMaybe<Scalars['String']['input']>;
  turnoverShouldApply?: Scalars['Boolean']['input'];
};

/** taxonomyDocument */
export type TaxonomyDocument = {
  __typename?: 'TaxonomyDocument';
  _id: Scalars['ID']['output'];
  addedBy?: Maybe<User>;
  category: TaxonomyDocumentCategoryEnum;
  createdAt: Scalars['DateTime']['output'];
  dataPoint?: Maybe<TaxonomySectorActivity>;
  file: RepositoryFile;
  organization: Organization;
  project?: Maybe<TaxonomyProject>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Enum for the Taxonomy document category */
export enum TaxonomyDocumentCategoryEnum {
  CORE_DATA = 'CORE_DATA',
  DNSH = 'DNSH',
  GENERAL = 'GENERAL',
  MINIMUM_SAFEGUARDS = 'MINIMUM_SAFEGUARDS',
  SUBSTANTIAL_CONTRIBUTION = 'SUBSTANTIAL_CONTRIBUTION'
}

export type TaxonomyDocumentPaginatedDto = {
  __typename?: 'TaxonomyDocumentPaginatedDto';
  items: Array<TaxonomyDocument>;
  totalCount: Scalars['Float']['output'];
};

export type TaxonomyDocumentsDatesFiltersDto = {
  __typename?: 'TaxonomyDocumentsDatesFiltersDto';
  from?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type TaxonomyDocumentsFilterByInput = {
  criteria: Array<Scalars['String']['input']>;
  field: TaxonomyDocumentsFilterableFieldEnum;
};

/** Enum for filterable fields of taxonomy documents */
export enum TaxonomyDocumentsFilterableFieldEnum {
  ADDED_BY = 'ADDED_BY',
  CATEGORY = 'CATEGORY',
  DATA_POINT = 'DATA_POINT',
  DATE = 'DATE',
  PROJECT = 'PROJECT'
}

export type TaxonomyDocumentsFiltersDto = {
  __typename?: 'TaxonomyDocumentsFiltersDto';
  addedBy: Array<User>;
  dataPoints: Array<TaxonomySectorActivity>;
  dates: Array<TaxonomyDocumentsDatesFiltersDto>;
  projects: Array<TaxonomyProject>;
};

/** Enum for the Taxonomy fit #TaxonomyFitEnum */
export enum TaxonomyFitEnum {
  ALIGNED = 'ALIGNED',
  ELIGIBLE = 'ELIGIBLE',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE'
}

/** TaxonomyProject */
export type TaxonomyProject = {
  __typename?: 'TaxonomyProject';
  _id: Scalars['ID']['output'];
  assessments: Array<TaxonomyAssessment>;
  assignees: Array<User>;
  name: Scalars['String']['output'];
  organization: Organization;
};

/** TaxonomySector */
export type TaxonomySector = {
  __typename?: 'TaxonomySector';
  _id: Scalars['ID']['output'];
  activities: Array<TaxonomySectorActivity>;
  name: Scalars['String']['output'];
};

/** TaxonomySectorActivity */
export type TaxonomySectorActivity = {
  __typename?: 'TaxonomySectorActivity';
  _id: Scalars['ID']['output'];
  descriptions: Array<TaxonomySectorActivityDescription>;
  helpText: Scalars['String']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  objectives: Scalars['JSON']['output'];
  reportColumn: Scalars['String']['output'];
};

/** TaxonomySectorActivityDescription */
export type TaxonomySectorActivityDescription = {
  __typename?: 'TaxonomySectorActivityDescription';
  _id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  objective?: Maybe<TaxonomyAssessmentBusinessActivityObjectiveEnum>;
  value: Scalars['String']['output'];
};

export type UnapproveDataPointRequestInput = {
  dataPointRequestId: Scalars['String']['input'];
};

export type UnapproveDataPointRequestsInput = {
  dataPointRequestIds?: Array<Scalars['String']['input']>;
};

export type UpdateCategoryNameInput = {
  _id?: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateEntityAssignmentInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  subcategories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateEntityKpiInput = {
  _id?: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  comparisonOperator?: InputMaybe<ComparisonOperatorEnum>;
  comparisonValue?: InputMaybe<Scalars['Float']['input']>;
  comparisonValueType?: InputMaybe<ComparisonValueTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  startingDate?: InputMaybe<Scalars['DateTime']['input']>;
  startingValue?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EntityKpiStatusEnum>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEntityLocationInput = {
  _id?: Scalars['String']['input'];
  areCategoriesAppliedOnAllProjects?: InputMaybe<Scalars['Boolean']['input']>;
  areCustomCategoriesAppliedOnAllProjects?: InputMaybe<Scalars['Boolean']['input']>;
  name?: Scalars['String']['input'];
};

export type UpdateEntityNotificationSettingsInput = {
  _id?: Scalars['String']['input'];
  approvedDatapoints?: Scalars['Boolean']['input'];
  goals?: Scalars['Boolean']['input'];
  newProject?: Scalars['Boolean']['input'];
  openApprovals?: Scalars['Boolean']['input'];
  openDatapoints?: Scalars['Boolean']['input'];
  recommendationsVisibility?: Scalars['Boolean']['input'];
  rejectedDatapoints?: Scalars['Boolean']['input'];
  voluntaryVisibility?: Scalars['Boolean']['input'];
};

export type UpdateEntityReportingFrameworksInput = {
  _id?: Scalars['String']['input'];
  reportingFrameworks?: Array<ReportingFrameworkEnum>;
};

export type UpdateEntitySettingsInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  dashboardPinnedDataPointTypes?: InputMaybe<Array<UpdatePinnedDataPointTypeInput>>;
  industry?: InputMaybe<Scalars['String']['input']>;
  locationOfHeadquarter?: InputMaybe<Scalars['String']['input']>;
  nameOfHeadquarter?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<UpdateEntityNotificationSettingsInput>;
  numberOfEmployees?: InputMaybe<Scalars['String']['input']>;
  overviewPinnedDataPointTypes?: InputMaybe<Array<UpdatePinnedDataPointTypeInput>>;
  picture?: InputMaybe<Scalars['String']['input']>;
  reportingPeriods?: InputMaybe<Array<EntitySettingsReportingPeriodInput>>;
  requiredProofCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  sharePassword?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExternallyTaxonomyAssessmentBusinessActivityInput = {
  doesNotHarm?: InputMaybe<Scalars['Boolean']['input']>;
  doesNotHarmComment?: InputMaybe<Scalars['String']['input']>;
  doesNotHarmFileId?: InputMaybe<Scalars['String']['input']>;
  minimumStandardsRespected?: InputMaybe<Scalars['Boolean']['input']>;
  minimumStandardsRespectedComment?: InputMaybe<Scalars['String']['input']>;
  minimumStandardsRespectedFileId?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<TaxonomyAssessmentBusinessActivityObjectiveEnum>;
  objectiveComment?: InputMaybe<Scalars['String']['input']>;
  objectiveFileId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInsightInput = {
  _id?: Scalars['String']['input'];
  dataPointTypeAId?: Scalars['String']['input'];
  dataPointTypeBId?: Scalars['String']['input'];
  refreshInterval?: DataPointTypeRefreshIntervalEnum;
  targetAction?: DataPointTypeTargetActionEnum;
  title?: Scalars['String']['input'];
  type?: Scalars['String']['input'];
};

export type UpdatePinnedDataPointTypeInput = {
  dataPointType: Scalars['String']['input'];
};

export type UpdateRepositoryFileInput = {
  _id: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filesize: Scalars['Float']['input'];
  relatedProjects?: InputMaybe<Array<Scalars['String']['input']>>;
  relatedTopicSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  secretUpdateToken?: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpdateSubcategoryInput = {
  _id?: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTaxonomyAssessmentBusinessActivityDoesNotHarmInput = {
  adaptation: Scalars['Boolean']['input'];
  adaptationComment?: InputMaybe<Scalars['String']['input']>;
  adaptationFileId?: InputMaybe<Scalars['String']['input']>;
  biodiversity: Scalars['Boolean']['input'];
  biodiversityComment?: InputMaybe<Scalars['String']['input']>;
  biodiversityFileId?: InputMaybe<Scalars['String']['input']>;
  circular: Scalars['Boolean']['input'];
  circularComment?: InputMaybe<Scalars['String']['input']>;
  circularFileId?: InputMaybe<Scalars['String']['input']>;
  mitigation: Scalars['Boolean']['input'];
  mitigationComment?: InputMaybe<Scalars['String']['input']>;
  mitigationFileId?: InputMaybe<Scalars['String']['input']>;
  pollution: Scalars['Boolean']['input'];
  pollutionComment?: InputMaybe<Scalars['String']['input']>;
  pollutionFileId?: InputMaybe<Scalars['String']['input']>;
  water: Scalars['Boolean']['input'];
  waterComment?: InputMaybe<Scalars['String']['input']>;
  waterFileId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaxonomyAssessmentBusinessActivityInput = {
  activityCapex?: InputMaybe<Scalars['Float']['input']>;
  activityFit?: InputMaybe<Scalars['Float']['input']>;
  activityOpex?: InputMaybe<Scalars['Float']['input']>;
  activityTurnover?: InputMaybe<Scalars['Float']['input']>;
  doesNotHarm?: InputMaybe<UpdateTaxonomyAssessmentBusinessActivityDoesNotHarmInput>;
  minimumStandardsRespected?: InputMaybe<Scalars['Boolean']['input']>;
  minimumStandardsRespectedComment?: InputMaybe<Scalars['String']['input']>;
  minimumStandardsRespectedFileId?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<TaxonomyAssessmentBusinessActivityObjectiveEnum>;
  objectiveComment?: InputMaybe<Scalars['String']['input']>;
  objectiveFileId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaxonomyAssessmentDocumentInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['String']['input'];
};

export type UpdateTaxonomyAssessmentInput = {
  capex?: InputMaybe<Scalars['Float']['input']>;
  capexCompleteLater?: InputMaybe<Scalars['Boolean']['input']>;
  documents?: InputMaybe<Array<UpdateTaxonomyAssessmentDocumentInput>>;
  opex?: InputMaybe<Scalars['Float']['input']>;
  opexCompleteLater?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<TaxonomyAssessmentStatusEnum>;
  turnover?: InputMaybe<Scalars['Float']['input']>;
  turnoverCompleteLater?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTaxonomyProjectInput = {
  _id: Scalars['String']['input'];
  assignees?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  assignments?: InputMaybe<UserAssignmentInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  entities?: InputMaybe<Array<Scalars['String']['input']>>;
  entity?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  getStartedStepsCompleted?: InputMaybe<Array<GetStartedStatusEnum>>;
  jobDepartment?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<UserLanguageEnum>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingStatus?: InputMaybe<OnboardingStatusEnum>;
  picture?: InputMaybe<Scalars['String']['input']>;
  pinnedDataPointTypes?: InputMaybe<Array<PinnedDataPointTypeInput>>;
  role?: InputMaybe<UserRole>;
  sub?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertCustomQuestionnaireQuestionInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  allowUploadProof: Scalars['Boolean']['input'];
  extraOptions?: InputMaybe<UpsertCustomQuestionnaireQuestionOptionsInput>;
  frameworkGroup?: InputMaybe<Scalars['String']['input']>;
  frameworks: Array<ReportingFrameworkEnum>;
  question: Scalars['String']['input'];
  questionHelp: Scalars['String']['input'];
  refreshInterval: DataPointTypeRefreshIntervalEnum;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  type: ValueDataTypeEnum;
};

export type UpsertCustomQuestionnaireQuestionOptionsInput = {
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  unitGroup?: InputMaybe<DataPointTypeValueUnitEnum>;
  valueUnit?: InputMaybe<DataPointTypeValueUnitEnum>;
};

export type UpsertDataPointInput = {
  _id?: Scalars['String']['input'];
  dataPointTypeId?: Scalars['String']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  locationIds?: Array<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  type?: DataPoint_Type;
  value?: Scalars['JSON']['input'];
};

export type UpsertDataPointTypeInput = {
  _id?: Scalars['String']['input'];
  allowUploadProof?: Scalars['Boolean']['input'];
  category?: Scalars['String']['input'];
  emissionFactorCategory?: InputMaybe<Scalars['String']['input']>;
  emissionFactorSubcategory?: InputMaybe<Scalars['String']['input']>;
  emissionFactorType?: InputMaybe<DataPointTypeEmissionTypeEnum>;
  emissionFactors?: InputMaybe<Array<DataPointTypeEmissionFactorInput>>;
  frameworkGroup?: InputMaybe<Scalars['String']['input']>;
  frameworks?: InputMaybe<Array<ReportingFrameworkEnum>>;
  friendlyName?: Scalars['String']['input'];
  isGlobal?: Scalars['Boolean']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  name?: Scalars['String']['input'];
  question?: Scalars['String']['input'];
  questionHelp?: Scalars['String']['input'];
  refreshInterval?: DataPointTypeRefreshIntervalEnum;
  subcategory?: Scalars['String']['input'];
  valueDataType?: ValueDataTypeEnum;
  valueDataTypeOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  valueUnit?: InputMaybe<DataPointTypeValueUnitEnum>;
};

/** user */
export type User = {
  __typename?: 'User';
  _id: Scalars['ID']['output'];
  assignments: UserAssignment;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  entities: Array<Entity>;
  entity: Entity;
  firstLogin: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  getStartedStepsCompleted: Array<GetStartedStatusEnum>;
  invitedBy?: Maybe<User>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  jobDepartment: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  language: UserLanguageEnum;
  lastLogin: Scalars['DateTime']['output'];
  lastName: Scalars['String']['output'];
  onboardingStatus: OnboardingStatusEnum;
  phone: Scalars['String']['output'];
  picture?: Maybe<RepositoryFile>;
  pinnedDataPointTypes: Array<PinnedDataPointType>;
  role: UserRole;
  sub: Scalars['String']['output'];
  tosAcceptedAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UserAssignedDataPointRequestSubcategoryDto = {
  __typename?: 'UserAssignedDataPointRequestSubcategoryDto';
  location: EntityLocation;
  subcategory: Scalars['String']['output'];
};

/** UserAssignment */
export type UserAssignment = {
  __typename?: 'UserAssignment';
  _id: Scalars['ID']['output'];
  categories: Array<UserCategoryAssignment>;
  datapointtypes: Array<UserDataPointTypeAssignment>;
  doubleMateriality: Scalars['Boolean']['output'];
  subcategories: Array<UserSubcategoryAssignment>;
};

export type UserAssignmentInput = {
  categories?: InputMaybe<Array<UserCategoryAssignmentInput>>;
  datapointtypes?: InputMaybe<Array<UserDataPointTypesAssignmentInput>>;
  doubleMateriality?: InputMaybe<Scalars['Boolean']['input']>;
  subcategories?: InputMaybe<Array<UserSubCategoryAssignmentInput>>;
};

/** UserCategoryAssignment */
export type UserCategoryAssignment = {
  __typename?: 'UserCategoryAssignment';
  category: Scalars['String']['output'];
  location: EntityLocation;
  role: UserRole;
};

export type UserCategoryAssignmentInput = {
  category: Scalars['String']['input'];
  location: Scalars['String']['input'];
  role: UserRole;
};

export type UserCreatedAnalyticsDto = {
  __typename?: 'UserCreatedAnalyticsDto';
  _id: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  emails: Array<Scalars['String']['output']>;
  numberOfCreatedUsers: Scalars['Float']['output'];
};

/** UserDataPointTypeAssignment */
export type UserDataPointTypeAssignment = {
  __typename?: 'UserDataPointTypeAssignment';
  dataPointType: DataPointType;
  location: EntityLocation;
  role: UserRole;
};

export type UserDataPointTypesAssignmentInput = {
  dataPointType?: Scalars['String']['input'];
  location?: Scalars['String']['input'];
  role?: UserRole;
};

/** Enum for user language */
export enum UserLanguageEnum {
  DE = 'DE',
  EN = 'EN'
}

/** Enum for user role */
export enum UserRole {
  ADMIN = 'ADMIN',
  AUDITOR = 'AUDITOR',
  CONTRIBUTOR = 'CONTRIBUTOR',
  MANAGER = 'MANAGER',
  NONE = 'NONE',
  SUPERADMIN = 'SUPERADMIN'
}

export type UserSubCategoryAssignmentInput = {
  assigneeId?: Scalars['String']['input'];
  location: Scalars['String']['input'];
  role: UserRole;
  subcategory: Scalars['String']['input'];
};

/** UserSubcategoryAssignment */
export type UserSubcategoryAssignment = {
  __typename?: 'UserSubcategoryAssignment';
  location: EntityLocation;
  role: UserRole;
  subcategory: Scalars['String']['output'];
};

export type UserUpdateSubcategoryAssignmentsInput = {
  userSubcategoryAssignmentInputs?: Array<UserSubCategoryAssignmentInput>;
};

/** Enum for valuedatetype */
export enum ValueDataTypeEnum {
  BOOLEAN = 'BOOLEAN',
  BOOLEAN_UNSURE = 'BOOLEAN_UNSURE',
  CHOICE = 'CHOICE',
  COUNTRY = 'COUNTRY',
  DATE = 'DATE',
  DATE_RANGE = 'DATE_RANGE',
  EMISSIONS_SPLIT = 'EMISSIONS_SPLIT',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  MULTIPLE_COUNTRIES = 'MULTIPLE_COUNTRIES',
  NUMERIC = 'NUMERIC',
  NUMERIC_SPLIT = 'NUMERIC_SPLIT',
  TEXT = 'TEXT',
  TEXT_LONG = 'TEXT_LONG',
  TEXT_SPLIT = 'TEXT_SPLIT',
  UPLOAD = 'UPLOAD',
  USER_ASSIGNATION = 'USER_ASSIGNATION'
}

export type CompleteCustomQuestionnaireMutationVariables = Exact<{
  customQuestionnaireId: Scalars['String']['input'];
}>;


export type CompleteCustomQuestionnaireMutation = { __typename?: 'Mutation', completeCustomQuestionnaire: { __typename?: 'CustomQuestionnaire', _id: string, category?: { __typename?: 'DataPointCategory', _id: string, slug: string } | null, subcategory?: { __typename?: 'DataPointSubcategory', _id: string, slug: string } | null } };

export type CreateCustomQuestionnaireMutationVariables = Exact<{
  customQuestionnaireData: CreateCustomQuestionnaireInput;
}>;


export type CreateCustomQuestionnaireMutation = { __typename?: 'Mutation', createCustomQuestionnaire: { __typename?: 'CustomQuestionnaire', _id: string } };

export type DeleteCustomQuestionnaireQuestionMutationVariables = Exact<{
  customQuestionnaireId: Scalars['String']['input'];
  customQuestionnaireQuestionId: Scalars['String']['input'];
}>;


export type DeleteCustomQuestionnaireQuestionMutation = { __typename?: 'Mutation', deleteCustomQuestionnaireQuestion: number };

export type SetCustomQuestionnaireNameMutationVariables = Exact<{
  customQuestionnaireId: Scalars['String']['input'];
  inputData: SetQuestionnaireNameInput;
}>;


export type SetCustomQuestionnaireNameMutation = { __typename?: 'Mutation', setQuestionnaireName: { __typename?: 'CustomQuestionnaire', _id: string } };

export type StartCustomQuestionnaireFileProcessingMutationVariables = Exact<{
  customQuestionnaireId: Scalars['String']['input'];
}>;


export type StartCustomQuestionnaireFileProcessingMutation = { __typename?: 'Mutation', startFileProcessing: CustomQuestionnaireStatus };

export type UploadQuestionsJsonMutationVariables = Exact<{
  customQuestionnaireId: Scalars['String']['input'];
  questions: Scalars['String']['input'];
}>;


export type UploadQuestionsJsonMutation = { __typename?: 'Mutation', uploadQuestionsJSON: { __typename?: 'CustomQuestionnaire', _id: string, status: CustomQuestionnaireStatus } };

export type UpsertCustomQuestionnaireQuestionMutationVariables = Exact<{
  customQuestionnaireId: Scalars['String']['input'];
  questionData: UpsertCustomQuestionnaireQuestionInput;
}>;


export type UpsertCustomQuestionnaireQuestionMutation = { __typename?: 'Mutation', upsertCustomQuestionnaireQuestion: { __typename?: 'CustomQuestionnaireQuestion', _id: string } };

export type UpsertDataPointMutationVariables = Exact<{
  upsertDataPointInput: UpsertDataPointInput;
}>;


export type UpsertDataPointMutation = { __typename?: 'Mutation', upsertDataPoint: { __typename?: 'DataPoint', _id: string, value?: any | null } };

export type CreateDataPointCustomCategoryMutationVariables = Exact<{
  createCategoryInput: CreateCategoryInput;
}>;


export type CreateDataPointCustomCategoryMutation = { __typename?: 'Mutation', createDataPointCustomCategory: { __typename?: 'DataPointCategory', _id: string } };

export type CreateDataPointCustomSubcategoriesMutationVariables = Exact<{
  categoryId: Scalars['String']['input'];
  subcategoryNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateDataPointCustomSubcategoriesMutation = { __typename?: 'Mutation', createDataPointCustomSubcategories: { __typename?: 'DataPointCategory', _id: string } };

export type DeleteDataPointCustomCategoriesMutationVariables = Exact<{
  categoryIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteDataPointCustomCategoriesMutation = { __typename?: 'Mutation', deleteDataPointCustomCategories: Array<string> };

export type DeleteDataPointCustomSubcategoriesMutationVariables = Exact<{
  categoryId: Scalars['String']['input'];
  subcategoryIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteDataPointCustomSubcategoriesMutation = { __typename?: 'Mutation', deleteDataPointCustomSubcategories: { __typename?: 'DataPointCategory', _id: string } };

export type UpdateDataPointCustomCategoryNameMutationVariables = Exact<{
  input: UpdateCategoryNameInput;
}>;


export type UpdateDataPointCustomCategoryNameMutation = { __typename?: 'Mutation', updateDataPointCustomCategoryName: { __typename?: 'DataPointCategory', _id: string } };

export type UpdateDataPointCustomSubcategoriesMutationVariables = Exact<{
  categoryId: Scalars['String']['input'];
  subcategories: Array<UpdateSubcategoryInput> | UpdateSubcategoryInput;
}>;


export type UpdateDataPointCustomSubcategoriesMutation = { __typename?: 'Mutation', updateDataPointCustomSubcategories: { __typename?: 'DataPointCategory', _id: string } };

export type AnswerDataPointRequestMutationVariables = Exact<{
  answerDataPointRequestDto: AnswerDataPointRequestInput;
}>;


export type AnswerDataPointRequestMutation = { __typename?: 'Mutation', answerDataPointRequest: { __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, displayStatus: DataPointRequestStatusEnum, value?: any | null, originalValue?: any | null, dueDate?: any | null, comment?: string | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, emissionFactor?: number | null, emissionFactorCountry?: string | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, childs: Array<{ __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, originalValue?: any | null, status: DataPointRequestStatusEnum, displayStatus: DataPointRequestStatusEnum, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, question: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', subcategory: string } }> } };

export type AnswerDelegatedDataPointRequestMutationVariables = Exact<{
  answerDataPointRequestDto: AnswerDataPointRequestInput;
  delegationEmailAddress: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
}>;


export type AnswerDelegatedDataPointRequestMutation = { __typename?: 'Mutation', answerDelegatedDataPointRequest: { __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, displayStatus: DataPointRequestStatusEnum, value?: any | null, originalValue?: any | null, dueDate?: any | null, comment?: string | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, emissionFactor?: number | null, emissionFactorCountry?: string | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, childs: Array<{ __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, originalValue?: any | null, status: DataPointRequestStatusEnum, displayStatus: DataPointRequestStatusEnum, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, question: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', subcategory: string } }> } };

export type ApproveDataPointRequestMutationVariables = Exact<{
  approveDataPointRequestInput: ApproveDataPointRequestInput;
}>;


export type ApproveDataPointRequestMutation = { __typename?: 'Mutation', approveDataPointRequest: { __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum } };

export type ApproveDataPointRequestsMutationVariables = Exact<{
  approveDataPointRequestsInput: ApproveDataPointRequestsInput;
}>;


export type ApproveDataPointRequestsMutation = { __typename?: 'Mutation', approveDataPointRequests: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum }> };

export type CreateDataPointRequestChatCommentMutationVariables = Exact<{
  createDataPointRequestChatCommentInput: CreateDataPointRequestChatCommentInput;
}>;


export type CreateDataPointRequestChatCommentMutation = { __typename?: 'Mutation', createDataPointRequestChatComment: { __typename?: 'DataPointRequest', _id: string, chatComments?: Array<{ __typename?: 'Comment', _id: string, text: string, updatedAt: any, user: { __typename?: 'User', _id: string, email: string, firstName: string, lastName: string } }> | null } };

export type DelegateDataPointRequestsMutationVariables = Exact<{
  delegateDataPointRequestsInput: DelegateDataPointRequestsInput;
  emailAddresses: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DelegateDataPointRequestsMutation = { __typename?: 'Mutation', delegateDataPointRequests: Array<{ __typename?: 'DataPointRequest', _id: string, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string, shareToken: string, user: { __typename?: 'User', _id: string, email: string }, reminder?: { __typename?: 'Reminder', _id: string, sendAt: any } | null }> | null }> };

export type DeleteDataPointRequestMutationVariables = Exact<{
  dataPointRequestId: Scalars['String']['input'];
}>;


export type DeleteDataPointRequestMutation = { __typename?: 'Mutation', deleteDataPointRequest: number };

export type DeleteDataPointRequestDelegationMutationVariables = Exact<{
  dataPointRequestId: Scalars['String']['input'];
}>;


export type DeleteDataPointRequestDelegationMutation = { __typename?: 'Mutation', deleteDataPointRequestDelegation: { __typename?: 'DataPointRequest', _id: string, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string }> | null } };

export type DeleteDataPointRequestsMutationVariables = Exact<{
  deleteDataPointRequestsInput: DeleteDataPointRequestsInput;
}>;


export type DeleteDataPointRequestsMutation = { __typename?: 'Mutation', deleteDataPointRequests: number };

export type DeleteDataPointTypeMutationVariables = Exact<{
  dataPointTypeId: Scalars['String']['input'];
}>;


export type DeleteDataPointTypeMutation = { __typename?: 'Mutation', deleteDataPointType: number };

export type FollowDataPointRequestMutationVariables = Exact<{
  dataPointRequestId: Scalars['String']['input'];
}>;


export type FollowDataPointRequestMutation = { __typename?: 'Mutation', followDataPointRequest: { __typename?: 'DataPointRequest', _id: string, followers: Array<{ __typename?: 'User', _id: string }> } };

export type RejectDataPointRequestMutationVariables = Exact<{
  rejectDataPointRequestInput: RejectDataPointRequestInput;
}>;


export type RejectDataPointRequestMutation = { __typename?: 'Mutation', rejectDataPointRequest: { __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null } };

export type RejectDataPointRequestsMutationVariables = Exact<{
  rejectDataPointRequestsInput: RejectDataPointRequestsInput;
}>;


export type RejectDataPointRequestsMutation = { __typename?: 'Mutation', rejectDataPointRequests: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null }> };

export type RequestReopenDataPointRequestMutationVariables = Exact<{
  reopenRequestedDataPointRequestInput: ReopenRequestedDataPointRequestInput;
}>;


export type RequestReopenDataPointRequestMutation = { __typename?: 'Mutation', requestReopenDataPointRequest: { __typename?: 'DataPointRequest', _id: string, isReopenRequestPending?: boolean | null, childs: Array<{ __typename?: 'DataPointRequest', _id: string }> } };

export type ResetDataPointRequestMutationVariables = Exact<{
  dataPointRequestId: Scalars['String']['input'];
}>;


export type ResetDataPointRequestMutation = { __typename?: 'Mutation', resetDataPointRequest: { __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, value?: any | null, displayStatus: DataPointRequestStatusEnum, originalValue?: any | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, emissionFactor?: number | null, emissionFactorCountry?: string | null }> | null } };

export type UnapproveDataPointRequestMutationVariables = Exact<{
  unapproveDataPointRequestInput: UnapproveDataPointRequestInput;
}>;


export type UnapproveDataPointRequestMutation = { __typename?: 'Mutation', unapproveDataPointRequest: { __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, displayStatus: DataPointRequestStatusEnum, childs: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, displayStatus: DataPointRequestStatusEnum }> } };

export type UnapproveDataPointRequestsMutationVariables = Exact<{
  unapproveDataPointRequestsInput: UnapproveDataPointRequestsInput;
}>;


export type UnapproveDataPointRequestsMutation = { __typename?: 'Mutation', unapproveDataPointRequests: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, displayStatus: DataPointRequestStatusEnum, childs: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, displayStatus: DataPointRequestStatusEnum }> }> };

export type UnfollowDataPointRequestMutationVariables = Exact<{
  dataPointRequestId: Scalars['String']['input'];
}>;


export type UnfollowDataPointRequestMutation = { __typename?: 'Mutation', unfollowDataPointRequest: { __typename?: 'DataPointRequest', _id: string, followers: Array<{ __typename?: 'User', _id: string }> } };

export type CreateInsightMutationVariables = Exact<{
  createInsightInput: CreateInsightInput;
}>;


export type CreateInsightMutation = { __typename?: 'Mutation', createInsight: { __typename?: 'DataPointType', _id: string, name: string, question: string, refreshInterval: DataPointTypeRefreshIntervalEnum, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null }>, entity?: { __typename?: 'Entity', _id: string } | null } };

export type DeleteInsightMutationVariables = Exact<{
  deleteInsightInput: DeleteInsightInput;
}>;


export type DeleteInsightMutation = { __typename?: 'Mutation', deleteInsight: number };

export type SuspendDataPointTypeByEntityMutationVariables = Exact<{
  dataPointTypeId: Scalars['String']['input'];
}>;


export type SuspendDataPointTypeByEntityMutation = { __typename?: 'Mutation', suspendDataPointTypeByEntity: Array<{ __typename?: 'EntityLocation', _id: string }> };

export type SuspendDataPointTypeByLocationMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  dataPointTypeId: Scalars['String']['input'];
}>;


export type SuspendDataPointTypeByLocationMutation = { __typename?: 'Mutation', suspendDataPointTypeByLocation: { __typename?: 'EntityLocation', _id: string } };

export type UnsuspendDataPointTypeByEntityMutationVariables = Exact<{
  dataPointTypeId: Scalars['String']['input'];
}>;


export type UnsuspendDataPointTypeByEntityMutation = { __typename?: 'Mutation', unsuspendDataPointTypeByEntity: Array<{ __typename?: 'EntityLocation', _id: string }> };

export type UnsuspendDataPointTypeByLocationMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  dataPointTypeId: Scalars['String']['input'];
}>;


export type UnsuspendDataPointTypeByLocationMutation = { __typename?: 'Mutation', unsuspendDataPointTypeByLocation: { __typename?: 'EntityLocation', _id: string } };

export type UpdateInsightMutationVariables = Exact<{
  updateInsightInput: UpdateInsightInput;
}>;


export type UpdateInsightMutation = { __typename?: 'Mutation', updateInsight: { __typename?: 'DataPointType', _id: string, name: string, question: string, refreshInterval: DataPointTypeRefreshIntervalEnum, targetAction?: DataPointTypeTargetActionEnum | null, formular: string, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string }> } };

export type UpsertDataPointTypeMutationVariables = Exact<{
  upsertDataPointTypeInput: UpsertDataPointTypeInput;
}>;


export type UpsertDataPointTypeMutation = { __typename?: 'Mutation', upsertDataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string, name: string, question: string, questionHelp: string, refreshInterval: DataPointTypeRefreshIntervalEnum, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, valueUnit?: DataPointTypeValueUnitEnum | null, emissionSubcategory?: string | null, allowUploadProof: boolean, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, factor: number }>, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }> } };

export type DoubleMaterialitySendSurveysMutationVariables = Exact<{
  doubleMaterialityId: Scalars['String']['input'];
  sendSurveys: Array<SendSurveyInput> | SendSurveyInput;
}>;


export type DoubleMaterialitySendSurveysMutation = { __typename?: 'Mutation', sendSurveys: number };

export type ValidateDoubleMaterialitySurveyParticipantShareTokenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
}>;


export type ValidateDoubleMaterialitySurveyParticipantShareTokenMutation = { __typename?: 'Mutation', validateDoubleMaterialitySurveyParticipantShareToken: boolean };

export type RemindUsersAdminMutationVariables = Exact<{
  type: RemindUsersAdminType;
  _id: Scalars['String']['input'];
}>;


export type RemindUsersAdminMutation = { __typename?: 'Mutation', remindUsersAdmin: number };

export type UpdateEntityMutationVariables = Exact<{
  entityInput: EntityInput;
}>;


export type UpdateEntityMutation = { __typename?: 'Mutation', updateEntity: { __typename?: 'Entity', _id: string, name?: string | null } };

export type UpdateEntityReportingFrameworksMutationVariables = Exact<{
  updateEntityReportingFrameworksInput: UpdateEntityReportingFrameworksInput;
}>;


export type UpdateEntityReportingFrameworksMutation = { __typename?: 'Mutation', updateEntityReportingFrameworks: { __typename?: 'Entity', _id: string, reportingFrameworks: Array<ReportingFrameworkEnum> } };

export type ToggleCategoriesMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  enable: Array<Scalars['String']['input']> | Scalars['String']['input'];
  disable: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ToggleCategoriesMutation = { __typename?: 'Mutation', toggleCategories: { __typename?: 'EntityLocation', _id: string, assignments: { __typename?: 'EntityAssignment', _id: string, categories: Array<{ __typename?: 'EntityCategoryAssignment', _id: string, category: string, isEnabled?: boolean | null }> } } };

export type UpdateEntityAssignmentMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  updateEntityAssignmentInput: Array<UpdateEntityAssignmentInput> | UpdateEntityAssignmentInput;
}>;


export type UpdateEntityAssignmentMutation = { __typename?: 'Mutation', updateEntityAssignment: { __typename?: 'EntityLocation', _id: string, assignments: { __typename?: 'EntityAssignment', _id: string, categories: Array<{ __typename?: 'EntityCategoryAssignment', _id: string, category: string }> } } };

export type CreateEntityKpiMutationVariables = Exact<{
  createEntityKPIInputs: Array<CreateEntityKpiInput> | CreateEntityKpiInput;
}>;


export type CreateEntityKpiMutation = { __typename?: 'Mutation', createEntityKPI: Array<{ __typename?: 'EntityKPI', _id: string, description: string, startingDate: any, dueDate: any, comparisonValue: number, comparisonOperator: ComparisonOperatorEnum, comparisonValueType: ComparisonValueTypeEnum, status: EntityKpiStatusEnum, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, question: string }, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string }, targets: Array<{ __typename?: 'Target', _id: string, name: string, number?: string | null, goal: { __typename?: 'Goal', _id: string, name: string, number: number, description: string } }> }> };

export type CreateEntityKpiCommentMutationVariables = Exact<{
  createEntityKPICommentInput: CreateEntityKpiCommentInput;
}>;


export type CreateEntityKpiCommentMutation = { __typename?: 'Mutation', createEntityKPIComment: { __typename?: 'Comment', _id: string } };

export type DeleteEntityKpiMutationVariables = Exact<{
  deleteEntityKPIInput: DeleteEntityKpiInput;
}>;


export type DeleteEntityKpiMutation = { __typename?: 'Mutation', deleteEntityKPI: { __typename?: 'EntityKPI', _id: string } };

export type UpdateEntityKpiMutationVariables = Exact<{
  updateEntityKPIInput: UpdateEntityKpiInput;
}>;


export type UpdateEntityKpiMutation = { __typename?: 'Mutation', updateEntityKPI: { __typename?: 'EntityKPI', _id: string, comparisonValue: number, comparisonOperator: ComparisonOperatorEnum, comparisonValueType: ComparisonValueTypeEnum, startingDate: any, dueDate: any, status: EntityKpiStatusEnum, user: { __typename?: 'User', _id: string }, dataPointType: { __typename?: 'DataPointType', _id: string } } };

export type AddDataPointTypeOverrideMutationVariables = Exact<{
  dataPointTypeOverrideInput: DataPointTypeOverrideInput;
  entityLocationInput: EntityLocationInput;
}>;


export type AddDataPointTypeOverrideMutation = { __typename?: 'Mutation', addDataPointTypeOverride: { __typename?: 'EntityLocation', _id: string, name: string, overrides: Array<{ __typename?: 'EntityLocationOverride', _id: string, refreshInterval?: DataPointTypeRefreshIntervalEnum | null, valueUnit?: DataPointTypeValueUnitEnum | null, isSplit: boolean, customConversionFactor?: number | null, datapointtype: { __typename?: 'DataPointType', _id: string }, tags?: Array<{ __typename?: 'Tag', _id: string, name: string, color: TagColorEnum, entity: { __typename?: 'Entity', _id: string } }> | null, guidanceComments: Array<{ __typename?: 'Comment', _id: string, text: string, createdAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } }> }> } };

export type AddDataPointTypeOverrideByEntityMutationVariables = Exact<{
  dataPointTypeOverrideInput: DataPointTypeOverrideInput;
}>;


export type AddDataPointTypeOverrideByEntityMutation = { __typename?: 'Mutation', addDataPointTypeOverrideByEntity: Array<{ __typename?: 'EntityLocation', _id: string, name: string, overrides: Array<{ __typename?: 'EntityLocationOverride', _id: string, refreshInterval?: DataPointTypeRefreshIntervalEnum | null, valueUnit?: DataPointTypeValueUnitEnum | null, isSplit: boolean, customConversionFactor?: number | null, datapointtype: { __typename?: 'DataPointType', _id: string }, tags?: Array<{ __typename?: 'Tag', _id: string, name: string, color: TagColorEnum, entity: { __typename?: 'Entity', _id: string } }> | null, guidanceComments: Array<{ __typename?: 'Comment', _id: string, text: string, createdAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } }> }> }> };

export type CreateEntityLocationMutationVariables = Exact<{
  createEntityLocationInput: CreateEntityLocationInput;
}>;


export type CreateEntityLocationMutation = { __typename?: 'Mutation', createEntityLocation: Array<{ __typename?: 'EntityLocation', _id: string, name: string }> };

export type DeleteEntityLocationMutationVariables = Exact<{
  deleteEntityLocationInput: DeleteEntityLocationInput;
}>;


export type DeleteEntityLocationMutation = { __typename?: 'Mutation', deleteEntityLocation: number };

export type GenerateDataPointRequestsForPastDatesMutationVariables = Exact<{
  pastDatesInput: PastDatesInput;
  projectId: Scalars['String']['input'];
  dataPointTypeId: Scalars['String']['input'];
}>;


export type GenerateDataPointRequestsForPastDatesMutation = { __typename?: 'Mutation', generateDataPointRequestsForPastDates: Array<{ __typename?: 'DataPointRequest', _id: string }> };

export type UpdateEntityLocationMutationVariables = Exact<{
  updateEntityLocationInput: UpdateEntityLocationInput;
}>;


export type UpdateEntityLocationMutation = { __typename?: 'Mutation', updateEntityLocation: { __typename?: 'EntityLocation', _id: string, name: string, isHeadquarters: boolean, areCategoriesAppliedOnAllProjects?: boolean | null, areCustomCategoriesAppliedOnAllProjects?: boolean | null } };

export type UpdateEntitySettingsMutationVariables = Exact<{
  updateEntitySettingsInput: UpdateEntitySettingsInput;
}>;


export type UpdateEntitySettingsMutation = { __typename?: 'Mutation', updateEntitySettings: { __typename?: 'EntitySettings', _id: string, companyName: string, industry: string, locationOfHeadquarter: string, nameOfHeadquarter: string, numberOfEmployees: string, dashboardPinnedDataPointTypes: Array<{ __typename?: 'AdminSettingsPinnedDataPointType', _id: string, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, defaultChartType: string, valueUnit?: DataPointTypeValueUnitEnum | null, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }> } }>, overviewPinnedDataPointTypes: Array<{ __typename?: 'AdminSettingsPinnedDataPointType', _id: string, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, defaultChartType: string, valueUnit?: DataPointTypeValueUnitEnum | null, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }> } }>, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } };

export type RequestHelpMutationVariables = Exact<{
  message: Scalars['String']['input'];
  phoneOrEmail: Scalars['String']['input'];
  type: HelpTypeEnum;
}>;


export type RequestHelpMutation = { __typename?: 'Mutation', requestHelp: boolean };

export type RequestHelpForExternalTaxonomyMutationVariables = Exact<{
  email: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
}>;


export type RequestHelpForExternalTaxonomyMutation = { __typename?: 'Mutation', requestHelpForExternalTaxonomy: boolean };

export type UpdateOrganizationMutationVariables = Exact<{
  organizationInput: OrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', _id: string, name: string } };

export type UpdateTaxonomyCoreDataMutationVariables = Exact<{
  input: TaxonomyCoreDataInput;
}>;


export type UpdateTaxonomyCoreDataMutation = { __typename?: 'Mutation', updateTaxonomyCoreData: { __typename?: 'TaxonomyCoreData', _id: string, turnover?: number | null, turnoverCompleteLater: boolean, capEx?: number | null, capExCompleteLater: boolean, opEx?: number | null, opExCompleteLater: boolean, minimumSafeguards?: boolean | null, turnoverFile?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string, downloadUrl: string } } | null, capExFile?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string, downloadUrl: string } } | null, opExFile?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string, downloadUrl: string } } | null } };

export type AddRatingToRecommendationMutationVariables = Exact<{
  recommendationId: Scalars['String']['input'];
  rating: Scalars['Float']['input'];
}>;


export type AddRatingToRecommendationMutation = { __typename?: 'Mutation', addRatingToRecommendation: { __typename?: 'Recommendation', _id: string, averageRating: number } };

export type AddUserToRecommendationMutationVariables = Exact<{
  recommendationId: Scalars['String']['input'];
}>;


export type AddUserToRecommendationMutation = { __typename?: 'Mutation', addUserToRecommendation: { __typename?: 'Recommendation', _id: string, utilizationCount: number } };

export type AddRepositoryFileMetadataMutationVariables = Exact<{
  repositoryFile: UpdateRepositoryFileInput;
}>;


export type AddRepositoryFileMetadataMutation = { __typename?: 'Mutation', addFileMetadata: { __typename?: 'RepositoryFile', _id: string } };

export type DeleteRepositoryFileMutationVariables = Exact<{
  repositoryFileId: Scalars['String']['input'];
}>;


export type DeleteRepositoryFileMutation = { __typename?: 'Mutation', deleteRepositoryFile: { __typename?: 'RepositoryFile', _id: string } };

export type GenerateFileDownloadTokenMutationVariables = Exact<{
  repositoryFileId: Scalars['String']['input'];
  repositoryFileType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateFileDownloadTokenMutation = { __typename?: 'Mutation', generateFileDownloadToken: string };

export type GenerateFileUploadTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateFileUploadTokenMutation = { __typename?: 'Mutation', generateFileUploadToken: { __typename?: 'RepositoryFile', _id: string, preSignedUrl: string, secretUpdateToken: string } };

export type GenerateFileUploadTokenExternalMutationVariables = Exact<{
  entityId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateFileUploadTokenExternalMutation = { __typename?: 'Mutation', generateFileUploadTokenExternal: { __typename?: 'RepositoryFile', _id: string, preSignedUrl: string, secretUpdateToken: string } };

export type GenerateQuestionnaireFileUploadTokenMutationVariables = Exact<{
  customQuestionnaireId: Scalars['String']['input'];
}>;


export type GenerateQuestionnaireFileUploadTokenMutation = { __typename?: 'Mutation', generateQuestionnaireFileUploadToken: { __typename?: 'RepositoryFile', _id: string, preSignedUrl: string, secretUpdateToken: string } };

export type UploadFileMutationVariables = Exact<{
  csvContent: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadCsvForHistoricImport: Array<{ __typename?: 'DataPoint', _id: string, from?: any | null, to?: any | null, value?: any | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, valueDataType: ValueDataTypeEnum, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataTypeOptions?: any | null }, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null }> };

export type UploadedFileForReviewMutationVariables = Exact<{
  repositoryFileId: Scalars['String']['input'];
  projectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  topics: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UploadedFileForReviewMutation = { __typename?: 'Mutation', uploadedFileForReview: string };

export type UpdateRestrictionMutationVariables = Exact<{
  restrictionInput: RestrictionInput;
}>;


export type UpdateRestrictionMutation = { __typename?: 'Mutation', updateRestriction: { __typename?: 'Restriction', _id: string, numberOfQuestionnaires: number, restrictedFeatures: Array<RestrictionsFeaturesEnum> } };

export type CreateTaxonomyAssessmentMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type CreateTaxonomyAssessmentMutation = { __typename?: 'Mutation', createTaxonomyAssessment: { __typename?: 'TaxonomyAssessment', _id: string } };

export type CreateTaxonomyProjectMutationVariables = Exact<{
  createTaxonomyProjectInput: CreateTaxonomyProjectInput;
}>;


export type CreateTaxonomyProjectMutation = { __typename?: 'Mutation', createTaxonomyProject: { __typename?: 'TaxonomyProject', _id: string, name: string, assignees: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string }> } };

export type DelegateTaxonomyAssessmentsMutationVariables = Exact<{
  assessmentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
}>;


export type DelegateTaxonomyAssessmentsMutation = { __typename?: 'Mutation', delegateTaxonomyAssessments: Array<{ __typename?: 'TaxonomyAssessment', _id: string, delegation?: { __typename?: 'TaxonomyAssessmentDelegation', _id: string, email: string } | null }> };

export type DelegateTaxonomyBusinessActivityMutationVariables = Exact<{
  assessmentId: Scalars['String']['input'];
  businessActivityId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  data: DelegateTaxonomyAssessmentBusinessActivityInput;
}>;


export type DelegateTaxonomyBusinessActivityMutation = { __typename?: 'Mutation', delegateBusinessActivity: { __typename?: 'TaxonomyBusinessActivity', _id: string, substantialContributionDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, doesNotHarm: { __typename?: 'DoesNotHarm', adaptationDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, biodiversityDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, circularDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, mitigationDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, pollutionDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, waterDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null }, minimumStandardsDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null } };

export type DeleteTaxonomyProjectMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeleteTaxonomyProjectMutation = { __typename?: 'Mutation', deleteTaxonomyProject: number };

export type UpdateExternallyTaxonomyAssessmentBusinessActivityMutationVariables = Exact<{
  email: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
  input: UpdateExternallyTaxonomyAssessmentBusinessActivityInput;
}>;


export type UpdateExternallyTaxonomyAssessmentBusinessActivityMutation = { __typename?: 'Mutation', updateExternallyTaxonomyAssessmentBusinessActivity: boolean };

export type UpdateTaxonomyAssessmentMutationVariables = Exact<{
  assessmentId: Scalars['String']['input'];
  input: UpdateTaxonomyAssessmentInput;
}>;


export type UpdateTaxonomyAssessmentMutation = { __typename?: 'Mutation', updateTaxonomyAssessment: { __typename?: 'TaxonomyAssessment', _id: string, turnover: number, turnoverCompleteLater: boolean, capex: number, capexCompleteLater: boolean, opex: number, opexCompleteLater: boolean, status: string, businessActivities: Array<{ __typename?: 'TaxonomyBusinessActivity', _id: string, activityFit: number, activityTurnover: number, minimumStandardsRespected?: boolean | null, doesNotHarm: { __typename?: 'DoesNotHarm', circular?: boolean | null, adaptation?: boolean | null, mitigation?: boolean | null, pollution?: boolean | null, biodiversity?: boolean | null, water?: boolean | null } }> } };

export type UpdateTaxonomyAssessmentActivitiesMutationVariables = Exact<{
  assessmentId: Scalars['String']['input'];
  activityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateTaxonomyAssessmentActivitiesMutation = { __typename?: 'Mutation', updateTaxonomyAssessmentActivities: { __typename?: 'TaxonomyAssessment', _id: string, businessActivities: Array<{ __typename?: 'TaxonomyBusinessActivity', _id: string, activity: { __typename?: 'TaxonomySectorActivity', _id: string, name: string, number: string } }> } };

export type UpdateTaxonomyAssessmentBusinessActivityMutationVariables = Exact<{
  assessmentId: Scalars['String']['input'];
  businessActivityId: Scalars['String']['input'];
  input: UpdateTaxonomyAssessmentBusinessActivityInput;
}>;


export type UpdateTaxonomyAssessmentBusinessActivityMutation = { __typename?: 'Mutation', updateTaxonomyAssessmentBusinessActivity: { __typename?: 'TaxonomyBusinessActivity', _id: string, activityTurnover: number, activityCapex: number, activityOpex: number, activityFit: number, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, isObjectiveAnswered: boolean, objectiveComment?: string | null, minimumStandardsRespected?: boolean | null, minimumStandardsRespectedComment?: string | null, objectiveDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, doesNotHarm: { __typename?: 'DoesNotHarm', _id: string, water?: boolean | null, waterComment?: string | null, biodiversity?: boolean | null, biodiversityComment?: string | null, pollution?: boolean | null, pollutionComment?: string | null, adaptation?: boolean | null, adaptationComment?: string | null, mitigation?: boolean | null, mitigationComment?: string | null, circular?: boolean | null, circularComment?: string | null, waterDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, waterDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, biodiversityDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, biodiversityDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, pollutionDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, pollutionDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, adaptationDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, adaptationDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, mitigationDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, mitigationDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, circularDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, circularDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null }, minimumStandardsRespectedDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, minimumStandardsDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, substantialContributionDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null } };

export type UpdateTaxonomyAssessmentSectorsMutationVariables = Exact<{
  assessmentId: Scalars['String']['input'];
  sectorIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateTaxonomyAssessmentSectorsMutation = { __typename?: 'Mutation', updateTaxonomyAssessmentSectors: { __typename?: 'TaxonomyAssessment', _id: string, sectors: Array<{ __typename?: 'TaxonomySector', _id: string, name: string }>, businessActivities: Array<{ __typename?: 'TaxonomyBusinessActivity', _id: string }> } };

export type UpdateTaxonomyProjectMutationVariables = Exact<{
  updateTaxonomyProjectInput: UpdateTaxonomyProjectInput;
}>;


export type UpdateTaxonomyProjectMutation = { __typename?: 'Mutation', updateTaxonomyProject: { __typename?: 'TaxonomyProject', _id: string, name: string, assignees: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string }> } };

export type DeleteTaxonomyDocumentMutationVariables = Exact<{
  taxonomyDocumentId: Scalars['String']['input'];
}>;


export type DeleteTaxonomyDocumentMutation = { __typename?: 'Mutation', deleteTaxonomyDocument: number };

export type ValidateBusinessActivityShareTokenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
}>;


export type ValidateBusinessActivityShareTokenMutation = { __typename?: 'Mutation', validateBusinessActivityShareToken: boolean };

export type AddEntityToUsersMutationVariables = Exact<{
  usersIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  entityId: Scalars['String']['input'];
}>;


export type AddEntityToUsersMutation = { __typename?: 'Mutation', addEntityToUsers: Array<{ __typename?: 'User', _id: string, email: string, entities: Array<{ __typename?: 'Entity', _id: string }> }> };

export type AssignUsersToDoubleMaterialityMutationVariables = Exact<{
  userIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AssignUsersToDoubleMaterialityMutation = { __typename?: 'Mutation', assignUserToDoubleMateriality: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, jobTitle: string, jobDepartment: string, email: string, role: UserRole, language: UserLanguageEnum, assignments: { __typename?: 'UserAssignment', _id: string, doubleMateriality: boolean }, entities: Array<{ __typename?: 'Entity', _id: string, name?: string | null }>, invitedBy?: { __typename?: 'User', _id: string } | null }> };

export type CreateUserMutationVariables = Exact<{
  createUserInput: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', _id: string, firstName: string, lastName: string, jobTitle: string, jobDepartment: string, email: string, role: UserRole, language: UserLanguageEnum, assignments: { __typename?: 'UserAssignment', _id: string, doubleMateriality: boolean }, entities: Array<{ __typename?: 'Entity', _id: string, name?: string | null }>, invitedBy?: { __typename?: 'User', _id: string } | null } };

export type DisableUserMutationVariables = Exact<{
  disableUserInput: DisableUserInput;
}>;


export type DisableUserMutation = { __typename?: 'Mutation', disableUser: { __typename?: 'User', _id: string, role: UserRole, email: string } };

export type ReassignSuperadminMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type ReassignSuperadminMutation = { __typename?: 'Mutation', reassignSuperadmin: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, role: UserRole } };

export type SignUpMutationVariables = Exact<{
  signupInput: SignupInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signup: { __typename?: 'User', _id: string, firstName: string, lastName: string, jobTitle: string, jobDepartment: string, email: string, phone: string, role: UserRole, onboardingStatus: OnboardingStatusEnum, getStartedStepsCompleted: Array<GetStartedStatusEnum>, entity: { __typename?: 'Entity', _id: string } } };

export type UpdatePinnedDataPointTypesMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdatePinnedDataPointTypesMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', _id: string, pinnedDataPointTypes: Array<{ __typename?: 'PinnedDataPointType', _id: string, entity: { __typename?: 'Entity', _id: string }, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, defaultChartType: string, valueUnit?: DataPointTypeValueUnitEnum | null, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }> } }> } };

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', _id: string, firstName: string, lastName: string, jobTitle: string, jobDepartment: string, email: string, role: UserRole, language: UserLanguageEnum, onboardingStatus: OnboardingStatusEnum, getStartedStepsCompleted: Array<GetStartedStatusEnum>, assignments: { __typename?: 'UserAssignment', _id: string, doubleMateriality: boolean }, invitedBy?: { __typename?: 'User', _id: string } | null, entities: Array<{ __typename?: 'Entity', _id: string, name?: string | null }>, picture?: { __typename?: 'RepositoryFile', _id: string } | null } };

export type UpdateUserSubcategoryAssignmentsMutationVariables = Exact<{
  subcategoryAssignments: UserUpdateSubcategoryAssignmentsInput;
}>;


export type UpdateUserSubcategoryAssignmentsMutation = { __typename?: 'Mutation', updateSubcategoryAssignments: number };

export type CreateEntityMutationVariables = Exact<{
  entityInput: EntityInput;
}>;


export type CreateEntityMutation = { __typename?: 'Mutation', createEntity: { __typename?: 'Entity', _id: string, name?: string | null } };

export type DeleteEntityMutationVariables = Exact<{
  entityInput: EntityInput;
}>;


export type DeleteEntityMutation = { __typename?: 'Mutation', deleteEntity: { __typename?: 'Entity', _id: string } };

export type RequestCo2ReportMutationVariables = Exact<{
  entityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RequestCo2ReportMutation = { __typename?: 'Mutation', requestCO2Report: { __typename?: 'User', _id: string } };

export type RequestCustomReportMutationVariables = Exact<{
  locationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  format: Scalars['String']['input'];
  fileId?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestCustomReportMutation = { __typename?: 'Mutation', requestCustomReport: { __typename?: 'User', _id: string } };

export type RequestEsgReportMutationVariables = Exact<{
  entityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RequestEsgReportMutation = { __typename?: 'Mutation', requestEsgReport: { __typename?: 'User', _id: string } };

export type RequestSupportMutationVariables = Exact<{
  requestSupportInput: RequestSupportInput;
}>;


export type RequestSupportMutation = { __typename?: 'Mutation', requestSupport: { __typename?: 'User', _id: string } };

export type AtEmissionSplitInputQueryVariables = Exact<{
  emissionSubcategory?: InputMaybe<Scalars['String']['input']>;
}>;


export type AtEmissionSplitInputQuery = { __typename?: 'Query', getEmissionFactorSuggestions: Array<{ __typename?: 'EmissionFactorSuggestion', _id: string, key: string, name: string, valueUnit: DataPointTypeValueUnitEnum, country?: string | null, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }> }> };

export type GetUserRepositoryFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRepositoryFilesQuery = { __typename?: 'Query', getUserRepositoryFiles: Array<{ __typename?: 'RepositoryFile', _id: string, filename: string }> };

export type SuggestionQueryVariables = Exact<{ [key: string]: never; }>;


export type SuggestionQuery = { __typename?: 'Query', getTeamUsers: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, entities: Array<{ __typename?: 'Entity', _id: string }> }> };

export type UsePinChartQueryVariables = Exact<{ [key: string]: never; }>;


export type UsePinChartQuery = { __typename?: 'Query', getOwnUser: { __typename?: 'User', _id: string, pinnedDataPointTypes: Array<{ __typename?: 'PinnedDataPointType', _id: string, entity: { __typename?: 'Entity', _id: string }, dataPointType: { __typename?: 'DataPointType', _id: string } }> } };

export type UsePinChartAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type UsePinChartAdminQuery = { __typename?: 'Query', getOwnUser: { __typename?: 'User', _id: string, entity: { __typename?: 'Entity', _id: string, entitySettings: { __typename?: 'EntitySettings', _id: string, dashboardPinnedDataPointTypes: Array<{ __typename?: 'AdminSettingsPinnedDataPointType', _id: string, dataPointType: { __typename?: 'DataPointType', _id: string } }>, overviewPinnedDataPointTypes: Array<{ __typename?: 'AdminSettingsPinnedDataPointType', _id: string, dataPointType: { __typename?: 'DataPointType', _id: string } }> } } } };

export type OgCreateEntityModalQueryVariables = Exact<{ [key: string]: never; }>;


export type OgCreateEntityModalQuery = { __typename?: 'Query', getAllTeamsUsers: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, entities: Array<{ __typename?: 'Entity', _id: string }> }> };

export type OgDataPointTypeSelectQueryVariables = Exact<{
  withActiveReportingFramework?: InputMaybe<Scalars['Boolean']['input']>;
  withExistingDataPoints?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OgDataPointTypeSelectQuery = { __typename?: 'Query', getCategoriesWithSubcategories: Array<{ __typename?: 'DataPointCategory', _id: string, slug: string, entity?: { __typename?: 'Entity', _id: string } | null, location?: { __typename?: 'EntityLocation', _id: string } | null, organization?: { __typename?: 'Organization', _id: string } | null, subcategories: Array<{ __typename?: 'DataPointSubcategory', _id: string, slug: string, orderPosition: number }> }>, getNumericDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, friendlyName: string, name: string, question: string, valueDataType: ValueDataTypeEnum, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, entity?: { __typename?: 'Entity', _id: string } | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null } }> };

export type OgDateRangePickerQueryVariables = Exact<{ [key: string]: never; }>;


export type OgDateRangePickerQuery = { __typename?: 'Query', getOwnUser: { __typename?: 'User', _id: string, entity: { __typename?: 'Entity', _id: string, entitySettings: { __typename?: 'EntitySettings', _id: string, activeReportingPeriod: { __typename?: 'EntityReportingPeriod', _id: string, from: any, to: any } } } } };

export type PgExternalDoubleMaterialitySurveyAnswerQueryVariables = Exact<{
  email: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
}>;


export type PgExternalDoubleMaterialitySurveyAnswerQuery = { __typename?: 'Query', getExternallyDoubleMateriality: { __typename?: 'DoubleMaterialityExternallyDto', doubleMaterialityId: string, surveyId: string, userLanguage: UserLanguageEnum, organizationName: string } };

export type OgDoubleMaterialityLayoutQueryVariables = Exact<{ [key: string]: never; }>;


export type OgDoubleMaterialityLayoutQuery = { __typename?: 'Query', getOrCreateDoubleMateriality: { __typename?: 'DoubleMateriality', _id: string } };

export type DownloadDmaResultExcelQueryVariables = Exact<{
  data: Scalars['String']['input'];
}>;


export type DownloadDmaResultExcelQuery = { __typename?: 'Query', downloadDMAResultExcel: string };

export type OgRecommendedEsrsQueryVariables = Exact<{ [key: string]: never; }>;


export type OgRecommendedEsrsQuery = { __typename?: 'Query', getDataPointCategoriesForDoubleMateriality: Array<{ __typename?: 'DataPointCategory', _id: string, name: string, slug: string, doubleMaterialityTopic?: { __typename?: 'DoubleMaterialityTopic', _id: string } | null, subcategories: Array<{ __typename?: 'DataPointSubcategory', _id: string, name: string, slug: string, doubleMaterialityMandatoryReason?: DoubleMaterialityMandatoryReason | null }> }> };

export type PgDoubleMaterialityTeamQueryVariables = Exact<{
  allTeamsUsers: Scalars['Boolean']['input'];
}>;


export type PgDoubleMaterialityTeamQuery = { __typename?: 'Query', getTeamUsers: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, jobTitle: string, jobDepartment: string, email: string, role: UserRole, language: UserLanguageEnum, assignments: { __typename?: 'UserAssignment', _id: string, doubleMateriality: boolean }, entities: Array<{ __typename?: 'Entity', _id: string, name?: string | null }>, invitedBy?: { __typename?: 'User', _id: string } | null }>, getAllTeamsUsers?: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, jobTitle: string, jobDepartment: string, email: string, role: UserRole, language: UserLanguageEnum, assignments: { __typename?: 'UserAssignment', _id: string, doubleMateriality: boolean }, entities: Array<{ __typename?: 'Entity', _id: string, name?: string | null }>, invitedBy?: { __typename?: 'User', _id: string } | null }> };

export type DoubleMaterialityTeamUserFieldsFragment = { __typename?: 'User', _id: string, firstName: string, lastName: string, jobTitle: string, jobDepartment: string, email: string, role: UserRole, language: UserLanguageEnum, assignments: { __typename?: 'UserAssignment', _id: string, doubleMateriality: boolean }, entities: Array<{ __typename?: 'Entity', _id: string, name?: string | null }>, invitedBy?: { __typename?: 'User', _id: string } | null };

export type DoubleMaterialityDocumentDownloadQueryVariables = Exact<{
  file: DoubleMaterialityDownloadDocumentEnum;
}>;


export type DoubleMaterialityDocumentDownloadQuery = { __typename?: 'Query', downloadDoubleMaterialityDocument: { __typename?: 'DoubleMaterialityDownloadDocumentDto', file: string, name: string, type: string } };

export type PgDoubleMaterialitySelectionQueryVariables = Exact<{ [key: string]: never; }>;


export type PgDoubleMaterialitySelectionQuery = { __typename?: 'Query', getDoubleMaterialityTopics: Array<{ __typename?: 'DoubleMaterialityTopic', _id: string, esrs: string, topic: string, subTopics: Array<{ __typename?: 'DoubleMaterialityTopicSubTopic', subTopic: string, subSubTopics: Array<string> }> }>, getDataPointCategoriesForDoubleMateriality: Array<{ __typename?: 'DataPointCategory', _id: string, name: string, doubleMaterialityTopic?: { __typename?: 'DoubleMaterialityTopic', _id: string } | null, subcategories: Array<{ __typename?: 'DataPointSubcategory', _id: string, name: string, doubleMaterialityMandatoryReason?: DoubleMaterialityMandatoryReason | null }> }> };

export type TmSectorActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type TmSectorActivitiesQuery = { __typename?: 'Query', getTaxonomySectors: Array<{ __typename?: 'TaxonomySector', _id: string, name: string, activities: Array<{ __typename?: 'TaxonomySectorActivity', _id: string, name: string, number: string }> }> };

export type PgTaxonomyAssessmentFinaliseQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type PgTaxonomyAssessmentFinaliseQuery = { __typename?: 'Query', getTaxonomyProject: { __typename?: 'TaxonomyProject', _id: string, name: string, assessments: Array<{ __typename?: 'TaxonomyAssessment', _id: string, status: string, turnover: number, turnoverCompleteLater: boolean, capex: number, capexCompleteLater: boolean, opex: number, opexCompleteLater: boolean, alignedTurnover: number, eligibleTurnover: number, nonEligibleTurnover: number, alignedCapex: number, eligibleCapex: number, nonEligibleCapex: number, alignedOpex: number, eligibleOpex: number, nonEligibleOpex: number, businessActivities: Array<{ __typename?: 'TaxonomyBusinessActivity', _id: string, activityTurnover: number, activityOpex: number, activityCapex: number, activityFit: number, alignedTurnover: number, eligibleTurnover: number, alignedCapex: number, eligibleCapex: number, alignedOpex: number, eligibleOpex: number, minimumStandardsRespected?: boolean | null, activity: { __typename?: 'TaxonomySectorActivity', _id: string, number: string, name: string } }> }> } };

export type OgForwardingDialogQueryVariables = Exact<{ [key: string]: never; }>;


export type OgForwardingDialogQuery = { __typename?: 'Query', getTeamUsers: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, email: string }> };

export type PgTaxonomyAssessmentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PgTaxonomyAssessmentQuery = { __typename?: 'Query', getTaxonomyAssessment: { __typename?: 'TaxonomyAssessment', _id: string, status: string, turnover: number, turnoverCompleteLater: boolean, capex: number, capexCompleteLater: boolean, opex: number, opexCompleteLater: boolean, project: { __typename?: 'TaxonomyProject', _id: string, name: string }, sectors: Array<{ __typename?: 'TaxonomySector', _id: string, name: string }>, documents: Array<{ __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string, downloadUrl: string, filesize: number } }>, businessActivities: Array<{ __typename?: 'TaxonomyBusinessActivity', _id: string, activityTurnover: number, activityCapex: number, activityOpex: number, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, isObjectiveAnswered: boolean, objectiveComment?: string | null, activityFit: number, minimumStandardsRespected?: boolean | null, minimumStandardsRespectedComment?: string | null, objectiveDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, minimumStandardsRespectedDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, minimumStandardsDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, activity: { __typename?: 'TaxonomySectorActivity', _id: string, number: string, name: string, descriptions: Array<{ __typename?: 'TaxonomySectorActivityDescription', _id: string, key: string, value: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null }> }, doesNotHarm: { __typename?: 'DoesNotHarm', _id: string, circular?: boolean | null, circularComment?: string | null, adaptation?: boolean | null, adaptationComment?: string | null, mitigation?: boolean | null, mitigationComment?: string | null, pollution?: boolean | null, pollutionComment?: string | null, biodiversity?: boolean | null, biodiversityComment?: string | null, water?: boolean | null, waterComment?: string | null, circularDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, circularDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, adaptationDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, adaptationDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, mitigationDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, mitigationDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, pollutionDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, pollutionDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, biodiversityDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, biodiversityDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null, waterDocument?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string } } | null, waterDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null }, substantialContributionDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string, shareToken: string, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } } | null }> }, getOwnUser: { __typename?: 'User', _id: string, entity: { __typename?: 'Entity', _id: string, organization?: { __typename?: 'Organization', _id: string, taxonomyCoreData?: { __typename?: 'TaxonomyCoreData', _id: string, minimumSafeguards?: boolean | null } | null } | null } } };

export type PgExternalTaxonomyAssessmentAnswerQueryVariables = Exact<{
  email: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
}>;


export type PgExternalTaxonomyAssessmentAnswerQuery = { __typename?: 'Query', getTaxonomyBusinessActivityDelegation: { __typename?: 'TaxonomyBusinessActivityDelegationDto', type: TaxonomyBusinessActivityDelegationTypeEnum, userId: string, projectName: string, activityName: string, objective: TaxonomyAssessmentBusinessActivityObjectiveEnum, objectiveDescription?: string | null } };

export type PgDataRoomQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: PaginationLimitEnum;
  sortBy: Scalars['String']['input'];
  sortOrder: PaginationSortingEnum;
  filterBy: Array<TaxonomyDocumentsFilterByInput> | TaxonomyDocumentsFilterByInput;
}>;


export type PgDataRoomQuery = { __typename?: 'Query', getTaxonomyDocuments: { __typename?: 'TaxonomyDocumentPaginatedDto', totalCount: number, items: Array<{ __typename?: 'TaxonomyDocument', _id: string, category: TaxonomyDocumentCategoryEnum, updatedAt: any, addedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } | null, project?: { __typename?: 'TaxonomyProject', _id: string, name: string } | null, file: { __typename?: 'RepositoryFile', _id: string, filename: string, downloadUrl: string }, dataPoint?: { __typename?: 'TaxonomySectorActivity', _id: string, name: string } | null }> } };

export type PgDataRoomFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type PgDataRoomFiltersQuery = { __typename?: 'Query', getTaxonomyDocumentsFilters: { __typename?: 'TaxonomyDocumentsFiltersDto', projects: Array<{ __typename?: 'TaxonomyProject', _id: string, name: string }>, addedBy: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string }>, dates: Array<{ __typename?: 'TaxonomyDocumentsDatesFiltersDto', from?: any | null, to?: any | null }>, dataPoints: Array<{ __typename?: 'TaxonomySectorActivity', _id: string, name: string }> } };

export type PgTaxonomyOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type PgTaxonomyOverviewQuery = { __typename?: 'Query', getTaxonomyProjects: Array<{ __typename?: 'TaxonomyProject', _id: string, name: string, assignees: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string }>, assessments: Array<{ __typename?: 'TaxonomyAssessment', _id: string, status: string, turnover: number, alignedTurnover: number, eligibleTurnover: number, nonEligibleTurnover: number, capex: number, alignedCapex: number, eligibleCapex: number, nonEligibleCapex: number, opex: number, alignedOpex: number, eligibleOpex: number, nonEligibleOpex: number, updatedAt: any, businessActivities: Array<{ __typename?: 'TaxonomyBusinessActivity', _id: string, activityTurnover: number, activityFit: number, alignedTurnover: number, eligibleTurnover: number, minimumStandardsRespected?: boolean | null, activity: { __typename?: 'TaxonomySectorActivity', _id: string, number: string, name: string } }> }> }> };

export type MlTaxonomyProjectModalQueryVariables = Exact<{ [key: string]: never; }>;


export type MlTaxonomyProjectModalQuery = { __typename?: 'Query', getTeamUsers: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string }> };

export type OgCoreDataDialogQueryVariables = Exact<{ [key: string]: never; }>;


export type OgCoreDataDialogQuery = { __typename?: 'Query', getTaxonomyCoreData: { __typename?: 'TaxonomyCoreData', _id: string, turnover?: number | null, turnoverCompleteLater: boolean, capEx?: number | null, capExCompleteLater: boolean, opEx?: number | null, opExCompleteLater: boolean, minimumSafeguards?: boolean | null, turnoverFile?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string, downloadUrl: string } } | null, capExFile?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string, downloadUrl: string } } | null, opExFile?: { __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string, downloadUrl: string } } | null } };

export type PgTaxonomyProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type PgTaxonomyProjectsQuery = { __typename?: 'Query', getTaxonomyProjects: Array<{ __typename?: 'TaxonomyProject', _id: string, name: string, assignees: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string }>, assessments: Array<{ __typename?: 'TaxonomyAssessment', _id: string, status: string, updatedAt: any, turnover: number, turnoverCompleteLater: boolean, alignedTurnover: number, eligibleTurnover: number, nonEligibleTurnover: number, capexCompleteLater: boolean, opexCompleteLater: boolean, documents: Array<{ __typename?: 'TaxonomyDocument', _id: string, file: { __typename?: 'RepositoryFile', _id: string, filename: string, downloadUrl: string, filesize: number } }>, businessActivities: Array<{ __typename?: 'TaxonomyBusinessActivity', _id: string, taxonomyFit: TaxonomyFitEnum, activityTurnover: number, eligibleTurnover: number, alignedTurnover: number, objective?: TaxonomyAssessmentBusinessActivityObjectiveEnum | null, minimumStandardsRespected?: boolean | null, activity: { __typename?: 'TaxonomySectorActivity', _id: string, name: string }, substantialContributionDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string } | null, minimumStandardsDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string } | null, doesNotHarm: { __typename?: 'DoesNotHarm', _id: string, adaptation?: boolean | null, mitigation?: boolean | null, water?: boolean | null, circular?: boolean | null, pollution?: boolean | null, biodiversity?: boolean | null, adaptationDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string } | null, mitigationDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string } | null, waterDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string } | null, circularDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string } | null, pollutionDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string } | null, biodiversityDelegation?: { __typename?: 'TaxonomyBusinessActivityDelegation', _id: string } | null } }> }> }> };

export type PgTaxonomyResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type PgTaxonomyResultsQuery = { __typename?: 'Query', getTaxonomyProjects: Array<{ __typename?: 'TaxonomyProject', _id: string, name: string, assessments: Array<{ __typename?: 'TaxonomyAssessment', _id: string, status: string, turnover: number, turnoverCompleteLater: boolean, capex: number, capexCompleteLater: boolean, opex: number, opexCompleteLater: boolean, alignedTurnover: number, eligibleTurnover: number, nonEligibleTurnover: number, alignedCapex: number, eligibleCapex: number, nonEligibleCapex: number, alignedOpex: number, eligibleOpex: number, nonEligibleOpex: number, businessActivities: Array<{ __typename?: 'TaxonomyBusinessActivity', _id: string, activityTurnover: number, activityOpex: number, activityCapex: number, activityFit: number, alignedTurnover: number, eligibleTurnover: number, alignedCapex: number, eligibleCapex: number, alignedOpex: number, eligibleOpex: number, minimumStandardsRespected?: boolean | null, activity: { __typename?: 'TaxonomySectorActivity', _id: string, number: string, name: string } }> }> }> };

export type TaxonomyProjectSpreadsheetsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type TaxonomyProjectSpreadsheetsQuery = { __typename?: 'Query', getTaxonomyProjectSpreadsheets: string };

export type TmDashboardQueryVariables = Exact<{
  adminMode: Scalars['Boolean']['input'];
  isExternal: Scalars['Boolean']['input'];
  entityId?: InputMaybe<Scalars['String']['input']>;
  shareToken?: InputMaybe<Scalars['String']['input']>;
  sharePassword?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type TmDashboardQuery = { __typename?: 'Query', getReportingProgress?: Array<{ __typename?: 'DataPointRequestReportingProgressDto', pending: number, open: number, accepted: number, rejected: number, overDue: number, total: number, entity: { __typename?: 'Entity', _id: string, name?: string | null, entitySettings: { __typename?: 'EntitySettings', _id: string, companyName: string } }, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, getEmissions?: Array<{ __typename?: 'EmissionsDto', _id: string, scope: DataPointTypeEmissionTypeEnum, category: string, value: number }>, getEmissionsExternal?: Array<{ __typename?: 'EmissionsDto', _id: string, scope: DataPointTypeEmissionTypeEnum, category: string, value: number }>, getReportingProgressExternal?: Array<{ __typename?: 'DataPointRequestReportingProgressDto', pending: number, open: number, accepted: number, rejected: number, overDue: number, total: number, entity: { __typename?: 'Entity', _id: string, name?: string | null, entitySettings: { __typename?: 'EntitySettings', _id: string, companyName: string } }, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, getAvailableDataPointsGroupedByType: Array<{ __typename?: 'DataPoint', _id: string, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, summarizingMethod?: SummarizingMethodEnum | null, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, category?: string | null, subcategory?: string | null }> } }> };

export type EmissionsFragmentFragment = { __typename?: 'EmissionsDto', _id: string, scope: DataPointTypeEmissionTypeEnum, category: string, value: number };

export type ReportingProgressFragmentFragment = { __typename?: 'DataPointRequestReportingProgressDto', pending: number, open: number, accepted: number, rejected: number, overDue: number, total: number, entity: { __typename?: 'Entity', _id: string, name?: string | null, entitySettings: { __typename?: 'EntitySettings', _id: string, companyName: string } }, location: { __typename?: 'EntityLocation', _id: string, name: string } };

export type TmDashboardChartSelectionQueryVariables = Exact<{
  dataPointTypeNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  type: Scalars['String']['input'];
  allEntities?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TmDashboardChartSelectionQuery = { __typename?: 'Query', getEsgDataPointsLength: number, getAdminDataPointsByType: Array<{ __typename?: 'DataPoint', _id: string, value?: any | null, from?: any | null, to?: any | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, summarizingMethod?: SummarizingMethodEnum | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, framework: ReportingFrameworkEnum, groups: Array<string> }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }> } }>, getCurrentUserEntities: Array<{ __typename?: 'Entity', _id: string, name?: string | null, entitySettings: { __typename?: 'EntitySettings', _id: string, companyName: string, dashboardPinnedDataPointTypes: Array<{ __typename?: 'AdminSettingsPinnedDataPointType', _id: string, dataPointType: { __typename?: 'DataPointType', friendlyName: string, name: string, _id: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, summarizingMethod?: SummarizingMethodEnum | null } }> }, kpis: Array<{ __typename?: 'EntityKPI', _id: string, startingDate: any, comparisonValue: number, comparisonValueType: ComparisonValueTypeEnum, comparisonOperator: ComparisonOperatorEnum, dueDate: any, dataPointType: { __typename?: 'DataPointType', _id: string } }>, locations: Array<{ __typename?: 'EntityLocation', _id: string, name: string }> }>, getCurrentEntity: { __typename?: 'Entity', _id: string, entitySettings: { __typename?: 'EntitySettings', _id: string, companyName: string, dashboardPinnedDataPointTypes: Array<{ __typename?: 'AdminSettingsPinnedDataPointType', _id: string, dataPointType: { __typename?: 'DataPointType', friendlyName: string, name: string, _id: string } }> }, kpis: Array<{ __typename?: 'EntityKPI', _id: string, startingDate: any, comparisonValue: number, comparisonValueType: ComparisonValueTypeEnum, comparisonOperator: ComparisonOperatorEnum, dueDate: any, dataPointType: { __typename?: 'DataPointType', _id: string } }>, locations: Array<{ __typename?: 'EntityLocation', _id: string, name: string }> }, getPinnedDataPointsAdmin: Array<{ __typename?: 'GroupedDataPoint', value?: any | null, from?: any | null, to?: any | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, summarizingMethod?: SummarizingMethodEnum | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, framework: ReportingFrameworkEnum, groups: Array<string> }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, category?: string | null, subcategory?: string | null }> } }> };

export type TmDashboardShareModalQueryVariables = Exact<{ [key: string]: never; }>;


export type TmDashboardShareModalQuery = { __typename?: 'Query', getCurrentEntity: { __typename?: 'Entity', _id: string, entitySettings: { __typename?: 'EntitySettings', _id: string, shareToken: string, sharePassword: string } } };

export type TmDashboardStatisticsQueryVariables = Exact<{
  isExternal: Scalars['Boolean']['input'];
  adminMode: Scalars['Boolean']['input'];
  entityId?: InputMaybe<Scalars['String']['input']>;
  shareToken?: InputMaybe<Scalars['String']['input']>;
  sharePassword?: InputMaybe<Scalars['String']['input']>;
}>;


export type TmDashboardStatisticsQuery = { __typename?: 'Query', getNumberOfUsers?: number, getNumberOfUsersExternal?: number, getNumberOfEntities?: number, getNumberOfEntitiesExternal?: number, getNumberOfLocations?: number, getNumberOfLocationsExternal?: number, getNumberOfEntityKpis?: number, getNumberOfEntityKpisExternal?: number };

export type AdminCo2XlsxExportQueryVariables = Exact<{
  entityIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
}>;


export type AdminCo2XlsxExportQuery = { __typename?: 'Query', getDatapointsAsXlsxAdmin: string };

export type AdminRawReportQueryVariables = Exact<{
  entityIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  reportingFrameworks?: InputMaybe<Array<ReportingFrameworkEnum> | ReportingFrameworkEnum>;
}>;


export type AdminRawReportQuery = { __typename?: 'Query', getDataPointsEncodedReport: string };

export type OgReportRequestModalQueryVariables = Exact<{ [key: string]: never; }>;


export type OgReportRequestModalQuery = { __typename?: 'Query', getProjectsAdmin: Array<{ __typename?: 'EntityLocation', _id: string, name: string }> };

export type TmReportsQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type TmReportsQuery = { __typename?: 'Query', getOrganizationQuestionnaires: Array<{ __typename?: 'CustomQuestionnaire', _id: string, name: string, entity: { __typename?: 'Entity', _id: string, name?: string | null }, category?: { __typename?: 'DataPointCategory', _id: string } | null }>, getReportingProgress: Array<{ __typename?: 'DataPointRequestReportingProgressDto', pending: number, open: number, accepted: number, rejected: number, overDue: number, total: number, entity: { __typename?: 'Entity', _id: string, name?: string | null }, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, getOwnUser: { __typename?: 'User', _id: string, entity: { __typename?: 'Entity', _id: string, reportingFrameworks: Array<ReportingFrameworkEnum>, entitySettings: { __typename?: 'EntitySettings', _id: string, companyName: string } } } };

export type TmReportsCarboneReportQueryVariables = Exact<{
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  locationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type TmReportsCarboneReportQuery = { __typename?: 'Query', getSingleProjectExport: string };

export type TmReportsCustomQuestionnaireQueryVariables = Exact<{
  dataPointCategoryId: Scalars['String']['input'];
}>;


export type TmReportsCustomQuestionnaireQuery = { __typename?: 'Query', getLocationsForCustomCategory: Array<{ __typename?: 'EntityLocation', _id: string, name: string }> };

export type TmReportsPdfReportQueryVariables = Exact<{
  reportTypes?: InputMaybe<Array<PdfReportTypeEnum> | PdfReportTypeEnum>;
  workspaceIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
}>;


export type TmReportsPdfReportQuery = { __typename?: 'Query', downloadPDFReport: string };

export type PgNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type PgNotificationSettingsQuery = { __typename?: 'Query', getCurrentEntitySettings: { __typename?: 'EntitySettings', _id: string, companyName: string, requiredProofCategories: Array<string>, notificationSettings: { __typename?: 'EntityNotificationSettings', _id: string, rejectedDatapoints: boolean, approvedDatapoints: boolean, openDatapoints: boolean, openApprovals: boolean, goals: boolean, newProject: boolean, recommendationsVisibility: boolean, voluntaryVisibility: boolean } }, getCategories: Array<{ __typename?: 'DataPointCategory', _id: string, slug: string, name: string }> };

export type SettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsQuery = { __typename?: 'Query', getOwnUser: { __typename?: 'User', _id: string, entity: { __typename?: 'Entity', _id: string, reportingFrameworks: Array<ReportingFrameworkEnum>, entitySettings: { __typename?: 'EntitySettings', _id: string, companyName: string, industry: string, locationOfHeadquarter: string, nameOfHeadquarter: string, numberOfEmployees: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null, reportingPeriods: Array<{ __typename?: 'EntityReportingPeriod', _id: string, from: any, to: any, deadline: any, status: EntityReportingPeriodStatusEnum }> }, locations: Array<{ __typename?: 'EntityLocation', _id: string, isHeadquarters: boolean }> } } };

export type TmSettingsEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type TmSettingsEntitiesQuery = { __typename?: 'Query', getCurrentUserEntities: Array<{ __typename?: 'Entity', _id: string, name?: string | null }> };

export type PgAnalyticsDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type PgAnalyticsDashboardQuery = { __typename?: 'Query', getUserCreatedAnalytics: Array<{ __typename?: 'UserCreatedAnalyticsDto', numberOfCreatedUsers: number, date: any }>, getDatapointsCreatedAnalytics: Array<{ __typename?: 'DatapointsCreatedAnalyticsDto', numberOfCreatedDatapoints: number, date: any }>, getDataPointRequestAnalytics: Array<{ __typename?: 'DataPointRequestAnalyticsDto', numberOfNonOpenDataPointsRequests: number, date: any }>, getEntityLocationAnalytics: Array<{ __typename?: 'EntityLocationAnalyticsDto', numberOfCreatedProjects: number, date: any }> };

export type TmPendingDataPointRequestsQueryVariables = Exact<{
  status: DataPointRequestStatusEnum;
  offset: Scalars['Int']['input'];
  limit: PaginationLimitEnum;
  sortBy: Scalars['String']['input'];
  sortOrder: PaginationSortingEnum;
  searchBy: Scalars['String']['input'];
  filterBy: Array<DataPointRequestFilterByInput> | DataPointRequestFilterByInput;
}>;


export type TmPendingDataPointRequestsQuery = { __typename?: 'Query', getCategories: Array<{ __typename?: 'DataPointCategory', _id: string, slug: string }>, getPaginatedApprovalDataPointRequests: { __typename?: 'DataPointRequestPaginatedDto', totalCount: number, items: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, value?: any | null, displayValue?: any | null, displayValueUnit?: DataPointTypeValueUnitEnum | null, comment?: string | null, dueDate?: any | null, from?: any | null, to?: any | null, rejectReason: string, createdAt: any, updatedAt: any, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', user: { __typename?: 'User', _id: string, email: string } }> | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string, filesize: number } | null, assignee?: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string } | null, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string }, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, refreshInterval: DataPointTypeRefreshIntervalEnum, question: string, valueDataType: ValueDataTypeEnum, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataTypeOptions?: any | null, questionHelp: string, summarizingMethod?: SummarizingMethodEnum | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, framework: ReportingFrameworkEnum, groups: Array<string> }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }> } }> } };

export type TmPendingDataPointRequestsRecentlyApprovedQueryVariables = Exact<{
  dataPointTypeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;


export type TmPendingDataPointRequestsRecentlyApprovedQuery = { __typename?: 'Query', getDataPointsByTypeAndLocation: Array<{ __typename?: 'DataPoint', _id: string, value?: any | null, displayValue?: any | null, displayValueUnit?: DataPointTypeValueUnitEnum | null, from?: any | null, to?: any | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null }> | null, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, summarizingMethod?: SummarizingMethodEnum | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null } } }> };

export type TmPendingDataPointRequestsFiltersQueryVariables = Exact<{
  status: DataPointRequestStatusEnum;
}>;


export type TmPendingDataPointRequestsFiltersQuery = { __typename?: 'Query', getApprovalDataPointRequestsFilters: { __typename?: 'DataPointRequestFiltersDto', categories: Array<string>, assignees: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string }>, dataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, friendlyName: string }>, locations: Array<{ __typename?: 'EntityLocation', _id: string, name: string }>, subcategories: Array<{ __typename?: 'DataPointRequestSubcategoriesFilterDto', category: string, subcategory: string }>, periods: Array<{ __typename?: 'DataPointRequestPeriodFiltersDto', from?: any | null, to?: any | null }> } };

export type PgDataEntryUploadQueryVariables = Exact<{ [key: string]: never; }>;


export type PgDataEntryUploadQuery = { __typename?: 'Query', entityLocationSummaries: Array<{ __typename?: 'EntityLocationSummaryDto', _id: string, name: string }> };

export type PgExternalDataEntryQueryVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
  statusFilter?: InputMaybe<DataPointRequestStatusEnum>;
}>;


export type PgExternalDataEntryQuery = { __typename?: 'Query', getCurrentExternalUserId: string, getDelegatedDataPointRequests: Array<{ __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, comment?: string | null, status: DataPointRequestStatusEnum, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null, isHistoric?: boolean | null, isReopenRequestPending?: boolean | null, updatedAt: any, displayStatus: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectReason: string, parent?: { __typename?: 'DataPointRequest', _id: string } | null, override?: { __typename?: 'EntityLocationOverride', _id: string, refreshInterval?: DataPointTypeRefreshIntervalEnum | null, valueUnit?: DataPointTypeValueUnitEnum | null, isSplit: boolean, datapointtype: { __typename?: 'DataPointType', _id: string, order: number }, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }> } | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, entity: { __typename?: 'Entity', _id: string }, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string }, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string }> | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, emissionSubcategory?: string | null, order: number, refreshInterval: DataPointTypeRefreshIntervalEnum, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }>, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, calculatedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }> }> }, childs: Array<{ __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, comment?: string | null, status: DataPointRequestStatusEnum, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null, isHistoric?: boolean | null, isReopenRequestPending?: boolean | null, updatedAt: any, displayStatus: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectReason: string, childs: Array<{ __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, comment?: string | null, status: DataPointRequestStatusEnum, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null, isHistoric?: boolean | null, isReopenRequestPending?: boolean | null, updatedAt: any, displayStatus: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectReason: string, override?: { __typename?: 'EntityLocationOverride', _id: string, refreshInterval?: DataPointTypeRefreshIntervalEnum | null, valueUnit?: DataPointTypeValueUnitEnum | null, isSplit: boolean, datapointtype: { __typename?: 'DataPointType', _id: string, order: number }, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }> } | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, entity: { __typename?: 'Entity', _id: string }, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string }, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string }> | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, emissionSubcategory?: string | null, order: number, refreshInterval: DataPointTypeRefreshIntervalEnum, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }>, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, calculatedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }> }> } }>, override?: { __typename?: 'EntityLocationOverride', _id: string, refreshInterval?: DataPointTypeRefreshIntervalEnum | null, valueUnit?: DataPointTypeValueUnitEnum | null, isSplit: boolean, datapointtype: { __typename?: 'DataPointType', _id: string, order: number }, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }> } | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, entity: { __typename?: 'Entity', _id: string }, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string }, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string }> | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, emissionSubcategory?: string | null, order: number, refreshInterval: DataPointTypeRefreshIntervalEnum, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }>, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, calculatedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }> }> } }> }> };

export type ChildsExternalFragment = { __typename?: 'DataPointRequest', _id: string, childs: Array<{ __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, comment?: string | null, status: DataPointRequestStatusEnum, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null, isHistoric?: boolean | null, isReopenRequestPending?: boolean | null, updatedAt: any, displayStatus: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectReason: string, childs: Array<{ __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, comment?: string | null, status: DataPointRequestStatusEnum, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null, isHistoric?: boolean | null, isReopenRequestPending?: boolean | null, updatedAt: any, displayStatus: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectReason: string, override?: { __typename?: 'EntityLocationOverride', _id: string, refreshInterval?: DataPointTypeRefreshIntervalEnum | null, valueUnit?: DataPointTypeValueUnitEnum | null, isSplit: boolean, datapointtype: { __typename?: 'DataPointType', _id: string, order: number }, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }> } | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, entity: { __typename?: 'Entity', _id: string }, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string }, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string }> | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, emissionSubcategory?: string | null, order: number, refreshInterval: DataPointTypeRefreshIntervalEnum, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }>, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, calculatedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }> }> } }>, override?: { __typename?: 'EntityLocationOverride', _id: string, refreshInterval?: DataPointTypeRefreshIntervalEnum | null, valueUnit?: DataPointTypeValueUnitEnum | null, isSplit: boolean, datapointtype: { __typename?: 'DataPointType', _id: string, order: number }, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }> } | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, entity: { __typename?: 'Entity', _id: string }, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string }, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string }> | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, emissionSubcategory?: string | null, order: number, refreshInterval: DataPointTypeRefreshIntervalEnum, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }>, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, calculatedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }> }> } }> };

export type DprFieldsExternalFragment = { __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, comment?: string | null, status: DataPointRequestStatusEnum, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null, isHistoric?: boolean | null, isReopenRequestPending?: boolean | null, updatedAt: any, displayStatus: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectReason: string, override?: { __typename?: 'EntityLocationOverride', _id: string, refreshInterval?: DataPointTypeRefreshIntervalEnum | null, valueUnit?: DataPointTypeValueUnitEnum | null, isSplit: boolean, datapointtype: { __typename?: 'DataPointType', _id: string, order: number }, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }> } | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, entity: { __typename?: 'Entity', _id: string }, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string }, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string }> | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, emissionSubcategory?: string | null, order: number, refreshInterval: DataPointTypeRefreshIntervalEnum, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }>, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, calculatedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }> }> } };

export type PgExternalDataEntryLoginQueryVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
}>;


export type PgExternalDataEntryLoginQuery = { __typename?: 'Query', validateDelegation: boolean };

export type PgGoalsOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type PgGoalsOverviewQuery = { __typename?: 'Query', getEntityKPIs: Array<{ __typename?: 'EntityKPI', _id: string, startingDate: any, dueDate: any, startingValue?: number | null, completionPercent: number, comparisonValue: number, comparisonOperator: ComparisonOperatorEnum, comparisonValueType: ComparisonValueTypeEnum, status: EntityKpiStatusEnum, user: { __typename?: 'User', _id: string, firstName: string, lastName: string }, targets: Array<{ __typename?: 'Target', _id: string, name: string, number?: string | null, goal: { __typename?: 'Goal', _id: string, name: string, number: number, description: string, reportingFramework: ReportingFrameworkEnum } }>, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string, question: string, name: string, valueDataType: ValueDataTypeEnum, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, entity?: { __typename?: 'Entity', _id: string } | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null } } }>, getGoals: Array<{ __typename?: 'Goal', _id: string, name: string, number: number, description: string, reportingFramework: ReportingFrameworkEnum }>, getKPIDataPoints: Array<{ __typename?: 'GroupedDataPoint', value?: any | null, from?: any | null, to?: any | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, valueUnit?: DataPointTypeValueUnitEnum | null, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }> } }> };

export type OgConnectGoalStepQueryVariables = Exact<{ [key: string]: never; }>;


export type OgConnectGoalStepQuery = { __typename?: 'Query', getTargets: Array<{ __typename?: 'Target', _id: string, name: string, number?: string | null, isRecommended: boolean, suggestedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, friendlyName: string, question: string, name: string, valueDataType: ValueDataTypeEnum, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, entity?: { __typename?: 'Entity', _id: string } | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null } }>, goal: { __typename?: 'Goal', _id: string, name: string, description: string, reportingFramework: ReportingFrameworkEnum } }>, getEsgDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, friendlyName: string, question: string, name: string, valueDataType: ValueDataTypeEnum, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, entity?: { __typename?: 'Entity', _id: string } | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null } }> };

export type OgSetupKpiStepQueryVariables = Exact<{ [key: string]: never; }>;


export type OgSetupKpiStepQuery = { __typename?: 'Query', getOwnUser: { __typename?: 'User', _id: string, entity: { __typename?: 'Entity', _id: string, locations: Array<{ __typename?: 'EntityLocation', _id: string, name: string }> } }, getTeamUsers: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string }> };

export type OgKpiFormQueryVariables = Exact<{ [key: string]: never; }>;


export type OgKpiFormQuery = { __typename?: 'Query', getOwnUser: { __typename?: 'User', _id: string, entity: { __typename?: 'Entity', _id: string, locations: Array<{ __typename?: 'EntityLocation', _id: string, name: string }> } }, getTeamUsers: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string }> };

export type OgSelectTargetStepQueryVariables = Exact<{ [key: string]: never; }>;


export type OgSelectTargetStepQuery = { __typename?: 'Query', getTargets: Array<{ __typename?: 'Target', _id: string, name: string, number?: string | null, isRecommended: boolean, suggestedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, friendlyName: string, question: string, name: string, valueDataType: ValueDataTypeEnum, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, entity?: { __typename?: 'Entity', _id: string } | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null } }>, goal: { __typename?: 'Goal', _id: string, reportingFramework: ReportingFrameworkEnum } }> };

export type PgGoalsNewQueryVariables = Exact<{ [key: string]: never; }>;


export type PgGoalsNewQuery = { __typename?: 'Query', getOwnUser: { __typename?: 'User', _id: string, firstName: string, lastName: string } };

export type PgKpiQueryVariables = Exact<{
  goal: Scalars['String']['input'];
  target: Scalars['String']['input'];
  kpi: Scalars['String']['input'];
}>;


export type PgKpiQuery = { __typename?: 'Query', getGoal: { __typename?: 'Goal', _id: string, name: string, number: number, description: string }, getTarget: { __typename?: 'Target', _id: string, name: string, number?: string | null, isRecommended: boolean, goal: { __typename?: 'Goal', _id: string, number: number, name: string, reportingFramework: ReportingFrameworkEnum }, suggestedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, friendlyName: string, question: string, name: string, valueDataType: ValueDataTypeEnum, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, entity?: { __typename?: 'Entity', _id: string } | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null } }> }, getEntityKPI: { __typename?: 'EntityKPI', _id: string, comparisonOperator: ComparisonOperatorEnum, comparisonValue: number, comparisonValueType: ComparisonValueTypeEnum, startingDate: any, startingValue?: number | null, dueDate: any, description: string, status: EntityKpiStatusEnum, comments: Array<{ __typename?: 'Comment', _id: string, text: string, createdAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } }>, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string, name: string, question: string, valueDataType: ValueDataTypeEnum, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }>, suggestedTargets: Array<{ __typename?: 'Target', _id: string, name: string, number?: string | null, goal: { __typename?: 'Goal', _id: string, name: string, number: number, reportingFramework: ReportingFrameworkEnum } }> }, user: { __typename?: 'User', _id: string, firstName: string, lastName: string } } };

export type MlCategoryDprsQueryVariables = Exact<{
  statusFilter: DataPointRequestStatusEnum;
  categoryFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  sortedByUpdate: Scalars['Boolean']['input'];
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeChilds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MlCategoryDprsQuery = { __typename?: 'Query', getMyDataPointRequests: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, dueDate?: any | null, from?: any | null, isHistoric?: boolean | null, parent?: { __typename?: 'DataPointRequest', _id: string } | null, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string }, childs: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, dueDate?: any | null, from?: any | null, isHistoric?: boolean | null, childs: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, dueDate?: any | null, from?: any | null, isHistoric?: boolean | null, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string } }>, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string } }> }> };

export type ChildsHomepageFragment = { __typename?: 'DataPointRequest', _id: string, childs: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, dueDate?: any | null, from?: any | null, isHistoric?: boolean | null, childs: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, dueDate?: any | null, from?: any | null, isHistoric?: boolean | null, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string } }>, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string } }> };

export type DprFieldsHomepageFragment = { __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, dueDate?: any | null, from?: any | null, isHistoric?: boolean | null, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string } };

export type TmOverviewViewQueryVariables = Exact<{
  adminMode: Scalars['Boolean']['input'];
  isExternal: Scalars['Boolean']['input'];
  isAdminOrSuperAdmin: Scalars['Boolean']['input'];
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TmOverviewViewQuery = { __typename?: 'Query', getTeamUsers: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, jobTitle: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null }>, getEntityAssignments?: Array<{ __typename?: 'EntityAssignmentDto', category: string, subcategory: string, statuses?: Array<DataPointRequestStatusEnum> | null, assignee: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string }, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, getEmissions?: Array<{ __typename?: 'EmissionsDto', _id: string, scope: DataPointTypeEmissionTypeEnum, category: string, value: number }>, getReportingProgress?: Array<{ __typename?: 'DataPointRequestReportingProgressDto', draft: number, open: number, pending: number, accepted: number, rejected: number, overDue: number, total: number, closed: number, entity: { __typename?: 'Entity', _id: string, name?: string | null }, location: { __typename?: 'EntityLocation', _id: string, name: string, assignments: { __typename?: 'EntityAssignment', _id: string, categories: Array<{ __typename?: 'EntityCategoryAssignment', _id: string, category: string }> } } }>, getEntityReportingProgress?: Array<{ __typename?: 'DataPointRequestReportingProgressDto', draft: number, open: number, pending: number, accepted: number, rejected: number, overDue: number, total: number, closed: number, entity: { __typename?: 'Entity', _id: string, name?: string | null }, location: { __typename?: 'EntityLocation', _id: string, name: string, assignments: { __typename?: 'EntityAssignment', _id: string, categories: Array<{ __typename?: 'EntityCategoryAssignment', _id: string, category: string }> } } }>, getCategories: Array<{ __typename?: 'DataPointCategory', _id: string, slug: string }> };

export type TmOverviewEmissionsFragmentFragment = { __typename?: 'EmissionsDto', _id: string, scope: DataPointTypeEmissionTypeEnum, category: string, value: number };

export type TmOverviewReportingProgressFragmentFragment = { __typename?: 'DataPointRequestReportingProgressDto', draft: number, open: number, pending: number, accepted: number, rejected: number, overDue: number, total: number, closed: number, entity: { __typename?: 'Entity', _id: string, name?: string | null }, location: { __typename?: 'EntityLocation', _id: string, name: string, assignments: { __typename?: 'EntityAssignment', _id: string, categories: Array<{ __typename?: 'EntityCategoryAssignment', _id: string, category: string }> } } };

export type TeamUserDprsQueryVariables = Exact<{
  teamUserId: Scalars['String']['input'];
  statusFilter?: InputMaybe<DataPointRequestStatusEnum>;
  categoryFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  subcategoryFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  sortedByUpdate: Scalars['Boolean']['input'];
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeChilds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TeamUserDprsQuery = { __typename?: 'Query', getTeamUserDataPointRequests: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, dueDate?: any | null, from?: any | null, isHistoric?: boolean | null, parent?: { __typename?: 'DataPointRequest', _id: string } | null, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string }, childs: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, dueDate?: any | null, from?: any | null, isHistoric?: boolean | null, childs: Array<{ __typename?: 'DataPointRequest', _id: string, status: DataPointRequestStatusEnum, dueDate?: any | null, from?: any | null, isHistoric?: boolean | null, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string } }>, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string } }> }> };

export type TmLibrarySourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type TmLibrarySourcesQuery = { __typename?: 'Query', getRepositorySourceFiles: Array<{ __typename?: 'RepositoryFile', _id: string, name?: string | null, filename: string, filepath?: string | null, module?: string | null, category?: string | null, language?: UserLanguageEnum | null, date?: any | null }> };

export type TmLibrarySourcesFieldsFragment = { __typename?: 'RepositoryFile', name?: string | null, filename: string, filepath?: string | null, module?: string | null, category?: string | null, language?: UserLanguageEnum | null, date?: any | null };

export type TmLibraryUploadsQueryVariables = Exact<{ [key: string]: never; }>;


export type TmLibraryUploadsQuery = { __typename?: 'Query', getEntityRepositoryFiles: Array<{ __typename?: 'RepositoryFile', _id: string, filename: string, createdAt: any, relatedTopicSlugs?: Array<string> | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null }>, getCategories: Array<{ __typename?: 'DataPointCategory', _id: string, slug: string, subcategories: Array<{ __typename?: 'DataPointSubcategory', _id: string, slug: string }> }>, entityLocationSummaries: Array<{ __typename?: 'EntityLocationSummaryDto', _id: string, name: string }> };

export type TmLibraryUploadsFieldsFragment = { __typename?: 'RepositoryFile', _id: string, filename: string, createdAt: any, relatedTopicSlugs?: Array<string> | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null };

export type GenerateGuidanceAiSuggestionQueryVariables = Exact<{
  aiGuidanceSuggestionInput: AiGuidanceSuggestionInput;
}>;


export type GenerateGuidanceAiSuggestionQuery = { __typename?: 'Query', generateGuidanceAiSuggestion: { __typename?: 'AiGuidanceSuggestionDto', aiSuggestionHtml: string, sourceGuidanceKeys: Array<LibraryGuidanceDocumentEnum> } };

export type GuidanceDocumentDownloadQueryVariables = Exact<{
  file: LibraryGuidanceDocumentEnum;
  fileType: RepositoryFileTypeEnum;
}>;


export type GuidanceDocumentDownloadQuery = { __typename?: 'Query', downloadRepositoryGuidanceDocument: { __typename?: 'RepositoryDownloadDocumentDto', file: string, name: string, type: string } };

export type SourceDocumentDownloadQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
}>;


export type SourceDocumentDownloadQuery = { __typename?: 'Query', downloadRepositorySourceDocument: { __typename?: 'RepositoryDownloadDocumentDto', file: string, name: string, type: string } };

export type PgLoginCallbackQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type PgLoginCallbackQuery = { __typename?: 'Query', getLoginWorkspaces: { __typename?: 'GetLoginWorkspacesDto', isNewUser: boolean, workspaces: Array<string> } };

export type PgOnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type PgOnboardingQuery = { __typename?: 'Query', getOwnUser: { __typename?: 'User', _id: string, entity: { __typename?: 'Entity', _id: string, reportingFrameworks: Array<ReportingFrameworkEnum>, entitySettings: { __typename?: 'EntitySettings', _id: string, companyName: string, industry: string, locationOfHeadquarter: string, nameOfHeadquarter: string, numberOfEmployees: string } } } };

export type TmStepTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type TmStepTopicsQuery = { __typename?: 'Query', getCategoriesWithSubcategories: Array<{ __typename?: 'DataPointCategory', _id: string, name: string, slug: string, framework: ReportingFrameworkEnum, subcategories: Array<{ __typename?: 'DataPointSubcategory', _id: string, name: string, slug: string, orderPosition: number }> }>, getOwnUser: { __typename?: 'User', _id: string, role: UserRole, entity: { __typename?: 'Entity', _id: string, locations: Array<{ __typename?: 'EntityLocation', _id: string, isHeadquarters: boolean, assignments: { __typename?: 'EntityAssignment', _id: string, categories: Array<{ __typename?: 'EntityCategoryAssignment', _id: string, category: string, subcategories: Array<{ __typename?: 'EntitySubcategoryAssignment', _id: string, subcategory: string }> }> } }> }, assignments: { __typename?: 'UserAssignment', _id: string, subcategories: Array<{ __typename?: 'UserSubcategoryAssignment', subcategory: string }> } } };

export type OgQuestionnaireNameNewQueryVariables = Exact<{ [key: string]: never; }>;


export type OgQuestionnaireNameNewQuery = { __typename?: 'Query', getCustomCategoriesWithSubcategoriesForEntity: Array<{ __typename?: 'DataPointCategory', _id: string, name: string }> };

export type OgProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type OgProjectsQuery = { __typename?: 'Query', getNumberOfLocations: number, getDelegatedSubcategories: Array<{ __typename?: 'UserSubcategoryAssignment', subcategory: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string, createdAt?: any | null } }>, entityLocationSummaries: Array<{ __typename?: 'EntityLocationSummaryDto', _id: string, name: string, parent?: string | null, isHeadquarters: boolean, hasChildren: boolean, progress: number, hasParentInfo: boolean, depth: number, createdAt?: any | null, assignees: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, assignments: { __typename?: 'UserAssignment', _id: string, subcategories: Array<{ __typename?: 'UserSubcategoryAssignment', role: UserRole, subcategory: string }> }, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null }>, suspensions: { __typename?: 'EntityLocationSuspensions', datapointtypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, question: string, questionHelp: string, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, category?: string | null, subcategory?: string | null } }> }, assignments: { __typename?: 'EntityAssignment', _id: string, categories: Array<{ __typename?: 'EntityCategoryAssignment', _id: string, category: string, subcategories: Array<{ __typename?: 'EntitySubcategoryAssignment', _id: string, subcategory: string }> }> } }> };

export type OgProjectHeaderQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type OgProjectHeaderQuery = { __typename?: 'Query', entityLocationSummaries: Array<{ __typename?: 'EntityLocationSummaryDto', _id: string, name: string, parent?: string | null, isHeadquarters: boolean, hasChildren: boolean, assignments: { __typename?: 'EntityAssignment', _id: string, categories: Array<{ __typename?: 'EntityCategoryAssignment', _id: string, category: string, isEnabled?: boolean | null, subcategories: Array<{ __typename?: 'EntitySubcategoryAssignment', _id: string, subcategory: string }> }> } }>, getCategoriesWithSubcategories: Array<{ __typename?: 'DataPointCategory', _id: string, slug: string, name: string, organization?: { __typename?: 'Organization', _id: string } | null, location?: { __typename?: 'EntityLocation', _id: string } | null, entity?: { __typename?: 'Entity', _id: string } | null, subcategories: Array<{ __typename?: 'DataPointSubcategory', _id: string, slug: string, name: string }> }> };

export type OgCreateQuestionnaireQueryVariables = Exact<{ [key: string]: never; }>;


export type OgCreateQuestionnaireQuery = { __typename?: 'Query', getOrganizationQuestionnairesCount: number, getCustomCategoriesWithSubcategoriesForEntity: Array<{ __typename?: 'DataPointCategory', _id: string, name: string }> };

export type OgProjectSidebarQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type OgProjectSidebarQuery = { __typename?: 'Query', getCategoriesWithSubcategoriesForUser: Array<{ __typename?: 'DataPointCategory', _id: string, slug: string, framework: ReportingFrameworkEnum, createdAt: any, organization?: { __typename?: 'Organization', _id: string } | null, location?: { __typename?: 'EntityLocation', _id: string } | null, entity?: { __typename?: 'Entity', _id: string } | null, createdBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, subcategories: Array<{ __typename?: 'DataPointSubcategory', _id: string, slug: string, orderPosition: number, topic: string }> }>, getUserAssignedDataPointRequestsSubcategories: Array<{ __typename?: 'UserAssignedDataPointRequestSubcategoryDto', subcategory: string, location: { __typename?: 'EntityLocation', _id: string } }>, entityLocationSummaries: Array<{ __typename?: 'EntityLocationSummaryDto', _id: string, name: string }>, getDelegatedSubcategories: Array<{ __typename?: 'UserSubcategoryAssignment', subcategory: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string } }>, entityLocationSummary: { __typename?: 'EntityLocationSummaryDto', _id: string, name: string, isHeadquarters: boolean, progress: number, hasParentInfo: boolean, hasChildren: boolean, depth: number, assignees: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, assignments: { __typename?: 'UserAssignment', _id: string, subcategories: Array<{ __typename?: 'UserSubcategoryAssignment', role: UserRole, subcategory: string }> }, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null }>, suspensions: { __typename?: 'EntityLocationSuspensions', datapointtypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, question: string, questionHelp: string, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, subcategory?: string | null } }> }, assignments: { __typename?: 'EntityAssignment', _id: string, categories: Array<{ __typename?: 'EntityCategoryAssignment', _id: string, category: string, isEnabled?: boolean | null, subcategories: Array<{ __typename?: 'EntitySubcategoryAssignment', _id: string, subcategory: string }> }> } } };

export type PgCustomQuestionnaireQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PgCustomQuestionnaireQuery = { __typename?: 'Query', getCustomQuestionnaire: { __typename?: 'CustomQuestionnaire', _id: string, status: CustomQuestionnaireStatus, entity: { __typename?: 'Entity', _id: string, name?: string | null }, initiallyCreatedForEntityLocation: { __typename?: 'EntityLocation', _id: string, name: string }, category?: { __typename?: 'DataPointCategory', _id: string, slug: string } | null, subcategory?: { __typename?: 'DataPointSubcategory', _id: string, slug: string } | null, questions: Array<{ __typename?: 'CustomQuestionnaireQuestion', _id: string, type: ValueDataTypeEnum, title: string, question: string, questionHelp: string, refreshInterval: DataPointTypeRefreshIntervalEnum, frameworks: Array<ReportingFrameworkEnum>, frameworkGroup?: string | null, allowUploadProof: boolean, tags: Array<string>, extraOptions?:
        | { __typename: 'CustomQuestionnaireQuestionChoiceOptions', options: Array<string> }
        | { __typename: 'CustomQuestionnaireQuestionNumericOptions', valueUnit: DataPointTypeValueUnitEnum }
        | { __typename: 'CustomQuestionnaireQuestionNumericSplitOptions', unitGroup: DataPointTypeValueUnitEnum }
       | null }> } };

export type PgCustomQuestionnaireShareQueryVariables = Exact<{ [key: string]: never; }>;


export type PgCustomQuestionnaireShareQuery = { __typename?: 'Query', getTeamUsers: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, role: UserRole, assignments: { __typename?: 'UserAssignment', _id: string, subcategories: Array<{ __typename?: 'UserSubcategoryAssignment', subcategory: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string } }> } }> };

export type OgQuestionnaireNameQueryVariables = Exact<{ [key: string]: never; }>;


export type OgQuestionnaireNameQuery = { __typename?: 'Query', getCustomCategoriesWithSubcategoriesForEntity: Array<{ __typename?: 'DataPointCategory', _id: string, name: string }> };

export type OgCustomDataPointTypeFormQueryVariables = Exact<{
  dataPointTypeId?: InputMaybe<Scalars['String']['input']>;
  isUpdate: Scalars['Boolean']['input'];
}>;


export type OgCustomDataPointTypeFormQuery = { __typename?: 'Query', getEmissionsDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, emissionType?: DataPointTypeEmissionTypeEnum | null, emissionCategory?: string | null, emissionSubcategory?: string | null }>, getDataPointType?: { __typename?: 'DataPointType', _id: string, friendlyName: string, name: string, question: string, questionHelp: string, refreshInterval: DataPointTypeRefreshIntervalEnum, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, valueUnit?: DataPointTypeValueUnitEnum | null, emissionSubcategory?: string | null, allowUploadProof: boolean, isGlobal?: boolean | null, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, factor: number, year: number }>, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }> } };

export type MlDelegateQuestionModalQueryVariables = Exact<{ [key: string]: never; }>;


export type MlDelegateQuestionModalQuery = { __typename?: 'Query', getTeamUsers: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, email: string }> };

export type MlQuestionFormQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MlQuestionFormQuery = { __typename?: 'Query', getDataPointRequest?: { __typename?: 'DataPointRequest', _id: string, suggestionFormularResult?: { __typename?: 'DataPointRequestSuggestionFormularDto', result: number, dependencies: Array<{ __typename?: 'DataPointType', _id: string, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, order: number } }> } | null, dataPointType: { __typename?: 'DataPointType', _id: string, suggestionFormular: string } } | null };

export type MlQuestionInputQueryVariables = Exact<{
  dataPointTypeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;


export type MlQuestionInputQuery = { __typename?: 'Query', getDataPointsByTypeAndLocation: Array<{ __typename?: 'DataPoint', _id: string, value?: any | null, from?: any | null, to?: any | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, emissionFactor?: number | null, emissionFactorCountry?: string | null }> | null, dataPointRequest?: { __typename?: 'DataPointRequest', _id: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, summarizingMethod?: SummarizingMethodEnum | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null } } }> };

export type OgSidePanelQueryVariables = Exact<{
  entityId: Scalars['String']['input'];
  dataPointTypeId: Scalars['String']['input'];
}>;


export type OgSidePanelQuery = { __typename?: 'Query', getRecommendations: Array<{ __typename?: 'Recommendation', _id: string, text: string, tags: Array<RecommendationTagEnum>, createdAt: any, averageRating: number, utilizationCount: number }> };

export type TmDataEntryQueryVariables = Exact<{
  statusFilter?: InputMaybe<DataPointRequestStatusEnum>;
  categoryFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  subcategoryFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  includeChilds?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TmDataEntryQuery = { __typename?: 'Query', getEntityTags: Array<{ __typename?: 'Tag', _id: string, name: string, color: TagColorEnum, entity: { __typename?: 'Entity', _id: string } }>, getEntityCustomQuestionnaires: Array<{ __typename?: 'CustomQuestionnaire', _id: string, name: string }>, entityLocationSubcategorySummaries: Array<{ __typename?: 'EntityLocationSubcategorySummaryDto', subcategory: string, category: string, progress: number, overrides: Array<{ __typename?: 'EntityLocationOverride', _id: string, refreshInterval?: DataPointTypeRefreshIntervalEnum | null, valueUnit?: DataPointTypeValueUnitEnum | null, isSplit: boolean, customConversionFactor?: number | null, datapointtype: { __typename?: 'DataPointType', _id: string }, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, tags?: Array<{ __typename?: 'Tag', _id: string, name: string, color: TagColorEnum, entity: { __typename?: 'Entity', _id: string } }> | null }>, assignees: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null }> }>, getMyDataPointRequests: Array<{ __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, comment?: string | null, status: DataPointRequestStatusEnum, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null, isHistoric?: boolean | null, isReopenRequestPending?: boolean | null, displayStatus: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectReason: string, parent?: { __typename?: 'DataPointRequest', _id: string } | null, chatComments?: Array<{ __typename?: 'Comment', _id: string, text: string, updatedAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } }> | null, followers: Array<{ __typename?: 'User', _id: string }>, override?: { __typename?: 'EntityLocationOverride', _id: string, guidanceComments: Array<{ __typename?: 'Comment', _id: string, text: string, updatedAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } }> } | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, value?: any | null, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, emissionFactor?: number | null, emissionFactorCountry?: string | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, location: { __typename?: 'EntityLocation', _id: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string, conditionValue: string }, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string, shareToken: string, user: { __typename?: 'User', _id: string, email: string, firstName: string, lastName: string, isExternal?: boolean | null, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null }, reminder?: { __typename?: 'Reminder', _id: string, sendAt: any } | null }> | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, summarizingMethod?: SummarizingMethodEnum | null, refreshInterval: DataPointTypeRefreshIntervalEnum, emissionSubcategory?: string | null, entity?: { __typename?: 'Entity', _id: string } | null, location?: { __typename?: 'EntityLocation', _id: string } | null, organization?: { __typename?: 'Organization', _id: string } | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, required?: boolean | null, boundary: string, phasein: string }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }>, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, calculatedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }> }> }, childs: Array<{ __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, comment?: string | null, status: DataPointRequestStatusEnum, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null, isHistoric?: boolean | null, isReopenRequestPending?: boolean | null, displayStatus: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectReason: string, childs: Array<{ __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, comment?: string | null, status: DataPointRequestStatusEnum, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null, isHistoric?: boolean | null, isReopenRequestPending?: boolean | null, displayStatus: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectReason: string, chatComments?: Array<{ __typename?: 'Comment', _id: string, text: string, updatedAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } }> | null, followers: Array<{ __typename?: 'User', _id: string }>, override?: { __typename?: 'EntityLocationOverride', _id: string, guidanceComments: Array<{ __typename?: 'Comment', _id: string, text: string, updatedAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } }> } | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, value?: any | null, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, emissionFactor?: number | null, emissionFactorCountry?: string | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, location: { __typename?: 'EntityLocation', _id: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string, conditionValue: string }, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string, shareToken: string, user: { __typename?: 'User', _id: string, email: string, firstName: string, lastName: string, isExternal?: boolean | null, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null }, reminder?: { __typename?: 'Reminder', _id: string, sendAt: any } | null }> | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, summarizingMethod?: SummarizingMethodEnum | null, refreshInterval: DataPointTypeRefreshIntervalEnum, emissionSubcategory?: string | null, entity?: { __typename?: 'Entity', _id: string } | null, location?: { __typename?: 'EntityLocation', _id: string } | null, organization?: { __typename?: 'Organization', _id: string } | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, required?: boolean | null, boundary: string, phasein: string }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }>, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, calculatedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }> }> } }>, chatComments?: Array<{ __typename?: 'Comment', _id: string, text: string, updatedAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } }> | null, followers: Array<{ __typename?: 'User', _id: string }>, override?: { __typename?: 'EntityLocationOverride', _id: string, guidanceComments: Array<{ __typename?: 'Comment', _id: string, text: string, updatedAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } }> } | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, value?: any | null, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, emissionFactor?: number | null, emissionFactorCountry?: string | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, location: { __typename?: 'EntityLocation', _id: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string, conditionValue: string }, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string, shareToken: string, user: { __typename?: 'User', _id: string, email: string, firstName: string, lastName: string, isExternal?: boolean | null, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null }, reminder?: { __typename?: 'Reminder', _id: string, sendAt: any } | null }> | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, summarizingMethod?: SummarizingMethodEnum | null, refreshInterval: DataPointTypeRefreshIntervalEnum, emissionSubcategory?: string | null, entity?: { __typename?: 'Entity', _id: string } | null, location?: { __typename?: 'EntityLocation', _id: string } | null, organization?: { __typename?: 'Organization', _id: string } | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, required?: boolean | null, boundary: string, phasein: string }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }>, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, calculatedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }> }> } }> }> };

export type ChildsFragment = { __typename?: 'DataPointRequest', _id: string, childs: Array<{ __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, comment?: string | null, status: DataPointRequestStatusEnum, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null, isHistoric?: boolean | null, isReopenRequestPending?: boolean | null, displayStatus: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectReason: string, childs: Array<{ __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, comment?: string | null, status: DataPointRequestStatusEnum, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null, isHistoric?: boolean | null, isReopenRequestPending?: boolean | null, displayStatus: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectReason: string, chatComments?: Array<{ __typename?: 'Comment', _id: string, text: string, updatedAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } }> | null, followers: Array<{ __typename?: 'User', _id: string }>, override?: { __typename?: 'EntityLocationOverride', _id: string, guidanceComments: Array<{ __typename?: 'Comment', _id: string, text: string, updatedAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } }> } | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, value?: any | null, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, emissionFactor?: number | null, emissionFactorCountry?: string | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, location: { __typename?: 'EntityLocation', _id: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string, conditionValue: string }, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string, shareToken: string, user: { __typename?: 'User', _id: string, email: string, firstName: string, lastName: string, isExternal?: boolean | null, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null }, reminder?: { __typename?: 'Reminder', _id: string, sendAt: any } | null }> | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, summarizingMethod?: SummarizingMethodEnum | null, refreshInterval: DataPointTypeRefreshIntervalEnum, emissionSubcategory?: string | null, entity?: { __typename?: 'Entity', _id: string } | null, location?: { __typename?: 'EntityLocation', _id: string } | null, organization?: { __typename?: 'Organization', _id: string } | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, required?: boolean | null, boundary: string, phasein: string }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }>, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, calculatedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }> }> } }>, chatComments?: Array<{ __typename?: 'Comment', _id: string, text: string, updatedAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } }> | null, followers: Array<{ __typename?: 'User', _id: string }>, override?: { __typename?: 'EntityLocationOverride', _id: string, guidanceComments: Array<{ __typename?: 'Comment', _id: string, text: string, updatedAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } }> } | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, value?: any | null, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, emissionFactor?: number | null, emissionFactorCountry?: string | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, location: { __typename?: 'EntityLocation', _id: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string, conditionValue: string }, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string, shareToken: string, user: { __typename?: 'User', _id: string, email: string, firstName: string, lastName: string, isExternal?: boolean | null, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null }, reminder?: { __typename?: 'Reminder', _id: string, sendAt: any } | null }> | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, summarizingMethod?: SummarizingMethodEnum | null, refreshInterval: DataPointTypeRefreshIntervalEnum, emissionSubcategory?: string | null, entity?: { __typename?: 'Entity', _id: string } | null, location?: { __typename?: 'EntityLocation', _id: string } | null, organization?: { __typename?: 'Organization', _id: string } | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, required?: boolean | null, boundary: string, phasein: string }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }>, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, calculatedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }> }> } }> };

export type DprFieldsFragment = { __typename?: 'DataPointRequest', _id: string, dueDate?: any | null, from?: any | null, to?: any | null, value?: any | null, comment?: string | null, status: DataPointRequestStatusEnum, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null, isHistoric?: boolean | null, isReopenRequestPending?: boolean | null, displayStatus: DataPointRequestStatusEnum, rejectedAt?: any | null, rejectReason: string, chatComments?: Array<{ __typename?: 'Comment', _id: string, text: string, updatedAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } }> | null, followers: Array<{ __typename?: 'User', _id: string }>, override?: { __typename?: 'EntityLocationOverride', _id: string, guidanceComments: Array<{ __typename?: 'Comment', _id: string, text: string, updatedAt: any, user: { __typename?: 'User', _id: string, firstName: string, lastName: string, email: string, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null } }> } | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, value?: any | null, originalValue?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, emissionFactor?: number | null, emissionFactorCountry?: string | null }> | null, file?: { __typename?: 'RepositoryFile', _id: string, filename: string } | null, location: { __typename?: 'EntityLocation', _id: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string, conditionValue: string }, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string, shareToken: string, user: { __typename?: 'User', _id: string, email: string, firstName: string, lastName: string, isExternal?: boolean | null, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null }, reminder?: { __typename?: 'Reminder', _id: string, sendAt: any } | null }> | null, rejectedBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, allowUploadProof: boolean, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, summarizingMethod?: SummarizingMethodEnum | null, refreshInterval: DataPointTypeRefreshIntervalEnum, emissionSubcategory?: string | null, entity?: { __typename?: 'Entity', _id: string } | null, location?: { __typename?: 'EntityLocation', _id: string } | null, organization?: { __typename?: 'Organization', _id: string } | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, required?: boolean | null, boundary: string, phasein: string }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }>, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, calculatedDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }> }> } };

export type DataPointRequestXlsxDownloadQueryVariables = Exact<{
  dataPointRequestIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DataPointRequestXlsxDownloadQuery = { __typename?: 'Query', getDataPointRequestsEncodedReport: string };

export type PgRepositoryQueryVariables = Exact<{
  adminMode: Scalars['Boolean']['input'];
}>;


export type PgRepositoryQuery = { __typename?: 'Query', getEntityRepositoryFiles?: Array<{ __typename?: 'RepositoryFile', _id: string, filename: string, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, dataPointRequests: Array<{ __typename?: 'DataPointRequest', _id: string, from?: any | null, to?: any | null, status: DataPointRequestStatusEnum, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string, name: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string } }> }>, getEntityRepositoryFilesAdmin?: Array<{ __typename?: 'RepositoryFile', _id: string, filename: string, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, dataPointRequests: Array<{ __typename?: 'DataPointRequest', _id: string, from?: any | null, to?: any | null, status: DataPointRequestStatusEnum, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string, name: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string } }> }> };

export type FieldsFragment = { __typename?: 'RepositoryFile', _id: string, filename: string, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, dataPointRequests: Array<{ __typename?: 'DataPointRequest', _id: string, from?: any | null, to?: any | null, status: DataPointRequestStatusEnum, location: { __typename?: 'EntityLocation', _id: string, name: string }, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string, name: string }, dataPointTypeFlat: { __typename?: 'DataPointTypeFlat', category: string, subcategory: string } }> };

export type PgAuditTrailGetHistoryQueryVariables = Exact<{
  entityIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type PgAuditTrailGetHistoryQuery = { __typename?: 'Query', getHistoryAsXSLX: string };

export type TmSettingsMaterialityQueryVariables = Exact<{ [key: string]: never; }>;


export type TmSettingsMaterialityQuery = { __typename?: 'Query', getCategoriesWithSubcategories: Array<{ __typename?: 'DataPointCategory', _id: string, slug: string, framework: ReportingFrameworkEnum, organization?: { __typename?: 'Organization', _id: string } | null, entity?: { __typename?: 'Entity', _id: string } | null, location?: { __typename?: 'EntityLocation', _id: string } | null, subcategories: Array<{ __typename?: 'DataPointSubcategory', _id: string, slug: string, orderPosition: number, topic: string }> }>, getOwnUser: { __typename?: 'User', _id: string, role: UserRole, assignments: { __typename?: 'UserAssignment', _id: string, subcategories: Array<{ __typename?: 'UserSubcategoryAssignment', subcategory: string, location: { __typename?: 'EntityLocation', _id: string } }> }, entity: { __typename?: 'Entity', _id: string, reportingFrameworks: Array<ReportingFrameworkEnum>, locations: Array<{ __typename?: 'EntityLocation', _id: string, name: string, assignments: { __typename?: 'EntityAssignment', _id: string, categories: Array<{ __typename?: 'EntityCategoryAssignment', _id: string, category: string, subcategories: Array<{ __typename?: 'EntitySubcategoryAssignment', _id: string, subcategory: string }> }> } }> } }, getTeamUsers: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, role: UserRole, email: string, assignments: { __typename?: 'UserAssignment', _id: string, categories: Array<{ __typename?: 'UserCategoryAssignment', category: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, subcategories: Array<{ __typename?: 'UserSubcategoryAssignment', subcategory: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, datapointtypes: Array<{ __typename?: 'UserDataPointTypeAssignment', role: UserRole, dataPointType: { __typename?: 'DataPointType', _id: string, name: string }, location: { __typename?: 'EntityLocation', _id: string, name: string } }> } }> };

export type TmSettingsProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type TmSettingsProfileQuery = { __typename?: 'Query', entityLocationSummaries: Array<{ __typename?: 'EntityLocationSummaryDto', _id: string, name: string, isHeadquarters: boolean }> };

export type TmSettingsTeamQueryVariables = Exact<{
  allTeamsUsers: Scalars['Boolean']['input'];
}>;


export type TmSettingsTeamQuery = { __typename?: 'Query', getTeamUsers: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, jobTitle: string, jobDepartment: string, email: string, role: UserRole, language: UserLanguageEnum, onboardingStatus: OnboardingStatusEnum, getStartedStepsCompleted: Array<GetStartedStatusEnum>, entities: Array<{ __typename?: 'Entity', _id: string, name?: string | null }>, invitedBy?: { __typename?: 'User', _id: string } | null, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null, assignments: { __typename?: 'UserAssignment', _id: string, doubleMateriality: boolean, categories: Array<{ __typename?: 'UserCategoryAssignment', category: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, subcategories: Array<{ __typename?: 'UserSubcategoryAssignment', subcategory: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, datapointtypes: Array<{ __typename?: 'UserDataPointTypeAssignment', role: UserRole, dataPointType: { __typename?: 'DataPointType', _id: string, name: string }, location: { __typename?: 'EntityLocation', _id: string, name: string } }> } }>, getAllTeamsUsers?: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, jobTitle: string, jobDepartment: string, email: string, role: UserRole, language: UserLanguageEnum, onboardingStatus: OnboardingStatusEnum, getStartedStepsCompleted: Array<GetStartedStatusEnum>, entities: Array<{ __typename?: 'Entity', _id: string, name?: string | null }>, invitedBy?: { __typename?: 'User', _id: string } | null, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null, assignments: { __typename?: 'UserAssignment', _id: string, doubleMateriality: boolean, categories: Array<{ __typename?: 'UserCategoryAssignment', category: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, subcategories: Array<{ __typename?: 'UserSubcategoryAssignment', subcategory: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, datapointtypes: Array<{ __typename?: 'UserDataPointTypeAssignment', role: UserRole, dataPointType: { __typename?: 'DataPointType', _id: string, name: string }, location: { __typename?: 'EntityLocation', _id: string, name: string } }> } }> };

export type UserFieldsFragment = { __typename?: 'User', _id: string, firstName: string, lastName: string, jobTitle: string, jobDepartment: string, email: string, role: UserRole, language: UserLanguageEnum, onboardingStatus: OnboardingStatusEnum, getStartedStepsCompleted: Array<GetStartedStatusEnum>, entities: Array<{ __typename?: 'Entity', _id: string, name?: string | null }>, invitedBy?: { __typename?: 'User', _id: string } | null, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null, assignments: { __typename?: 'UserAssignment', _id: string, doubleMateriality: boolean, categories: Array<{ __typename?: 'UserCategoryAssignment', category: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, subcategories: Array<{ __typename?: 'UserSubcategoryAssignment', subcategory: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, datapointtypes: Array<{ __typename?: 'UserDataPointTypeAssignment', role: UserRole, dataPointType: { __typename?: 'DataPointType', _id: string, name: string }, location: { __typename?: 'EntityLocation', _id: string, name: string } }> } };

export type CsvReportQueryVariables = Exact<{
  dataPointTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CsvReportQuery = { __typename?: 'Query', getDataPointsEncodedReport: string };

export type DocxReportQueryVariables = Exact<{
  dataPointTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DocxReportQuery = { __typename?: 'Query', getDataPointsEncodedReport: string };

export type PdfReportQueryVariables = Exact<{
  isAdmin: Scalars['Boolean']['input'];
  reportType: PdfReportTypeEnum;
  dataPointTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  workspaceIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  scope2EmissionTypeExcluded?: InputMaybe<DataPointTypeEmissionTypeEnum>;
  reportingFrameworks?: InputMaybe<Array<ReportingFrameworkEnum> | ReportingFrameworkEnum>;
}>;


export type PdfReportQuery = { __typename?: 'Query', getDataPointsEncodedPDFReport?: string, getDataPointsEncodedAdminPDFReport?: string };

export type PgCarbonFootprintViewQueryVariables = Exact<{
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  workspaceIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  adminMode: Scalars['Boolean']['input'];
}>;


export type PgCarbonFootprintViewQuery = { __typename?: 'Query', entityLocationSummaries: Array<{ __typename?: 'EntityLocationSummaryDto', _id: string, name: string, parent?: string | null, hasParentInfo: boolean }>, getCurrentUserEntities?: Array<{ __typename?: 'Entity', _id: string, name?: string | null }>, getCarbonFootprintDataPointsByProjectAndDateRange?: Array<{ __typename?: 'DataPoint', _id: string, value?: any | null, valueUnit?: DataPointTypeValueUnitEnum | null, displayValue?: any | null, displayValueUnit?: DataPointTypeValueUnitEnum | null, type: DataPoint_Type, from?: any | null, to?: any | null, comment?: string | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, value?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null }> | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, dataPointRequest?: { __typename?: 'DataPointRequest', _id: string, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string }> | null } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, refreshInterval: DataPointTypeRefreshIntervalEnum, summarizingMethod?: SummarizingMethodEnum | null, emissionType?: DataPointTypeEmissionTypeEnum | null, emissionCategory?: string | null, emissionSubcategory?: string | null, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, framework: ReportingFrameworkEnum, groups: Array<string>, order: number }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, order: number }> } }>, getCarbonFootprintDataPointsByProjectAndDateRangeAdmin?: Array<{ __typename?: 'GroupedDataPoint', value?: any | null, valueUnit?: DataPointTypeValueUnitEnum | null, displayValue?: any | null, displayValueUnit?: DataPointTypeValueUnitEnum | null, from?: any | null, to?: any | null, comment?: string | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, value?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null }> | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, dataPointRequest?: { __typename?: 'DataPointRequest', _id: string, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string }> | null } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, refreshInterval: DataPointTypeRefreshIntervalEnum, summarizingMethod?: SummarizingMethodEnum | null, emissionType?: DataPointTypeEmissionTypeEnum | null, emissionCategory?: string | null, emissionSubcategory?: string | null, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, framework: ReportingFrameworkEnum, groups: Array<string>, order: number }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, order: number }> } }> };

export type AiSummaryQueryQueryVariables = Exact<{
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
  dataPointType: Scalars['String']['input'];
  locations: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AiSummaryQueryQuery = { __typename?: 'Query', generateDataPointSummary: string };

export type PgStandardViewQueryVariables = Exact<{
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  workspaceIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  adminMode: Scalars['Boolean']['input'];
}>;


export type PgStandardViewQuery = { __typename?: 'Query', entityLocationSummaries: Array<{ __typename?: 'EntityLocationSummaryDto', _id: string, name: string, parent?: string | null, hasParentInfo: boolean }>, getCurrentUserEntities?: Array<{ __typename?: 'Entity', _id: string, name?: string | null }>, getCategoriesWithSubcategoriesForUser: Array<{ __typename?: 'DataPointCategory', _id: string, slug: string, subcategories: Array<{ __typename?: 'DataPointSubcategory', _id: string, slug: string, orderPosition: number }> }>, getStandardDataPointsByProjectAndDateRange?: Array<{ __typename?: 'DataPoint', _id: string, value?: any | null, valueUnit?: DataPointTypeValueUnitEnum | null, displayValue?: any | null, displayValueUnit?: DataPointTypeValueUnitEnum | null, from?: any | null, to?: any | null, comment?: string | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, value?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null }> | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, dataPointRequest?: { __typename?: 'DataPointRequest', _id: string, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string }> | null } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, refreshInterval: DataPointTypeRefreshIntervalEnum, summarizingMethod?: SummarizingMethodEnum | null, emissionType?: DataPointTypeEmissionTypeEnum | null, emissionCategory?: string | null, emissionSubcategory?: string | null, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, framework: ReportingFrameworkEnum, groups: Array<string>, order: number }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, order: number }> } }>, getStandardDataPointsByProjectAndDateRangeAdmin?: Array<{ __typename?: 'GroupedDataPoint', value?: any | null, valueUnit?: DataPointTypeValueUnitEnum | null, displayValue?: any | null, displayValueUnit?: DataPointTypeValueUnitEnum | null, from?: any | null, to?: any | null, comment?: string | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, value?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null }> | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, dataPointRequest?: { __typename?: 'DataPointRequest', _id: string, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string }> | null } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, refreshInterval: DataPointTypeRefreshIntervalEnum, summarizingMethod?: SummarizingMethodEnum | null, emissionType?: DataPointTypeEmissionTypeEnum | null, emissionCategory?: string | null, emissionSubcategory?: string | null, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, framework: ReportingFrameworkEnum, groups: Array<string>, order: number }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, order: number }> } }>, entitySummaries?: Array<{ __typename?: 'EntityLocationSummaryDto', _id: string, name: string, entityId?: string | null, entityName?: string | null, parent?: string | null, hasParentInfo: boolean }>, getSummaryDataPointsByProjectAndDateRangeAdmin?: Array<{ __typename?: 'GroupedDataPoint', value?: any | null, valueUnit?: DataPointTypeValueUnitEnum | null, displayValue?: any | null, displayValueUnit?: DataPointTypeValueUnitEnum | null, type: DataPoint_Type, from?: any | null, to?: any | null, comment?: string | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null }> | null, dataPointRequest?: { __typename?: 'DataPointRequest', _id: string, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string }> | null } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, refreshInterval: DataPointTypeRefreshIntervalEnum, summarizingMethod?: SummarizingMethodEnum | null, emissionType?: DataPointTypeEmissionTypeEnum | null, emissionCategory?: string | null, emissionSubcategory?: string | null, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, framework: ReportingFrameworkEnum, groups: Array<string>, order: number }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, order: number }> } }>, getQualitativeDataPointsByProjectAndDateRangeAdmin?: Array<{ __typename?: 'GroupedDataPoint', value?: any | null, valueUnit?: DataPointTypeValueUnitEnum | null, displayValue?: any | null, displayValueUnit?: DataPointTypeValueUnitEnum | null, type: DataPoint_Type, from?: any | null, to?: any | null, comment?: string | null, valueSource?: Array<{ __typename?: 'DataPointValueSource', name: string, value?: any | null, originalValueUnit?: DataPointTypeValueUnitEnum | null, originalValue?: any | null }> | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, dataPointRequest?: { __typename?: 'DataPointRequest', _id: string, delegations?: Array<{ __typename?: 'DataPointRequestDelegation', _id: string }> | null } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, valueDataTypeOptions?: any | null, refreshInterval: DataPointTypeRefreshIntervalEnum, summarizingMethod?: SummarizingMethodEnum | null, emissionType?: DataPointTypeEmissionTypeEnum | null, emissionCategory?: string | null, emissionSubcategory?: string | null, emissionFactors: Array<{ __typename?: 'DataPointTypeEmissionFactor', _id: string, year: number, factor: number }>, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, framework: ReportingFrameworkEnum, groups: Array<string>, order: number }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, order: number }> } }> };

export type PgStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type PgStatisticsQuery = { __typename?: 'Query', entityLocationSummaries: Array<{ __typename?: 'EntityLocationSummaryDto', _id: string, name: string }>, getTeamUsers: Array<{ __typename?: 'User', _id: string, firstName: string, lastName: string, role: UserRole, email: string, assignments: { __typename?: 'UserAssignment', _id: string, categories: Array<{ __typename?: 'UserCategoryAssignment', category: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, subcategories: Array<{ __typename?: 'UserSubcategoryAssignment', subcategory: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, datapointtypes: Array<{ __typename?: 'UserDataPointTypeAssignment', role: UserRole, dataPointType: { __typename?: 'DataPointType', _id: string, name: string }, location: { __typename?: 'EntityLocation', _id: string, name: string } }> } }>, getOwnUser: { __typename?: 'User', _id: string, entity: { __typename?: 'Entity', _id: string, locations: Array<{ __typename?: 'EntityLocation', _id: string, name: string }> } } };

export type TmChartSelectionQueryVariables = Exact<{
  dataPointTypeNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  allEntities?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin: Scalars['Boolean']['input'];
}>;


export type TmChartSelectionQuery = { __typename?: 'Query', getEsgDataPointsLength: number, getAvailableDataPointsGroupedByType: Array<{ __typename?: 'DataPoint', _id: string, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, summarizingMethod?: SummarizingMethodEnum | null, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, category?: string | null, subcategory?: string | null }> } }>, getDataPointsByType?: Array<{ __typename?: 'DataPoint', _id: string, value?: any | null, from?: any | null, to?: any | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, friendlyName: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, summarizingMethod?: SummarizingMethodEnum | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, framework: ReportingFrameworkEnum, groups: Array<string> }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }> } }>, getAdminDataPointsByType?: Array<{ __typename?: 'DataPoint', _id: string, value?: any | null, from?: any | null, to?: any | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, summarizingMethod?: SummarizingMethodEnum | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, framework: ReportingFrameworkEnum, groups: Array<string> }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }> } }>, getCurrentUserEntities: Array<{ __typename?: 'Entity', _id: string, name?: string | null, entitySettings: { __typename?: 'EntitySettings', _id: string, companyName: string, dashboardPinnedDataPointTypes: Array<{ __typename?: 'AdminSettingsPinnedDataPointType', _id: string, dataPointType: { __typename?: 'DataPointType', friendlyName: string, name: string, _id: string } }> }, kpis: Array<{ __typename?: 'EntityKPI', _id: string, startingDate: any, comparisonValue: number, comparisonValueType: ComparisonValueTypeEnum, comparisonOperator: ComparisonOperatorEnum, dueDate: any, dataPointType: { __typename?: 'DataPointType', _id: string } }>, locations: Array<{ __typename?: 'EntityLocation', _id: string, name: string }> }>, getOwnUser: { __typename?: 'User', _id: string, pinnedDataPointTypes: Array<{ __typename?: 'PinnedDataPointType', _id: string, entity: { __typename?: 'Entity', _id: string }, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string } }>, entity: { __typename?: 'Entity', _id: string, kpis: Array<{ __typename?: 'EntityKPI', _id: string, startingDate: any, comparisonValue: number, comparisonValueType: ComparisonValueTypeEnum, comparisonOperator: ComparisonOperatorEnum, dueDate: any, dataPointType: { __typename?: 'DataPointType', _id: string } }> } } };

export type DetailedReportQueryVariables = Exact<{
  dataPointTypeNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type DetailedReportQuery = { __typename?: 'Query', getDataPointsEncodedReport: string };

export type TmChartViewExportPdfQueryVariables = Exact<{
  charts: ChartsInput;
}>;


export type TmChartViewExportPdfQuery = { __typename?: 'Query', getGraphsPDF: string };

export type TmChartViewQueryVariables = Exact<{
  adminMode: Scalars['Boolean']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type TmChartViewQuery = { __typename?: 'Query', isAnyDataPointApprovedAndNumeric: boolean, getOwnUser: { __typename?: 'User', _id: string, pinnedDataPointTypes: Array<{ __typename?: 'PinnedDataPointType', _id: string, entity: { __typename?: 'Entity', _id: string }, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, defaultChartType: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, summarizingMethod?: SummarizingMethodEnum | null, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string> }> } }>, entity: { __typename?: 'Entity', _id: string, kpis: Array<{ __typename?: 'EntityKPI', _id: string, startingDate: any, comparisonValue: number, comparisonValueType: ComparisonValueTypeEnum, comparisonOperator: ComparisonOperatorEnum, dueDate: any, dataPointType: { __typename?: 'DataPointType', _id: string } }>, locations: Array<{ __typename?: 'EntityLocation', _id: string, name: string }> } }, getCurrentUserEntities?: Array<{ __typename?: 'Entity', _id: string, name?: string | null }>, getPinnedDataPoints?: Array<{ __typename?: 'DataPoint', _id: string, value?: any | null, displayValue?: any | null, displayValueUnit?: DataPointTypeValueUnitEnum | null, from?: any | null, to?: any | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, summarizingMethod?: SummarizingMethodEnum | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, framework: ReportingFrameworkEnum, groups: Array<string> }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, category?: string | null, subcategory?: string | null }> } }>, getPinnedDataPointsAdmin?: Array<{ __typename?: 'GroupedDataPoint', value?: any | null, displayValue?: any | null, displayValueUnit?: DataPointTypeValueUnitEnum | null, from?: any | null, to?: any | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, valueUnit?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, summarizingMethod?: SummarizingMethodEnum | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null, framework: ReportingFrameworkEnum, groups: Array<string> }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, category?: string | null, subcategory?: string | null }> } }> };

export type CategoriesWithSubcategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesWithSubcategoriesQuery = { __typename?: 'Query', getCategoriesWithSubcategories: Array<{ __typename?: 'DataPointCategory', _id: string, slug: string, createdAt: any, organization?: { __typename?: 'Organization', _id: string } | null, entity?: { __typename?: 'Entity', _id: string } | null, location?: { __typename?: 'EntityLocation', _id: string } | null, createdBy?: { __typename?: 'User', _id: string, firstName: string, lastName: string } | null, subcategories: Array<{ __typename?: 'DataPointSubcategory', _id: string, slug: string, orderPosition: number }> }> };

export type OgCustomInsightFormQueryVariables = Exact<{
  previewInsightInput: PreviewInsightInput;
}>;


export type OgCustomInsightFormQuery = { __typename?: 'Query', previewInsight: Array<{ __typename?: 'DataPoint', _id: string, value?: any | null, from?: any | null, to?: any | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, formular: string, targetAction?: DataPointTypeTargetActionEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, refreshInterval: DataPointTypeRefreshIntervalEnum, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }>, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, subcategory?: string | null }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, subcategory?: string | null }> } }> };

export type OgCustomInsightFormDataPointTypesAQueryVariables = Exact<{
  withExistingDataPoints?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OgCustomInsightFormDataPointTypesAQuery = { __typename?: 'Query', getNumericDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, refreshInterval: DataPointTypeRefreshIntervalEnum, question: string, valueUnit?: DataPointTypeValueUnitEnum | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, subcategory?: string | null, category?: string | null }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, subcategory?: string | null, category?: string | null }> }>, getAvailableSubcategories: Array<{ __typename?: 'DataPointTypeSubcategoryDto', _id: any, category: string, subcategory: string }> };

export type OgCustomInsightFormDataPointTypesBQueryVariables = Exact<{
  withExistingDataPoints?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OgCustomInsightFormDataPointTypesBQuery = { __typename?: 'Query', getDenominatorNumericDataPointTypes: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, refreshInterval: DataPointTypeRefreshIntervalEnum, question: string, valueUnit?: DataPointTypeValueUnitEnum | null, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, category?: string | null, subcategory?: string | null }> }> };

export type TmInsightsViewQueryVariables = Exact<{
  adminMode: Scalars['Boolean']['input'];
}>;


export type TmInsightsViewQuery = { __typename?: 'Query', getOwnUser: { __typename?: 'User', _id: string, role: UserRole, email: string }, entityLocationSummaries?: Array<{ __typename?: 'EntityLocationSummaryDto', _id: string, name: string }>, getCurrentUserEntities?: Array<{ __typename?: 'Entity', _id: string, name?: string | null }>, getInsightDataPointTypes?: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, refreshInterval: DataPointTypeRefreshIntervalEnum, targetAction?: DataPointTypeTargetActionEnum | null, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }>, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, subcategory?: string | null }> }>, getInsightDataPoints?: Array<{ __typename?: 'DataPoint', _id: string, value?: any | null, from?: any | null, to?: any | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, formular: string, targetAction?: DataPointTypeTargetActionEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, refreshInterval: DataPointTypeRefreshIntervalEnum, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }>, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, subcategory?: string | null }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, subcategory?: string | null }> } }>, getInsightDataPointTypesAdmin?: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, refreshInterval: DataPointTypeRefreshIntervalEnum, targetAction?: DataPointTypeTargetActionEnum | null, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }>, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, subcategory?: string | null }> }>, getInsightDataPointsAdmin?: Array<{ __typename?: 'GroupedDataPoint', value?: any | null, from?: any | null, to?: any | null, location?: { __typename?: 'EntityLocation', _id: string, name: string } | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null, dataPointType: { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, question: string, questionHelp: string, valueUnit?: DataPointTypeValueUnitEnum | null, formular: string, targetAction?: DataPointTypeTargetActionEnum | null, valueUnitDivisor?: DataPointTypeValueUnitEnum | null, valueDataType: ValueDataTypeEnum, refreshInterval: DataPointTypeRefreshIntervalEnum, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }>, activeReportingFramework: { __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, subcategory?: string | null }, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, subcategory?: string | null }> } }> };

export type InsightDataPointTypesFragment = { __typename?: 'DataPointType', _id: string, name: string, friendlyName: string, formular: string, refreshInterval: DataPointTypeRefreshIntervalEnum, targetAction?: DataPointTypeTargetActionEnum | null, formularDependencies: Array<{ __typename?: 'DataPointType', _id: string, name: string, friendlyName: string }>, reportingFrameworks: Array<{ __typename?: 'DataPointTypeReportingFramework', _id: string, framework: ReportingFrameworkEnum, groups: Array<string>, subcategory?: string | null }> };

export type AiDocumentsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AiDocumentsQueryQuery = { __typename?: 'Query', getEntityRepositoryFiles: Array<{ __typename?: 'RepositoryFile', _id: string, filename: string, createdAt: any, relatedTopicSlugs?: Array<string> | null, relatedProjects?: Array<{ __typename?: 'EntityLocation', _id: string, name: string }> | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null }>, getCategories: Array<{ __typename?: 'DataPointCategory', _id: string, slug: string, subcategories: Array<{ __typename?: 'DataPointSubcategory', _id: string, slug: string }> }>, entityLocationSummaries: Array<{ __typename?: 'EntityLocationSummaryDto', _id: string, name: string }> };

export type AiDocumentsRepositoryFilesQueryFragment = { __typename?: 'RepositoryFile', _id: string, filename: string, createdAt: any, relatedTopicSlugs?: Array<string> | null, relatedProjects?: Array<{ __typename?: 'EntityLocation', _id: string, name: string }> | null, entity?: { __typename?: 'Entity', _id: string, name?: string | null } | null };

export type DataSheetsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type DataSheetsQueryQuery = { __typename?: 'Query', entityLocationSummaries: Array<{ __typename?: 'EntityLocationSummaryDto', _id: string, name: string }>, getCategories: Array<{ __typename?: 'DataPointCategory', _id: string, slug: string, subcategories: Array<{ __typename?: 'DataPointSubcategory', _id: string, slug: string }> }> };

export type UseCategoryTranslateQueryVariables = Exact<{
  entityId: Scalars['String']['input'];
}>;


export type UseCategoryTranslateQuery = { __typename?: 'Query', getAllCategoriesForEntity: Array<{ __typename?: 'DataPointCategory', _id: string, name: string, slug: string, subcategories: Array<{ __typename?: 'DataPointSubcategory', _id: string, slug: string, name: string }> }> };

export type UseCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type UseCurrentUserQuery = { __typename?: 'Query', getTotalsForAssigments: { __typename?: 'EntityAssignmentTotalsDto', assignedTopicsTotal: number, assigmentsTotal: number }, getAuthenticatedUser: { __typename?: 'User', _id: string, email: string }, getOwnUser: { __typename?: 'User', _id: string, firstName: string, lastName: string, jobTitle: string, jobDepartment: string, email: string, phone: string, role: UserRole, language: UserLanguageEnum, isExternal?: boolean | null, onboardingStatus: OnboardingStatusEnum, getStartedStepsCompleted: Array<GetStartedStatusEnum>, picture?: { __typename?: 'RepositoryFile', _id: string, downloadUrl: string } | null, assignments: { __typename?: 'UserAssignment', _id: string, doubleMateriality: boolean, categories: Array<{ __typename?: 'UserCategoryAssignment', category: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, subcategories: Array<{ __typename?: 'UserSubcategoryAssignment', subcategory: string, role: UserRole, location: { __typename?: 'EntityLocation', _id: string, name: string } }>, datapointtypes: Array<{ __typename?: 'UserDataPointTypeAssignment', role: UserRole, dataPointType: { __typename?: 'DataPointType', _id: string, name: string }, location: { __typename?: 'EntityLocation', _id: string, name: string } }> }, entities: Array<{ __typename?: 'Entity', _id: string, name?: string | null, reportingFrameworks: Array<ReportingFrameworkEnum>, entitySettings: { __typename?: 'EntitySettings', _id: string, requiredProofCategories: Array<string>, notificationSettings: { __typename?: 'EntityNotificationSettings', _id: string, recommendationsVisibility: boolean } } }>, entity: { __typename?: 'Entity', _id: string, name?: string | null, reportingFrameworks: Array<ReportingFrameworkEnum>, organization?: { __typename?: 'Organization', _id: string, name: string } | null, entitySettings: { __typename?: 'EntitySettings', _id: string, companyName: string, requiredProofCategories: Array<string>, notificationSettings: { __typename?: 'EntityNotificationSettings', _id: string, recommendationsVisibility: boolean } }, locations: Array<{ __typename?: 'EntityLocation', _id: string, name: string, isHeadquarters: boolean, areCategoriesAppliedOnAllProjects?: boolean | null, areCustomCategoriesAppliedOnAllProjects?: boolean | null, assignments: { __typename?: 'EntityAssignment', _id: string, categories: Array<{ __typename?: 'EntityCategoryAssignment', _id: string, category: string, subcategories: Array<{ __typename?: 'EntitySubcategoryAssignment', _id: string, subcategory: string }> }> } }> } } };

export type UseEmissionFactorsCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type UseEmissionFactorsCsvQuery = { __typename?: 'Query', getEmissionFactorsCsv: string };

export type UseReportingPeriodQueryVariables = Exact<{
  isExternal: Scalars['Boolean']['input'];
}>;


export type UseReportingPeriodQuery = { __typename?: 'Query', getOwnUser?: { __typename?: 'User', _id: string, entity: { __typename?: 'Entity', _id: string, entitySettings: { __typename?: 'EntitySettings', _id: string, activeReportingPeriod: { __typename?: 'EntityReportingPeriod', _id: string, from: any, to: any } } } } };

export type GetRestrictionsForOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRestrictionsForOrganizationQuery = { __typename?: 'Query', restrictions: { __typename?: 'Restriction', _id: string, numberOfWorkspaces: number, numberOfProjects: number, numberOfTopics: number, numberOfAdmins: number, numberOfManagers: number, numberOfUsers: number, numberOfExportsPerYearPerType: number, numberOfQuestionnaires: number, supportedTopics: Array<string>, supportedStandards: Array<ReportingFrameworkEnum>, restrictedFeatures: Array<RestrictionsFeaturesEnum> } };
